/*! For license information please see main.js.LICENSE.txt */
!function() {
  var t = {
      9069: function(t) {
          t.exports = function() {
              function t(t, e) {
                  for (var n = 0; n < e.length; n++) {
                      var r = e[n];
                      r.enumerable = r.enumerable || !1,
                      r.configurable = !0,
                      "value"in r && (r.writable = !0),
                      Object.defineProperty(t, r.key, r)
                  }
              }
              function e(e, n, r) {
                  return n && t(e.prototype, n),
                  r && t(e, r),
                  e
              }
              function n() {
                  return (n = Object.assign || function(t) {
                      for (var e = 1; e < arguments.length; e++) {
                          var n = arguments[e];
                          for (var r in n)
                              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r])
                      }
                      return t
                  }
                  ).apply(this, arguments)
              }
              function r(t, e) {
                  t.prototype = Object.create(e.prototype),
                  t.prototype.constructor = t,
                  t.__proto__ = e
              }
              function i(t) {
                  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                      return t.__proto__ || Object.getPrototypeOf(t)
                  }
                  )(t)
              }
              function o(t, e) {
                  return (o = Object.setPrototypeOf || function(t, e) {
                      return t.__proto__ = e,
                      t
                  }
                  )(t, e)
              }
              function s(t, e, n) {
                  return (s = function() {
                      if ("undefined" == typeof Reflect || !Reflect.construct)
                          return !1;
                      if (Reflect.construct.sham)
                          return !1;
                      if ("function" == typeof Proxy)
                          return !0;
                      try {
                          return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
                          ))),
                          !0
                      } catch (t) {
                          return !1
                      }
                  }() ? Reflect.construct : function(t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var i = new (Function.bind.apply(t, r));
                      return n && o(i, n.prototype),
                      i
                  }
                  ).apply(null, arguments)
              }
              function a(t) {
                  var e = "function" == typeof Map ? new Map : void 0;
                  return (a = function(t) {
                      if (null === t || -1 === Function.toString.call(t).indexOf("[native code]"))
                          return t;
                      if ("function" != typeof t)
                          throw new TypeError("Super expression must either be null or a function");
                      if (void 0 !== e) {
                          if (e.has(t))
                              return e.get(t);
                          e.set(t, n)
                      }
                      function n() {
                          return s(t, arguments, i(this).constructor)
                      }
                      return n.prototype = Object.create(t.prototype, {
                          constructor: {
                              value: n,
                              enumerable: !1,
                              writable: !0,
                              configurable: !0
                          }
                      }),
                      o(n, t)
                  }
                  )(t)
              }
              function c(t, e) {
                  try {
                      var n = t()
                  } catch (t) {
                      return e(t)
                  }
                  return n && n.then ? n.then(void 0, e) : n
              }
              "undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))),
              "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));
              var l;
              !function(t) {
                  t[t.off = 0] = "off",
                  t[t.error = 1] = "error",
                  t[t.warning = 2] = "warning",
                  t[t.info = 3] = "info",
                  t[t.debug = 4] = "debug"
              }(l || (l = {}));
              var u = l.off
                , h = function() {
                  function t(t) {
                      this.t = t
                  }
                  t.getLevel = function() {
                      return u
                  }
                  ,
                  t.setLevel = function(t) {
                      return u = l[t]
                  }
                  ;
                  var e = t.prototype;
                  return e.error = function() {
                      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                          e[n] = arguments[n];
                      this.i(console.error, l.error, e)
                  }
                  ,
                  e.warn = function() {
                      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                          e[n] = arguments[n];
                      this.i(console.warn, l.warning, e)
                  }
                  ,
                  e.info = function() {
                      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                          e[n] = arguments[n];
                      this.i(console.info, l.info, e)
                  }
                  ,
                  e.debug = function() {
                      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                          e[n] = arguments[n];
                      this.i(console.log, l.debug, e)
                  }
                  ,
                  e.i = function(e, n, r) {
                      n <= t.getLevel() && e.apply(console, ["[" + this.t + "] "].concat(r))
                  }
                  ,
                  t
              }()
                , f = S
                , d = w
                , p = y
                , v = b
                , m = k
                , g = new RegExp(["(\\\\.)", "(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?"].join("|"),"g");
              function y(t, e) {
                  for (var n, r = [], i = 0, o = 0, s = "", a = e && e.delimiter || "/", c = e && e.whitelist || void 0, l = !1; null !== (n = g.exec(t)); ) {
                      var u = n[0]
                        , h = n[1]
                        , f = n.index;
                      if (s += t.slice(o, f),
                      o = f + u.length,
                      h)
                          s += h[1],
                          l = !0;
                      else {
                          var d = ""
                            , p = n[2]
                            , v = n[3]
                            , m = n[4]
                            , y = n[5];
                          if (!l && s.length) {
                              var w = s.length - 1
                                , b = s[w];
                              (!c || c.indexOf(b) > -1) && (d = b,
                              s = s.slice(0, w))
                          }
                          s && (r.push(s),
                          s = "",
                          l = !1);
                          var _ = v || m
                            , k = d || a;
                          r.push({
                              name: p || i++,
                              prefix: d,
                              delimiter: k,
                              optional: "?" === y || "*" === y,
                              repeat: "+" === y || "*" === y,
                              pattern: _ ? x(_) : "[^" + E(k === a ? k : k + a) + "]+?"
                          })
                      }
                  }
                  return (s || o < t.length) && r.push(s + t.substr(o)),
                  r
              }
              function w(t, e) {
                  return function(n, r) {
                      var i = t.exec(n);
                      if (!i)
                          return !1;
                      for (var o = i[0], s = i.index, a = {}, c = r && r.decode || decodeURIComponent, l = 1; l < i.length; l++)
                          if (void 0 !== i[l]) {
                              var u = e[l - 1];
                              a[u.name] = u.repeat ? i[l].split(u.delimiter).map((function(t) {
                                  return c(t, u)
                              }
                              )) : c(i[l], u)
                          }
                      return {
                          path: o,
                          index: s,
                          params: a
                      }
                  }
              }
              function b(t, e) {
                  for (var n = new Array(t.length), r = 0; r < t.length; r++)
                      "object" == typeof t[r] && (n[r] = new RegExp("^(?:" + t[r].pattern + ")$",_(e)));
                  return function(e, r) {
                      for (var i = "", o = r && r.encode || encodeURIComponent, s = !r || !1 !== r.validate, a = 0; a < t.length; a++) {
                          var c = t[a];
                          if ("string" != typeof c) {
                              var l, u = e ? e[c.name] : void 0;
                              if (Array.isArray(u)) {
                                  if (!c.repeat)
                                      throw new TypeError('Expected "' + c.name + '" to not repeat, but got array');
                                  if (0 === u.length) {
                                      if (c.optional)
                                          continue;
                                      throw new TypeError('Expected "' + c.name + '" to not be empty')
                                  }
                                  for (var h = 0; h < u.length; h++) {
                                      if (l = o(u[h], c),
                                      s && !n[a].test(l))
                                          throw new TypeError('Expected all "' + c.name + '" to match "' + c.pattern + '"');
                                      i += (0 === h ? c.prefix : c.delimiter) + l
                                  }
                              } else if ("string" != typeof u && "number" != typeof u && "boolean" != typeof u) {
                                  if (!c.optional)
                                      throw new TypeError('Expected "' + c.name + '" to be ' + (c.repeat ? "an array" : "a string"))
                              } else {
                                  if (l = o(String(u), c),
                                  s && !n[a].test(l))
                                      throw new TypeError('Expected "' + c.name + '" to match "' + c.pattern + '", but got "' + l + '"');
                                  i += c.prefix + l
                              }
                          } else
                              i += c
                      }
                      return i
                  }
              }
              function E(t) {
                  return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1")
              }
              function x(t) {
                  return t.replace(/([=!:$/()])/g, "\\$1")
              }
              function _(t) {
                  return t && t.sensitive ? "" : "i"
              }
              function k(t, e, n) {
                  for (var r = (n = n || {}).strict, i = !1 !== n.start, o = !1 !== n.end, s = n.delimiter || "/", a = [].concat(n.endsWith || []).map(E).concat("$").join("|"), c = i ? "^" : "", l = 0; l < t.length; l++) {
                      var u = t[l];
                      if ("string" == typeof u)
                          c += E(u);
                      else {
                          var h = u.repeat ? "(?:" + u.pattern + ")(?:" + E(u.delimiter) + "(?:" + u.pattern + "))*" : u.pattern;
                          e && e.push(u),
                          c += u.optional ? u.prefix ? "(?:" + E(u.prefix) + "(" + h + "))?" : "(" + h + ")?" : E(u.prefix) + "(" + h + ")"
                      }
                  }
                  if (o)
                      r || (c += "(?:" + E(s) + ")?"),
                      c += "$" === a ? "$" : "(?=" + a + ")";
                  else {
                      var f = t[t.length - 1]
                        , d = "string" == typeof f ? f[f.length - 1] === s : void 0 === f;
                      r || (c += "(?:" + E(s) + "(?=" + a + "))?"),
                      d || (c += "(?=" + E(s) + "|" + a + ")")
                  }
                  return new RegExp(c,_(n))
              }
              function S(t, e, n) {
                  return t instanceof RegExp ? function(t, e) {
                      if (!e)
                          return t;
                      var n = t.source.match(/\((?!\?)/g);
                      if (n)
                          for (var r = 0; r < n.length; r++)
                              e.push({
                                  name: r,
                                  prefix: null,
                                  delimiter: null,
                                  optional: !1,
                                  repeat: !1,
                                  pattern: null
                              });
                      return t
                  }(t, e) : Array.isArray(t) ? function(t, e, n) {
                      for (var r = [], i = 0; i < t.length; i++)
                          r.push(S(t[i], e, n).source);
                      return new RegExp("(?:" + r.join("|") + ")",_(n))
                  }(t, e, n) : function(t, e, n) {
                      return k(y(t, n), e, n)
                  }(t, e, n)
              }
              f.match = function(t, e) {
                  var n = [];
                  return w(S(t, n, e), n)
              }
              ,
              f.regexpToFunction = d,
              f.parse = p,
              f.compile = function(t, e) {
                  return b(y(t, e), e)
              }
              ,
              f.tokensToFunction = v,
              f.tokensToRegExp = m;
              var T = {
                  container: "container",
                  history: "history",
                  namespace: "namespace",
                  prefix: "data-barba",
                  prevent: "prevent",
                  wrapper: "wrapper"
              }
                , A = new (function() {
                  function t() {
                      this.o = T,
                      this.u = new DOMParser
                  }
                  var e = t.prototype;
                  return e.toString = function(t) {
                      return t.outerHTML
                  }
                  ,
                  e.toDocument = function(t) {
                      return this.u.parseFromString(t, "text/html")
                  }
                  ,
                  e.toElement = function(t) {
                      var e = document.createElement("div");
                      return e.innerHTML = t,
                      e
                  }
                  ,
                  e.getHtml = function(t) {
                      return void 0 === t && (t = document),
                      this.toString(t.documentElement)
                  }
                  ,
                  e.getWrapper = function(t) {
                      return void 0 === t && (t = document),
                      t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]')
                  }
                  ,
                  e.getContainer = function(t) {
                      return void 0 === t && (t = document),
                      t.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]')
                  }
                  ,
                  e.removeContainer = function(t) {
                      document.body.contains(t) && t.parentNode.removeChild(t)
                  }
                  ,
                  e.addContainer = function(t, e) {
                      var n = this.getContainer();
                      n ? this.s(t, n) : e.appendChild(t)
                  }
                  ,
                  e.getNamespace = function(t) {
                      void 0 === t && (t = document);
                      var e = t.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
                      return e ? e.getAttribute(this.o.prefix + "-" + this.o.namespace) : null
                  }
                  ,
                  e.getHref = function(t) {
                      if (t.tagName && "a" === t.tagName.toLowerCase()) {
                          if ("string" == typeof t.href)
                              return t.href;
                          var e = t.getAttribute("href") || t.getAttribute("xlink:href");
                          if (e)
                              return this.resolveUrl(e.baseVal || e)
                      }
                      return null
                  }
                  ,
                  e.resolveUrl = function() {
                      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
                          e[n] = arguments[n];
                      var r = e.length;
                      if (0 === r)
                          throw new Error("resolveUrl requires at least one argument; got none.");
                      var i = document.createElement("base");
                      if (i.href = arguments[0],
                      1 === r)
                          return i.href;
                      var o = document.getElementsByTagName("head")[0];
                      o.insertBefore(i, o.firstChild);
                      for (var s, a = document.createElement("a"), c = 1; c < r; c++)
                          a.href = arguments[c],
                          i.href = s = a.href;
                      return o.removeChild(i),
                      s
                  }
                  ,
                  e.s = function(t, e) {
                      e.parentNode.insertBefore(t, e.nextSibling)
                  }
                  ,
                  t
              }())
                , L = new (function() {
                  function t() {
                      this.h = [],
                      this.v = -1
                  }
                  var r = t.prototype;
                  return r.init = function(t, e) {
                      this.l = "barba";
                      var n = {
                          ns: e,
                          scroll: {
                              x: window.scrollX,
                              y: window.scrollY
                          },
                          url: t
                      };
                      this.h.push(n),
                      this.v = 0;
                      var r = {
                          from: this.l,
                          index: 0,
                          states: [].concat(this.h)
                      };
                      window.history && window.history.replaceState(r, "", t)
                  }
                  ,
                  r.change = function(t, e, n) {
                      if (n && n.state) {
                          var r = n.state
                            , i = r.index;
                          e = this.m(this.v - i),
                          this.replace(r.states),
                          this.v = i
                      } else
                          this.add(t, e);
                      return e
                  }
                  ,
                  r.add = function(t, e) {
                      var n = this.size
                        , r = this.p(e)
                        , i = {
                          ns: "tmp",
                          scroll: {
                              x: window.scrollX,
                              y: window.scrollY
                          },
                          url: t
                      };
                      this.h.push(i),
                      this.v = n;
                      var o = {
                          from: this.l,
                          index: n,
                          states: [].concat(this.h)
                      };
                      switch (r) {
                      case "push":
                          window.history && window.history.pushState(o, "", t);
                          break;
                      case "replace":
                          window.history && window.history.replaceState(o, "", t)
                      }
                  }
                  ,
                  r.update = function(t, e) {
                      var r = e || this.v
                        , i = n({}, this.get(r), {}, t);
                      this.set(r, i)
                  }
                  ,
                  r.remove = function(t) {
                      t ? this.h.splice(t, 1) : this.h.pop(),
                      this.v--
                  }
                  ,
                  r.clear = function() {
                      this.h = [],
                      this.v = -1
                  }
                  ,
                  r.replace = function(t) {
                      this.h = t
                  }
                  ,
                  r.get = function(t) {
                      return this.h[t]
                  }
                  ,
                  r.set = function(t, e) {
                      return this.h[t] = e
                  }
                  ,
                  r.p = function(t) {
                      var e = "push"
                        , n = t
                        , r = T.prefix + "-" + T.history;
                      return n.hasAttribute && n.hasAttribute(r) && (e = n.getAttribute(r)),
                      e
                  }
                  ,
                  r.m = function(t) {
                      return Math.abs(t) > 1 ? t > 0 ? "forward" : "back" : 0 === t ? "popstate" : t > 0 ? "back" : "forward"
                  }
                  ,
                  e(t, [{
                      key: "current",
                      get: function() {
                          return this.h[this.v]
                      }
                  }, {
                      key: "state",
                      get: function() {
                          return this.h[this.h.length - 1]
                      }
                  }, {
                      key: "previous",
                      get: function() {
                          return this.v < 1 ? null : this.h[this.v - 1]
                      }
                  }, {
                      key: "size",
                      get: function() {
                          return this.h.length
                      }
                  }]),
                  t
              }())
                , O = function(t, e) {
                  try {
                      var n = function() {
                          if (!e.next.html)
                              return Promise.resolve(t).then((function(t) {
                                  var n = e.next;
                                  if (t) {
                                      var r = A.toElement(t);
                                      n.namespace = A.getNamespace(r),
                                      n.container = A.getContainer(r),
                                      n.html = t,
                                      L.update({
                                          ns: n.namespace
                                      });
                                      var i = A.toDocument(t);
                                      document.title = i.title
                                  }
                              }
                              ))
                      }();
                      return Promise.resolve(n && n.then ? n.then((function() {}
                      )) : void 0)
                  } catch (t) {
                      return Promise.reject(t)
                  }
              }
                , j = f
                , P = {
                  __proto__: null,
                  update: O,
                  nextTick: function() {
                      return new Promise((function(t) {
                          window.requestAnimationFrame(t)
                      }
                      ))
                  },
                  pathToRegexp: j
              }
                , M = function() {
                  return window.location.origin
              }
                , C = function(t) {
                  return void 0 === t && (t = window.location.href),
                  R(t).port
              }
                , R = function(t) {
                  var e, n = t.match(/:\d+/);
                  if (null === n)
                      /^http/.test(t) && (e = 80),
                      /^https/.test(t) && (e = 443);
                  else {
                      var r = n[0].substring(1);
                      e = parseInt(r, 10)
                  }
                  var i, o = t.replace(M(), ""), s = {}, a = o.indexOf("#");
                  a >= 0 && (i = o.slice(a + 1),
                  o = o.slice(0, a));
                  var c = o.indexOf("?");
                  return c >= 0 && (s = I(o.slice(c + 1)),
                  o = o.slice(0, c)),
                  {
                      hash: i,
                      path: o,
                      port: e,
                      query: s
                  }
              }
                , I = function(t) {
                  return t.split("&").reduce((function(t, e) {
                      var n = e.split("=");
                      return t[n[0]] = n[1],
                      t
                  }
                  ), {})
              }
                , q = function(t) {
                  return void 0 === t && (t = window.location.href),
                  t.replace(/(\/#.*|\/|#.*)$/, "")
              }
                , D = {
                  __proto__: null,
                  getHref: function() {
                      return window.location.href
                  },
                  getOrigin: M,
                  getPort: C,
                  getPath: function(t) {
                      return void 0 === t && (t = window.location.href),
                      R(t).path
                  },
                  parse: R,
                  parseQuery: I,
                  clean: q
              };
              function F(t, e, n) {
                  return void 0 === e && (e = 2e3),
                  new Promise((function(r, i) {
                      var o = new XMLHttpRequest;
                      o.onreadystatechange = function() {
                          if (o.readyState === XMLHttpRequest.DONE)
                              if (200 === o.status)
                                  r(o.responseText);
                              else if (o.status) {
                                  var e = {
                                      status: o.status,
                                      statusText: o.statusText
                                  };
                                  n(t, e),
                                  i(e)
                              }
                      }
                      ,
                      o.ontimeout = function() {
                          var r = new Error("Timeout error [" + e + "]");
                          n(t, r),
                          i(r)
                      }
                      ,
                      o.onerror = function() {
                          var e = new Error("Fetch error");
                          n(t, e),
                          i(e)
                      }
                      ,
                      o.open("GET", t),
                      o.timeout = e,
                      o.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"),
                      o.setRequestHeader("x-barba", "yes"),
                      o.send()
                  }
                  ))
              }
              var B = function(t) {
                  return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then
              };
              function H(t, e) {
                  return void 0 === e && (e = {}),
                  function() {
                      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
                          r[i] = arguments[i];
                      var o = !1
                        , s = new Promise((function(n, i) {
                          e.async = function() {
                              return o = !0,
                              function(t, e) {
                                  t ? i(t) : n(e)
                              }
                          }
                          ;
                          var s = t.apply(e, r);
                          o || (B(s) ? s.then(n, i) : n(s))
                      }
                      ));
                      return s
                  }
              }
              var N = new (function(t) {
                  function e() {
                      var e;
                      return (e = t.call(this) || this).logger = new h("@barba/core"),
                      e.all = ["ready", "page", "reset", "currentAdded", "currentRemoved", "nextAdded", "nextRemoved", "beforeOnce", "once", "afterOnce", "before", "beforeLeave", "leave", "afterLeave", "beforeEnter", "enter", "afterEnter", "after"],
                      e.registered = new Map,
                      e.init(),
                      e
                  }
                  r(e, t);
                  var n = e.prototype;
                  return n.init = function() {
                      var t = this;
                      this.registered.clear(),
                      this.all.forEach((function(e) {
                          t[e] || (t[e] = function(n, r) {
                              t.registered.has(e) || t.registered.set(e, new Set),
                              t.registered.get(e).add({
                                  ctx: r || {},
                                  fn: n
                              })
                          }
                          )
                      }
                      ))
                  }
                  ,
                  n.do = function(t) {
                      for (var e = this, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
                          r[i - 1] = arguments[i];
                      if (this.registered.has(t)) {
                          var o = Promise.resolve();
                          return this.registered.get(t).forEach((function(t) {
                              o = o.then((function() {
                                  return H(t.fn, t.ctx).apply(void 0, r)
                              }
                              ))
                          }
                          )),
                          o.catch((function(n) {
                              e.logger.debug("Hook error [" + t + "]"),
                              e.logger.error(n)
                          }
                          ))
                      }
                      return Promise.resolve()
                  }
                  ,
                  n.clear = function() {
                      var t = this;
                      this.all.forEach((function(e) {
                          delete t[e]
                      }
                      )),
                      this.init()
                  }
                  ,
                  n.help = function() {
                      this.logger.info("Available hooks: " + this.all.join(","));
                      var t = [];
                      this.registered.forEach((function(e, n) {
                          return t.push(n)
                      }
                      )),
                      this.logger.info("Registered hooks: " + t.join(","))
                  }
                  ,
                  e
              }((function() {}
              )))
                , z = function() {
                  function t(t) {
                      if (this.P = [],
                      "boolean" == typeof t)
                          this.g = t;
                      else {
                          var e = Array.isArray(t) ? t : [t];
                          this.P = e.map((function(t) {
                              return j(t)
                          }
                          ))
                      }
                  }
                  return t.prototype.checkHref = function(t) {
                      if ("boolean" == typeof this.g)
                          return this.g;
                      var e = R(t).path;
                      return this.P.some((function(t) {
                          return null !== t.exec(e)
                      }
                      ))
                  }
                  ,
                  t
              }()
                , W = function(t) {
                  function e(e) {
                      var n;
                      return (n = t.call(this, e) || this).k = new Map,
                      n
                  }
                  r(e, t);
                  var i = e.prototype;
                  return i.set = function(t, e, n) {
                      return this.k.set(t, {
                          action: n,
                          request: e
                      }),
                      {
                          action: n,
                          request: e
                      }
                  }
                  ,
                  i.get = function(t) {
                      return this.k.get(t)
                  }
                  ,
                  i.getRequest = function(t) {
                      return this.k.get(t).request
                  }
                  ,
                  i.getAction = function(t) {
                      return this.k.get(t).action
                  }
                  ,
                  i.has = function(t) {
                      return !this.checkHref(t) && this.k.has(t)
                  }
                  ,
                  i.delete = function(t) {
                      return this.k.delete(t)
                  }
                  ,
                  i.update = function(t, e) {
                      var r = n({}, this.k.get(t), {}, e);
                      return this.k.set(t, r),
                      r
                  }
                  ,
                  e
              }(z)
                , Y = function() {
                  return !window.history.pushState
              }
                , V = function(t) {
                  return !t.el || !t.href
              }
                , U = function(t) {
                  var e = t.event;
                  return e.which > 1 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
              }
                , X = function(t) {
                  var e = t.el;
                  return e.hasAttribute("target") && "_blank" === e.target
              }
                , $ = function(t) {
                  var e = t.el;
                  return void 0 !== e.protocol && window.location.protocol !== e.protocol || void 0 !== e.hostname && window.location.hostname !== e.hostname
              }
                , G = function(t) {
                  var e = t.el;
                  return void 0 !== e.port && C() !== C(e.href)
              }
                , K = function(t) {
                  var e = t.el;
                  return e.getAttribute && "string" == typeof e.getAttribute("download")
              }
                , Q = function(t) {
                  return t.el.hasAttribute(T.prefix + "-" + T.prevent)
              }
                , J = function(t) {
                  return Boolean(t.el.closest("[" + T.prefix + "-" + T.prevent + '="all"]'))
              }
                , Z = function(t) {
                  var e = t.href;
                  return q(e) === q() && C(e) === C()
              }
                , tt = function(t) {
                  function e(e) {
                      var n;
                      return (n = t.call(this, e) || this).suite = [],
                      n.tests = new Map,
                      n.init(),
                      n
                  }
                  r(e, t);
                  var n = e.prototype;
                  return n.init = function() {
                      this.add("pushState", Y),
                      this.add("exists", V),
                      this.add("newTab", U),
                      this.add("blank", X),
                      this.add("corsDomain", $),
                      this.add("corsPort", G),
                      this.add("download", K),
                      this.add("preventSelf", Q),
                      this.add("preventAll", J),
                      this.add("sameUrl", Z, !1)
                  }
                  ,
                  n.add = function(t, e, n) {
                      void 0 === n && (n = !0),
                      this.tests.set(t, e),
                      n && this.suite.push(t)
                  }
                  ,
                  n.run = function(t, e, n, r) {
                      return this.tests.get(t)({
                          el: e,
                          event: n,
                          href: r
                      })
                  }
                  ,
                  n.checkLink = function(t, e, n) {
                      var r = this;
                      return this.suite.some((function(i) {
                          return r.run(i, t, e, n)
                      }
                      ))
                  }
                  ,
                  e
              }(z)
                , et = function(t) {
                  function e(n, r) {
                      var i;
                      void 0 === r && (r = "Barba error");
                      for (var o = arguments.length, s = new Array(o > 2 ? o - 2 : 0), a = 2; a < o; a++)
                          s[a - 2] = arguments[a];
                      return (i = t.call.apply(t, [this].concat(s)) || this).error = n,
                      i.label = r,
                      Error.captureStackTrace && Error.captureStackTrace(function(t) {
                          if (void 0 === t)
                              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                          return t
                      }(i), e),
                      i.name = "BarbaError",
                      i
                  }
                  return r(e, t),
                  e
              }(a(Error))
                , nt = function() {
                  function t(t) {
                      void 0 === t && (t = []),
                      this.logger = new h("@barba/core"),
                      this.all = [],
                      this.page = [],
                      this.once = [],
                      this.A = [{
                          name: "namespace",
                          type: "strings"
                      }, {
                          name: "custom",
                          type: "function"
                      }],
                      t && (this.all = this.all.concat(t)),
                      this.update()
                  }
                  var e = t.prototype;
                  return e.add = function(t, e) {
                      "rule" === t ? this.A.splice(e.position || 0, 0, e.value) : this.all.push(e),
                      this.update()
                  }
                  ,
                  e.resolve = function(t, e) {
                      var n = this;
                      void 0 === e && (e = {});
                      var r = e.once ? this.once : this.page;
                      r = r.filter(e.self ? function(t) {
                          return t.name && "self" === t.name
                      }
                      : function(t) {
                          return !t.name || "self" !== t.name
                      }
                      );
                      var i = new Map
                        , o = r.find((function(r) {
                          var o = !0
                            , s = {};
                          return !(!e.self || "self" !== r.name) || (n.A.reverse().forEach((function(e) {
                              o && (o = n.R(r, e, t, s),
                              r.from && r.to && (o = n.R(r, e, t, s, "from") && n.R(r, e, t, s, "to")),
                              r.from && !r.to && (o = n.R(r, e, t, s, "from")),
                              !r.from && r.to && (o = n.R(r, e, t, s, "to")))
                          }
                          )),
                          i.set(r, s),
                          o)
                      }
                      ))
                        , s = i.get(o)
                        , a = [];
                      if (a.push(e.once ? "once" : "page"),
                      e.self && a.push("self"),
                      s) {
                          var c, l = [o];
                          Object.keys(s).length > 0 && l.push(s),
                          (c = this.logger).info.apply(c, ["Transition found [" + a.join(",") + "]"].concat(l))
                      } else
                          this.logger.info("No transition found [" + a.join(",") + "]");
                      return o
                  }
                  ,
                  e.update = function() {
                      var t = this;
                      this.all = this.all.map((function(e) {
                          return t.T(e)
                      }
                      )).sort((function(t, e) {
                          return t.priority - e.priority
                      }
                      )).reverse().map((function(t) {
                          return delete t.priority,
                          t
                      }
                      )),
                      this.page = this.all.filter((function(t) {
                          return void 0 !== t.leave || void 0 !== t.enter
                      }
                      )),
                      this.once = this.all.filter((function(t) {
                          return void 0 !== t.once
                      }
                      ))
                  }
                  ,
                  e.R = function(t, e, n, r, i) {
                      var o = !0
                        , s = !1
                        , a = t
                        , c = e.name
                        , l = c
                        , u = c
                        , h = c
                        , f = i ? a[i] : a
                        , d = "to" === i ? n.next : n.current;
                      if (i ? f && f[c] : f[c]) {
                          switch (e.type) {
                          default:
                              var p = Array.isArray(f[l]) ? f[l] : [f[l]];
                              d[l] && -1 !== p.indexOf(d[l]) && (s = !0),
                              -1 === p.indexOf(d[l]) && (o = !1);
                              break;
                          case "object":
                              var v = Array.isArray(f[u]) ? f[u] : [f[u]];
                              d[u] ? (d[u].name && -1 !== v.indexOf(d[u].name) && (s = !0),
                              -1 === v.indexOf(d[u].name) && (o = !1)) : o = !1;
                              break;
                          case "function":
                              f[h](n) ? s = !0 : o = !1
                          }
                          s && (i ? (r[i] = r[i] || {},
                          r[i][c] = a[i][c]) : r[c] = a[c])
                      }
                      return o
                  }
                  ,
                  e.O = function(t, e, n) {
                      var r = 0;
                      return (t[e] || t.from && t.from[e] || t.to && t.to[e]) && (r += Math.pow(10, n),
                      t.from && t.from[e] && (r += 1),
                      t.to && t.to[e] && (r += 2)),
                      r
                  }
                  ,
                  e.T = function(t) {
                      var e = this;
                      t.priority = 0;
                      var n = 0;
                      return this.A.forEach((function(r, i) {
                          n += e.O(t, r.name, i + 1)
                      }
                      )),
                      t.priority = n,
                      t
                  }
                  ,
                  t
              }()
                , rt = function() {
                  function t(t) {
                      void 0 === t && (t = []),
                      this.logger = new h("@barba/core"),
                      this.S = !1,
                      this.store = new nt(t)
                  }
                  var n = t.prototype;
                  return n.get = function(t, e) {
                      return this.store.resolve(t, e)
                  }
                  ,
                  n.doOnce = function(t) {
                      var e = t.data
                        , n = t.transition;
                      try {
                          var r = function() {
                              i.S = !1
                          }
                            , i = this
                            , o = n || {};
                          i.S = !0;
                          var s = c((function() {
                              return Promise.resolve(i.j("beforeOnce", e, o)).then((function() {
                                  return Promise.resolve(i.once(e, o)).then((function() {
                                      return Promise.resolve(i.j("afterOnce", e, o)).then((function() {}
                                      ))
                                  }
                                  ))
                              }
                              ))
                          }
                          ), (function(t) {
                              i.S = !1,
                              i.logger.debug("Transition error [before/after/once]"),
                              i.logger.error(t)
                          }
                          ));
                          return Promise.resolve(s && s.then ? s.then(r) : r())
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.doPage = function(t) {
                      var e = t.data
                        , n = t.transition
                        , r = t.page
                        , i = t.wrapper;
                      try {
                          var o = function(t) {
                              if (s)
                                  return t;
                              a.S = !1
                          }
                            , s = !1
                            , a = this
                            , l = n || {}
                            , u = !0 === l.sync || !1;
                          a.S = !0;
                          var h = c((function() {
                              function t() {
                                  return Promise.resolve(a.j("before", e, l)).then((function() {
                                      function t(t) {
                                          return Promise.resolve(a.remove(e)).then((function() {
                                              return Promise.resolve(a.j("after", e, l)).then((function() {}
                                              ))
                                          }
                                          ))
                                      }
                                      var n = function() {
                                          if (u)
                                              return c((function() {
                                                  return Promise.resolve(a.add(e, i)).then((function() {
                                                      return Promise.resolve(a.j("beforeLeave", e, l)).then((function() {
                                                          return Promise.resolve(a.j("beforeEnter", e, l)).then((function() {
                                                              return Promise.resolve(Promise.all([a.leave(e, l), a.enter(e, l)])).then((function() {
                                                                  return Promise.resolve(a.j("afterLeave", e, l)).then((function() {
                                                                      return Promise.resolve(a.j("afterEnter", e, l)).then((function() {}
                                                                      ))
                                                                  }
                                                                  ))
                                                              }
                                                              ))
                                                          }
                                                          ))
                                                      }
                                                      ))
                                                  }
                                                  ))
                                              }
                                              ), (function(t) {
                                                  if (a.M(t))
                                                      throw new et(t,"Transition error [sync]")
                                              }
                                              ));
                                          var t = function(t) {
                                              return c((function() {
                                                  var t = function() {
                                                      if (!1 !== n)
                                                          return Promise.resolve(a.add(e, i)).then((function() {
                                                              return Promise.resolve(a.j("beforeEnter", e, l)).then((function() {
                                                                  return Promise.resolve(a.enter(e, l, n)).then((function() {
                                                                      return Promise.resolve(a.j("afterEnter", e, l)).then((function() {}
                                                                      ))
                                                                  }
                                                                  ))
                                                              }
                                                              ))
                                                          }
                                                          ))
                                                  }();
                                                  if (t && t.then)
                                                      return t.then((function() {}
                                                      ))
                                              }
                                              ), (function(t) {
                                                  if (a.M(t))
                                                      throw new et(t,"Transition error [before/after/enter]")
                                              }
                                              ))
                                          }
                                            , n = !1
                                            , o = c((function() {
                                              return Promise.resolve(a.j("beforeLeave", e, l)).then((function() {
                                                  return Promise.resolve(Promise.all([a.leave(e, l), O(r, e)]).then((function(t) {
                                                      return t[0]
                                                  }
                                                  ))).then((function(t) {
                                                      return n = t,
                                                      Promise.resolve(a.j("afterLeave", e, l)).then((function() {}
                                                      ))
                                                  }
                                                  ))
                                              }
                                              ))
                                          }
                                          ), (function(t) {
                                              if (a.M(t))
                                                  throw new et(t,"Transition error [before/after/leave]")
                                          }
                                          ));
                                          return o && o.then ? o.then(t) : t()
                                      }();
                                      return n && n.then ? n.then(t) : t()
                                  }
                                  ))
                              }
                              var n = function() {
                                  if (u)
                                      return Promise.resolve(O(r, e)).then((function() {}
                                      ))
                              }();
                              return n && n.then ? n.then(t) : t()
                          }
                          ), (function(t) {
                              if (a.S = !1,
                              t.name && "BarbaError" === t.name)
                                  throw a.logger.debug(t.label),
                                  a.logger.error(t.error),
                                  t;
                              throw a.logger.debug("Transition error [page]"),
                              a.logger.error(t),
                              t
                          }
                          ));
                          return Promise.resolve(h && h.then ? h.then(o) : o(h))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.once = function(t, e) {
                      try {
                          return Promise.resolve(N.do("once", t, e)).then((function() {
                              return e.once ? H(e.once, e)(t) : Promise.resolve()
                          }
                          ))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.leave = function(t, e) {
                      try {
                          return Promise.resolve(N.do("leave", t, e)).then((function() {
                              return e.leave ? H(e.leave, e)(t) : Promise.resolve()
                          }
                          ))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.enter = function(t, e, n) {
                      try {
                          return Promise.resolve(N.do("enter", t, e)).then((function() {
                              return e.enter ? H(e.enter, e)(t, n) : Promise.resolve()
                          }
                          ))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.add = function(t, e) {
                      try {
                          return A.addContainer(t.next.container, e),
                          N.do("nextAdded", t),
                          Promise.resolve()
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.remove = function(t) {
                      try {
                          return A.removeContainer(t.current.container),
                          N.do("currentRemoved", t),
                          Promise.resolve()
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  n.M = function(t) {
                      return t.message ? !/Timeout error|Fetch error/.test(t.message) : !t.status
                  }
                  ,
                  n.j = function(t, e, n) {
                      try {
                          return Promise.resolve(N.do(t, e, n)).then((function() {
                              return n[t] ? H(n[t], n)(e) : Promise.resolve()
                          }
                          ))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  e(t, [{
                      key: "isRunning",
                      get: function() {
                          return this.S
                      },
                      set: function(t) {
                          this.S = t
                      }
                  }, {
                      key: "hasOnce",
                      get: function() {
                          return this.store.once.length > 0
                      }
                  }, {
                      key: "hasSelf",
                      get: function() {
                          return this.store.all.some((function(t) {
                              return "self" === t.name
                          }
                          ))
                      }
                  }, {
                      key: "shouldWait",
                      get: function() {
                          return this.store.all.some((function(t) {
                              return t.to && !t.to.route || t.sync
                          }
                          ))
                      }
                  }]),
                  t
              }()
                , it = function() {
                  function t(t) {
                      var e = this;
                      this.names = ["beforeLeave", "afterLeave", "beforeEnter", "afterEnter"],
                      this.byNamespace = new Map,
                      0 !== t.length && (t.forEach((function(t) {
                          e.byNamespace.set(t.namespace, t)
                      }
                      )),
                      this.names.forEach((function(t) {
                          N[t](e.L(t))
                      }
                      )))
                  }
                  return t.prototype.L = function(t) {
                      var e = this;
                      return function(n) {
                          var r = t.match(/enter/i) ? n.next : n.current
                            , i = e.byNamespace.get(r.namespace);
                          return i && i[t] ? H(i[t], i)(n) : Promise.resolve()
                      }
                  }
                  ,
                  t
              }();
              Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector),
              Element.prototype.closest || (Element.prototype.closest = function(t) {
                  var e = this;
                  do {
                      if (e.matches(t))
                          return e;
                      e = e.parentElement || e.parentNode
                  } while (null !== e && 1 === e.nodeType);
                  return null
              }
              );
              var ot = {
                  container: null,
                  html: "",
                  namespace: "",
                  url: {
                      hash: "",
                      href: "",
                      path: "",
                      port: null,
                      query: {}
                  }
              };
              return new (function() {
                  function t() {
                      this.version = "2.9.7",
                      this.schemaPage = ot,
                      this.Logger = h,
                      this.logger = new h("@barba/core"),
                      this.plugins = [],
                      this.hooks = N,
                      this.dom = A,
                      this.helpers = P,
                      this.history = L,
                      this.request = F,
                      this.url = D
                  }
                  var r = t.prototype;
                  return r.use = function(t, e) {
                      var n = this.plugins;
                      n.indexOf(t) > -1 ? this.logger.warn("Plugin [" + t.name + "] already installed.") : "function" == typeof t.install ? (t.install(this, e),
                      n.push(t)) : this.logger.warn("Plugin [" + t.name + '] has no "install" method.')
                  }
                  ,
                  r.init = function(t) {
                      var e = void 0 === t ? {} : t
                        , r = e.transitions
                        , i = void 0 === r ? [] : r
                        , o = e.views
                        , s = void 0 === o ? [] : o
                        , a = e.schema
                        , c = void 0 === a ? T : a
                        , l = e.requestError
                        , u = e.timeout
                        , f = void 0 === u ? 2e3 : u
                        , d = e.cacheIgnore
                        , p = void 0 !== d && d
                        , v = e.prefetchIgnore
                        , m = void 0 !== v && v
                        , g = e.preventRunning
                        , y = void 0 !== g && g
                        , w = e.prevent
                        , b = void 0 === w ? null : w
                        , E = e.debug
                        , x = e.logLevel;
                      if (h.setLevel(!0 === (void 0 !== E && E) ? "debug" : void 0 === x ? "off" : x),
                      this.logger.info(this.version),
                      Object.keys(c).forEach((function(t) {
                          T[t] && (T[t] = c[t])
                      }
                      )),
                      this.$ = l,
                      this.timeout = f,
                      this.cacheIgnore = p,
                      this.prefetchIgnore = m,
                      this.preventRunning = y,
                      this._ = this.dom.getWrapper(),
                      !this._)
                          throw new Error("[@barba/core] No Barba wrapper found");
                      this._.setAttribute("aria-live", "polite"),
                      this.q();
                      var _ = this.data.current;
                      if (!_.container)
                          throw new Error("[@barba/core] No Barba container found");
                      if (this.cache = new W(p),
                      this.prevent = new tt(m),
                      this.transitions = new rt(i),
                      this.views = new it(s),
                      null !== b) {
                          if ("function" != typeof b)
                              throw new Error("[@barba/core] Prevent should be a function");
                          this.prevent.add("preventCustom", b)
                      }
                      this.history.init(_.url.href, _.namespace),
                      this.B = this.B.bind(this),
                      this.U = this.U.bind(this),
                      this.D = this.D.bind(this),
                      this.F(),
                      this.plugins.forEach((function(t) {
                          return t.init()
                      }
                      ));
                      var k = this.data;
                      k.trigger = "barba",
                      k.next = k.current,
                      k.current = n({}, this.schemaPage),
                      this.hooks.do("ready", k),
                      this.once(k),
                      this.q()
                  }
                  ,
                  r.destroy = function() {
                      this.q(),
                      this.H(),
                      this.history.clear(),
                      this.hooks.clear(),
                      this.plugins = []
                  }
                  ,
                  r.force = function(t) {
                      window.location.assign(t)
                  }
                  ,
                  r.go = function(t, e, n) {
                      var r;
                      if (void 0 === e && (e = "barba"),
                      this.transitions.isRunning)
                          this.force(t);
                      else if (!(r = "popstate" === e ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t) : this.prevent.run("sameUrl", null, null, t)) || this.transitions.hasSelf)
                          return e = this.history.change(t, e, n),
                          n && (n.stopPropagation(),
                          n.preventDefault()),
                          this.page(t, e, r)
                  }
                  ,
                  r.once = function(t) {
                      try {
                          var e = this;
                          return Promise.resolve(e.hooks.do("beforeEnter", t)).then((function() {
                              function n() {
                                  return Promise.resolve(e.hooks.do("afterEnter", t)).then((function() {}
                                  ))
                              }
                              var r = function() {
                                  if (e.transitions.hasOnce) {
                                      var n = e.transitions.get(t, {
                                          once: !0
                                      });
                                      return Promise.resolve(e.transitions.doOnce({
                                          transition: n,
                                          data: t
                                      })).then((function() {}
                                      ))
                                  }
                              }();
                              return r && r.then ? r.then(n) : n()
                          }
                          ))
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  r.page = function(t, e, r) {
                      try {
                          var i = function() {
                              var t = o.data;
                              return Promise.resolve(o.hooks.do("page", t)).then((function() {
                                  var e = c((function() {
                                      var e = o.transitions.get(t, {
                                          once: !1,
                                          self: r
                                      });
                                      return Promise.resolve(o.transitions.doPage({
                                          data: t,
                                          page: s,
                                          transition: e,
                                          wrapper: o._
                                      })).then((function() {
                                          o.q()
                                      }
                                      ))
                                  }
                                  ), (function() {
                                      0 === h.getLevel() && o.force(t.current.url.href)
                                  }
                                  ));
                                  if (e && e.then)
                                      return e.then((function() {}
                                      ))
                              }
                              ))
                          }
                            , o = this;
                          o.data.next.url = n({
                              href: t
                          }, o.url.parse(t)),
                          o.data.trigger = e;
                          var s = o.cache.has(t) ? o.cache.update(t, {
                              action: "click"
                          }).request : o.cache.set(t, o.request(t, o.timeout, o.onRequestError.bind(o, e)), "click").request
                            , a = function() {
                              if (o.transitions.shouldWait)
                                  return Promise.resolve(O(s, o.data)).then((function() {}
                                  ))
                          }();
                          return Promise.resolve(a && a.then ? a.then(i) : i())
                      } catch (t) {
                          return Promise.reject(t)
                      }
                  }
                  ,
                  r.onRequestError = function(t) {
                      this.transitions.isRunning = !1;
                      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
                          n[r - 1] = arguments[r];
                      var i = n[0]
                        , o = n[1]
                        , s = this.cache.getAction(i);
                      return this.cache.delete(i),
                      !(this.$ && !1 === this.$(t, s, i, o) || ("click" === s && this.force(i),
                      1))
                  }
                  ,
                  r.prefetch = function(t) {
                      var e = this;
                      this.cache.has(t) || this.cache.set(t, this.request(t, this.timeout, this.onRequestError.bind(this, "barba")).catch((function(t) {
                          e.logger.error(t)
                      }
                      )), "prefetch")
                  }
                  ,
                  r.F = function() {
                      !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.B),
                      document.addEventListener("touchstart", this.B)),
                      document.addEventListener("click", this.U),
                      window.addEventListener("popstate", this.D)
                  }
                  ,
                  r.H = function() {
                      !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.B),
                      document.removeEventListener("touchstart", this.B)),
                      document.removeEventListener("click", this.U),
                      window.removeEventListener("popstate", this.D)
                  }
                  ,
                  r.B = function(t) {
                      var e = this
                        , n = this.I(t);
                      if (n) {
                          var r = this.dom.getHref(n);
                          this.prevent.checkHref(r) || this.cache.has(r) || this.cache.set(r, this.request(r, this.timeout, this.onRequestError.bind(this, n)).catch((function(t) {
                              e.logger.error(t)
                          }
                          )), "enter")
                      }
                  }
                  ,
                  r.U = function(t) {
                      var e = this.I(t);
                      if (e)
                          return this.transitions.isRunning && this.preventRunning ? (t.preventDefault(),
                          void t.stopPropagation()) : void this.go(this.dom.getHref(e), e, t)
                  }
                  ,
                  r.D = function(t) {
                      this.go(this.url.getHref(), "popstate", t)
                  }
                  ,
                  r.I = function(t) {
                      for (var e = t.target; e && !this.dom.getHref(e); )
                          e = e.parentNode;
                      if (e && !this.prevent.checkLink(e, t, this.dom.getHref(e)))
                          return e
                  }
                  ,
                  r.q = function() {
                      var t = this.url.getHref()
                        , e = {
                          container: this.dom.getContainer(),
                          html: this.dom.getHtml(),
                          namespace: this.dom.getNamespace(),
                          url: n({
                              href: t
                          }, this.url.parse(t))
                      };
                      this.C = {
                          current: e,
                          next: n({}, this.schemaPage),
                          trigger: void 0
                      },
                      this.hooks.do("reset", this.data)
                  }
                  ,
                  e(t, [{
                      key: "data",
                      get: function() {
                          return this.C
                      }
                  }, {
                      key: "wrapper",
                      get: function() {
                          return this._
                      }
                  }]),
                  t
              }())
          }()
      },
      9662: function(t, e, n) {
          var r = n(614)
            , i = n(6330);
          t.exports = function(t) {
              if (r(t))
                  return t;
              throw TypeError(i(t) + " is not a function")
          }
      },
      9483: function(t, e, n) {
          var r = n(4411)
            , i = n(6330);
          t.exports = function(t) {
              if (r(t))
                  return t;
              throw TypeError(i(t) + " is not a constructor")
          }
      },
      6077: function(t, e, n) {
          var r = n(614);
          t.exports = function(t) {
              if ("object" == typeof t || r(t))
                  return t;
              throw TypeError("Can't set " + String(t) + " as a prototype")
          }
      },
      5787: function(t) {
          t.exports = function(t, e, n) {
              if (t instanceof e)
                  return t;
              throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation")
          }
      },
      9670: function(t, e, n) {
          var r = n(111);
          t.exports = function(t) {
              if (r(t))
                  return t;
              throw TypeError(String(t) + " is not an object")
          }
      },
      4019: function(t) {
          t.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView
      },
      260: function(t, e, n) {
          "use strict";
          var r, i, o, s = n(4019), a = n(9781), c = n(7854), l = n(614), u = n(111), h = n(2597), f = n(648), d = n(6330), p = n(8880), v = n(1320), m = n(3070).f, g = n(9518), y = n(7674), w = n(5112), b = n(9711), E = c.Int8Array, x = E && E.prototype, _ = c.Uint8ClampedArray, k = _ && _.prototype, S = E && g(E), T = x && g(x), A = Object.prototype, L = A.isPrototypeOf, O = w("toStringTag"), j = b("TYPED_ARRAY_TAG"), P = b("TYPED_ARRAY_CONSTRUCTOR"), M = s && !!y && "Opera" !== f(c.opera), C = !1, R = {
              Int8Array: 1,
              Uint8Array: 1,
              Uint8ClampedArray: 1,
              Int16Array: 2,
              Uint16Array: 2,
              Int32Array: 4,
              Uint32Array: 4,
              Float32Array: 4,
              Float64Array: 8
          }, I = {
              BigInt64Array: 8,
              BigUint64Array: 8
          }, q = function(t) {
              if (!u(t))
                  return !1;
              var e = f(t);
              return h(R, e) || h(I, e)
          };
          for (r in R)
              (o = (i = c[r]) && i.prototype) ? p(o, P, i) : M = !1;
          for (r in I)
              (o = (i = c[r]) && i.prototype) && p(o, P, i);
          if ((!M || !l(S) || S === Function.prototype) && (S = function() {
              throw TypeError("Incorrect invocation")
          }
          ,
          M))
              for (r in R)
                  c[r] && y(c[r], S);
          if ((!M || !T || T === A) && (T = S.prototype,
          M))
              for (r in R)
                  c[r] && y(c[r].prototype, T);
          if (M && g(k) !== T && y(k, T),
          a && !h(T, O))
              for (r in C = !0,
              m(T, O, {
                  get: function() {
                      return u(this) ? this[j] : void 0
                  }
              }),
              R)
                  c[r] && p(c[r], j, r);
          t.exports = {
              NATIVE_ARRAY_BUFFER_VIEWS: M,
              TYPED_ARRAY_CONSTRUCTOR: P,
              TYPED_ARRAY_TAG: C && j,
              aTypedArray: function(t) {
                  if (q(t))
                      return t;
                  throw TypeError("Target is not a typed array")
              },
              aTypedArrayConstructor: function(t) {
                  if (l(t) && (!y || L.call(S, t)))
                      return t;
                  throw TypeError(d(t) + " is not a typed array constructor")
              },
              exportTypedArrayMethod: function(t, e, n) {
                  if (a) {
                      if (n)
                          for (var r in R) {
                              var i = c[r];
                              if (i && h(i.prototype, t))
                                  try {
                                      delete i.prototype[t]
                                  } catch (t) {}
                          }
                      T[t] && !n || v(T, t, n ? e : M && x[t] || e)
                  }
              },
              exportTypedArrayStaticMethod: function(t, e, n) {
                  var r, i;
                  if (a) {
                      if (y) {
                          if (n)
                              for (r in R)
                                  if ((i = c[r]) && h(i, t))
                                      try {
                                          delete i[t]
                                      } catch (t) {}
                          if (S[t] && !n)
                              return;
                          try {
                              return v(S, t, n ? e : M && S[t] || e)
                          } catch (t) {}
                      }
                      for (r in R)
                          !(i = c[r]) || i[t] && !n || v(i, t, e)
                  }
              },
              isView: function(t) {
                  if (!u(t))
                      return !1;
                  var e = f(t);
                  return "DataView" === e || h(R, e) || h(I, e)
              },
              isTypedArray: q,
              TypedArray: S,
              TypedArrayPrototype: T
          }
      },
      3331: function(t, e, n) {
          "use strict";
          var r = n(7854)
            , i = n(9781)
            , o = n(4019)
            , s = n(6530)
            , a = n(8880)
            , c = n(2248)
            , l = n(7293)
            , u = n(5787)
            , h = n(9303)
            , f = n(7466)
            , d = n(7067)
            , p = n(1179)
            , v = n(9518)
            , m = n(7674)
            , g = n(8006).f
            , y = n(3070).f
            , w = n(1285)
            , b = n(8003)
            , E = n(9909)
            , x = s.PROPER
            , _ = s.CONFIGURABLE
            , k = E.get
            , S = E.set
            , T = "ArrayBuffer"
            , A = "DataView"
            , L = "Wrong index"
            , O = r.ArrayBuffer
            , j = O
            , P = r.DataView
            , M = P && P.prototype
            , C = Object.prototype
            , R = r.RangeError
            , I = p.pack
            , q = p.unpack
            , D = function(t) {
              return [255 & t]
          }
            , F = function(t) {
              return [255 & t, t >> 8 & 255]
          }
            , B = function(t) {
              return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255]
          }
            , H = function(t) {
              return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0]
          }
            , N = function(t) {
              return I(t, 23, 4)
          }
            , z = function(t) {
              return I(t, 52, 8)
          }
            , W = function(t, e) {
              y(t.prototype, e, {
                  get: function() {
                      return k(this)[e]
                  }
              })
          }
            , Y = function(t, e, n, r) {
              var i = d(n)
                , o = k(t);
              if (i + e > o.byteLength)
                  throw R(L);
              var s = k(o.buffer).bytes
                , a = i + o.byteOffset
                , c = s.slice(a, a + e);
              return r ? c : c.reverse()
          }
            , V = function(t, e, n, r, i, o) {
              var s = d(n)
                , a = k(t);
              if (s + e > a.byteLength)
                  throw R(L);
              for (var c = k(a.buffer).bytes, l = s + a.byteOffset, u = r(+i), h = 0; h < e; h++)
                  c[l + h] = u[o ? h : e - h - 1]
          };
          if (o) {
              var U = x && O.name !== T;
              if (l((function() {
                  O(1)
              }
              )) && l((function() {
                  new O(-1)
              }
              )) && !l((function() {
                  return new O,
                  new O(1.5),
                  new O(NaN),
                  U && !_
              }
              )))
                  U && _ && a(O, "name", T);
              else {
                  for (var X, $ = (j = function(t) {
                      return u(this, j),
                      new O(d(t))
                  }
                  ).prototype = O.prototype, G = g(O), K = 0; G.length > K; )
                      (X = G[K++])in j || a(j, X, O[X]);
                  $.constructor = j
              }
              m && v(M) !== C && m(M, C);
              var Q = new P(new j(2))
                , J = M.setInt8;
              Q.setInt8(0, 2147483648),
              Q.setInt8(1, 2147483649),
              !Q.getInt8(0) && Q.getInt8(1) || c(M, {
                  setInt8: function(t, e) {
                      J.call(this, t, e << 24 >> 24)
                  },
                  setUint8: function(t, e) {
                      J.call(this, t, e << 24 >> 24)
                  }
              }, {
                  unsafe: !0
              })
          } else
              j = function(t) {
                  u(this, j, T);
                  var e = d(t);
                  S(this, {
                      bytes: w.call(new Array(e), 0),
                      byteLength: e
                  }),
                  i || (this.byteLength = e)
              }
              ,
              P = function(t, e, n) {
                  u(this, P, A),
                  u(t, j, A);
                  var r = k(t).byteLength
                    , o = h(e);
                  if (o < 0 || o > r)
                      throw R("Wrong offset");
                  if (o + (n = void 0 === n ? r - o : f(n)) > r)
                      throw R("Wrong length");
                  S(this, {
                      buffer: t,
                      byteLength: n,
                      byteOffset: o
                  }),
                  i || (this.buffer = t,
                  this.byteLength = n,
                  this.byteOffset = o)
              }
              ,
              i && (W(j, "byteLength"),
              W(P, "buffer"),
              W(P, "byteLength"),
              W(P, "byteOffset")),
              c(P.prototype, {
                  getInt8: function(t) {
                      return Y(this, 1, t)[0] << 24 >> 24
                  },
                  getUint8: function(t) {
                      return Y(this, 1, t)[0]
                  },
                  getInt16: function(t) {
                      var e = Y(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
                      return (e[1] << 8 | e[0]) << 16 >> 16
                  },
                  getUint16: function(t) {
                      var e = Y(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
                      return e[1] << 8 | e[0]
                  },
                  getInt32: function(t) {
                      return H(Y(this, 4, t, arguments.length > 1 ? arguments[1] : void 0))
                  },
                  getUint32: function(t) {
                      return H(Y(this, 4, t, arguments.length > 1 ? arguments[1] : void 0)) >>> 0
                  },
                  getFloat32: function(t) {
                      return q(Y(this, 4, t, arguments.length > 1 ? arguments[1] : void 0), 23)
                  },
                  getFloat64: function(t) {
                      return q(Y(this, 8, t, arguments.length > 1 ? arguments[1] : void 0), 52)
                  },
                  setInt8: function(t, e) {
                      V(this, 1, t, D, e)
                  },
                  setUint8: function(t, e) {
                      V(this, 1, t, D, e)
                  },
                  setInt16: function(t, e) {
                      V(this, 2, t, F, e, arguments.length > 2 ? arguments[2] : void 0)
                  },
                  setUint16: function(t, e) {
                      V(this, 2, t, F, e, arguments.length > 2 ? arguments[2] : void 0)
                  },
                  setInt32: function(t, e) {
                      V(this, 4, t, B, e, arguments.length > 2 ? arguments[2] : void 0)
                  },
                  setUint32: function(t, e) {
                      V(this, 4, t, B, e, arguments.length > 2 ? arguments[2] : void 0)
                  },
                  setFloat32: function(t, e) {
                      V(this, 4, t, N, e, arguments.length > 2 ? arguments[2] : void 0)
                  },
                  setFloat64: function(t, e) {
                      V(this, 8, t, z, e, arguments.length > 2 ? arguments[2] : void 0)
                  }
              });
          b(j, T),
          b(P, A),
          t.exports = {
              ArrayBuffer: j,
              DataView: P
          }
      },
      1285: function(t, e, n) {
          "use strict";
          var r = n(7908)
            , i = n(1400)
            , o = n(6244);
          t.exports = function(t) {
              for (var e = r(this), n = o(e), s = arguments.length, a = i(s > 1 ? arguments[1] : void 0, n), c = s > 2 ? arguments[2] : void 0, l = void 0 === c ? n : i(c, n); l > a; )
                  e[a++] = t;
              return e
          }
      },
      1318: function(t, e, n) {
          var r = n(5656)
            , i = n(1400)
            , o = n(6244)
            , s = function(t) {
              return function(e, n, s) {
                  var a, c = r(e), l = o(c), u = i(s, l);
                  if (t && n != n) {
                      for (; l > u; )
                          if ((a = c[u++]) != a)
                              return !0
                  } else
                      for (; l > u; u++)
                          if ((t || u in c) && c[u] === n)
                              return t || u || 0;
                  return !t && -1
              }
          };
          t.exports = {
              includes: s(!0),
              indexOf: s(!1)
          }
      },
      2092: function(t, e, n) {
          var r = n(9974)
            , i = n(8361)
            , o = n(7908)
            , s = n(6244)
            , a = n(5417)
            , c = [].push
            , l = function(t) {
              var e = 1 == t
                , n = 2 == t
                , l = 3 == t
                , u = 4 == t
                , h = 6 == t
                , f = 7 == t
                , d = 5 == t || h;
              return function(p, v, m, g) {
                  for (var y, w, b = o(p), E = i(b), x = r(v, m, 3), _ = s(E), k = 0, S = g || a, T = e ? S(p, _) : n || f ? S(p, 0) : void 0; _ > k; k++)
                      if ((d || k in E) && (w = x(y = E[k], k, b),
                      t))
                          if (e)
                              T[k] = w;
                          else if (w)
                              switch (t) {
                              case 3:
                                  return !0;
                              case 5:
                                  return y;
                              case 6:
                                  return k;
                              case 2:
                                  c.call(T, y)
                              }
                          else
                              switch (t) {
                              case 4:
                                  return !1;
                              case 7:
                                  c.call(T, y)
                              }
                  return h ? -1 : l || u ? u : T
              }
          };
          t.exports = {
              forEach: l(0),
              map: l(1),
              filter: l(2),
              some: l(3),
              every: l(4),
              find: l(5),
              findIndex: l(6),
              filterReject: l(7)
          }
      },
      4362: function(t) {
          var e = Math.floor
            , n = function(t, o) {
              var s = t.length
                , a = e(s / 2);
              return s < 8 ? r(t, o) : i(n(t.slice(0, a), o), n(t.slice(a), o), o)
          }
            , r = function(t, e) {
              for (var n, r, i = t.length, o = 1; o < i; ) {
                  for (r = o,
                  n = t[o]; r && e(t[r - 1], n) > 0; )
                      t[r] = t[--r];
                  r !== o++ && (t[r] = n)
              }
              return t
          }
            , i = function(t, e, n) {
              for (var r = t.length, i = e.length, o = 0, s = 0, a = []; o < r || s < i; )
                  o < r && s < i ? a.push(n(t[o], e[s]) <= 0 ? t[o++] : e[s++]) : a.push(o < r ? t[o++] : e[s++]);
              return a
          };
          t.exports = n
      },
      7475: function(t, e, n) {
          var r = n(3157)
            , i = n(4411)
            , o = n(111)
            , s = n(5112)("species");
          t.exports = function(t) {
              var e;
              return r(t) && (e = t.constructor,
              (i(e) && (e === Array || r(e.prototype)) || o(e) && null === (e = e[s])) && (e = void 0)),
              void 0 === e ? Array : e
          }
      },
      5417: function(t, e, n) {
          var r = n(7475);
          t.exports = function(t, e) {
              return new (r(t))(0 === e ? 0 : e)
          }
      },
      7072: function(t, e, n) {
          var r = n(5112)("iterator")
            , i = !1;
          try {
              var o = 0
                , s = {
                  next: function() {
                      return {
                          done: !!o++
                      }
                  },
                  return: function() {
                      i = !0
                  }
              };
              s[r] = function() {
                  return this
              }
              ,
              Array.from(s, (function() {
                  throw 2
              }
              ))
          } catch (t) {}
          t.exports = function(t, e) {
              if (!e && !i)
                  return !1;
              var n = !1;
              try {
                  var o = {};
                  o[r] = function() {
                      return {
                          next: function() {
                              return {
                                  done: n = !0
                              }
                          }
                      }
                  }
                  ,
                  t(o)
              } catch (t) {}
              return n
          }
      },
      4326: function(t) {
          var e = {}.toString;
          t.exports = function(t) {
              return e.call(t).slice(8, -1)
          }
      },
      648: function(t, e, n) {
          var r = n(1694)
            , i = n(614)
            , o = n(4326)
            , s = n(5112)("toStringTag")
            , a = "Arguments" == o(function() {
              return arguments
          }());
          t.exports = r ? o : function(t) {
              var e, n, r;
              return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                  try {
                      return t[e]
                  } catch (t) {}
              }(e = Object(t), s)) ? n : a ? o(e) : "Object" == (r = o(e)) && i(e.callee) ? "Arguments" : r
          }
      },
      9920: function(t, e, n) {
          var r = n(2597)
            , i = n(3887)
            , o = n(1236)
            , s = n(3070);
          t.exports = function(t, e) {
              for (var n = i(e), a = s.f, c = o.f, l = 0; l < n.length; l++) {
                  var u = n[l];
                  r(t, u) || a(t, u, c(e, u))
              }
          }
      },
      8544: function(t, e, n) {
          var r = n(7293);
          t.exports = !r((function() {
              function t() {}
              return t.prototype.constructor = null,
              Object.getPrototypeOf(new t) !== t.prototype
          }
          ))
      },
      8880: function(t, e, n) {
          var r = n(9781)
            , i = n(3070)
            , o = n(9114);
          t.exports = r ? function(t, e, n) {
              return i.f(t, e, o(1, n))
          }
          : function(t, e, n) {
              return t[e] = n,
              t
          }
      },
      9114: function(t) {
          t.exports = function(t, e) {
              return {
                  enumerable: !(1 & t),
                  configurable: !(2 & t),
                  writable: !(4 & t),
                  value: e
              }
          }
      },
      9781: function(t, e, n) {
          var r = n(7293);
          t.exports = !r((function() {
              return 7 != Object.defineProperty({}, 1, {
                  get: function() {
                      return 7
                  }
              })[1]
          }
          ))
      },
      317: function(t, e, n) {
          var r = n(7854)
            , i = n(111)
            , o = r.document
            , s = i(o) && i(o.createElement);
          t.exports = function(t) {
              return s ? o.createElement(t) : {}
          }
      },
      8886: function(t, e, n) {
          var r = n(8113).match(/firefox\/(\d+)/i);
          t.exports = !!r && +r[1]
      },
      256: function(t, e, n) {
          var r = n(8113);
          t.exports = /MSIE|Trident/.test(r)
      },
      8113: function(t, e, n) {
          var r = n(5005);
          t.exports = r("navigator", "userAgent") || ""
      },
      7392: function(t, e, n) {
          var r, i, o = n(7854), s = n(8113), a = o.process, c = o.Deno, l = a && a.versions || c && c.version, u = l && l.v8;
          u ? i = (r = u.split("."))[0] < 4 ? 1 : r[0] + r[1] : s && (!(r = s.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = s.match(/Chrome\/(\d+)/)) && (i = r[1]),
          t.exports = i && +i
      },
      8008: function(t, e, n) {
          var r = n(8113).match(/AppleWebKit\/(\d+)\./);
          t.exports = !!r && +r[1]
      },
      748: function(t) {
          t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
      },
      2109: function(t, e, n) {
          var r = n(7854)
            , i = n(1236).f
            , o = n(8880)
            , s = n(1320)
            , a = n(3505)
            , c = n(9920)
            , l = n(4705);
          t.exports = function(t, e) {
              var n, u, h, f, d, p = t.target, v = t.global, m = t.stat;
              if (n = v ? r : m ? r[p] || a(p, {}) : (r[p] || {}).prototype)
                  for (u in e) {
                      if (f = e[u],
                      h = t.noTargetGet ? (d = i(n, u)) && d.value : n[u],
                      !l(v ? u : p + (m ? "." : "#") + u, t.forced) && void 0 !== h) {
                          if (typeof f == typeof h)
                              continue;
                          c(f, h)
                      }
                      (t.sham || h && h.sham) && o(f, "sham", !0),
                      s(n, u, f, t)
                  }
          }
      },
      7293: function(t) {
          t.exports = function(t) {
              try {
                  return !!t()
              } catch (t) {
                  return !0
              }
          }
      },
      9974: function(t, e, n) {
          var r = n(9662);
          t.exports = function(t, e, n) {
              if (r(t),
              void 0 === e)
                  return t;
              switch (n) {
              case 0:
                  return function() {
                      return t.call(e)
                  }
                  ;
              case 1:
                  return function(n) {
                      return t.call(e, n)
                  }
                  ;
              case 2:
                  return function(n, r) {
                      return t.call(e, n, r)
                  }
                  ;
              case 3:
                  return function(n, r, i) {
                      return t.call(e, n, r, i)
                  }
              }
              return function() {
                  return t.apply(e, arguments)
              }
          }
      },
      6530: function(t, e, n) {
          var r = n(9781)
            , i = n(2597)
            , o = Function.prototype
            , s = r && Object.getOwnPropertyDescriptor
            , a = i(o, "name")
            , c = a && "something" === function() {}
          .name
            , l = a && (!r || r && s(o, "name").configurable);
          t.exports = {
              EXISTS: a,
              PROPER: c,
              CONFIGURABLE: l
          }
      },
      5005: function(t, e, n) {
          var r = n(7854)
            , i = n(614)
            , o = function(t) {
              return i(t) ? t : void 0
          };
          t.exports = function(t, e) {
              return arguments.length < 2 ? o(r[t]) : r[t] && r[t][e]
          }
      },
      1246: function(t, e, n) {
          var r = n(648)
            , i = n(8173)
            , o = n(7497)
            , s = n(5112)("iterator");
          t.exports = function(t) {
              if (null != t)
                  return i(t, s) || i(t, "@@iterator") || o[r(t)]
          }
      },
      8554: function(t, e, n) {
          var r = n(9662)
            , i = n(9670)
            , o = n(1246);
          t.exports = function(t, e) {
              var n = arguments.length < 2 ? o(t) : e;
              if (r(n))
                  return i(n.call(t));
              throw TypeError(String(t) + " is not iterable")
          }
      },
      8173: function(t, e, n) {
          var r = n(9662);
          t.exports = function(t, e) {
              var n = t[e];
              return null == n ? void 0 : r(n)
          }
      },
      7854: function(t, e, n) {
          var r = function(t) {
              return t && t.Math == Math && t
          };
          t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function() {
              return this
          }() || Function("return this")()
      },
      2597: function(t, e, n) {
          var r = n(7908)
            , i = {}.hasOwnProperty;
          t.exports = Object.hasOwn || function(t, e) {
              return i.call(r(t), e)
          }
      },
      3501: function(t) {
          t.exports = {}
      },
      490: function(t, e, n) {
          var r = n(5005);
          t.exports = r("document", "documentElement")
      },
      4664: function(t, e, n) {
          var r = n(9781)
            , i = n(7293)
            , o = n(317);
          t.exports = !r && !i((function() {
              return 7 != Object.defineProperty(o("div"), "a", {
                  get: function() {
                      return 7
                  }
              }).a
          }
          ))
      },
      1179: function(t) {
          var e = Math.abs
            , n = Math.pow
            , r = Math.floor
            , i = Math.log
            , o = Math.LN2;
          t.exports = {
              pack: function(t, s, a) {
                  var c, l, u, h = new Array(a), f = 8 * a - s - 1, d = (1 << f) - 1, p = d >> 1, v = 23 === s ? n(2, -24) - n(2, -77) : 0, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0, g = 0;
                  for ((t = e(t)) != t || t === 1 / 0 ? (l = t != t ? 1 : 0,
                  c = d) : (c = r(i(t) / o),
                  t * (u = n(2, -c)) < 1 && (c--,
                  u *= 2),
                  (t += c + p >= 1 ? v / u : v * n(2, 1 - p)) * u >= 2 && (c++,
                  u /= 2),
                  c + p >= d ? (l = 0,
                  c = d) : c + p >= 1 ? (l = (t * u - 1) * n(2, s),
                  c += p) : (l = t * n(2, p - 1) * n(2, s),
                  c = 0)); s >= 8; h[g++] = 255 & l,
                  l /= 256,
                  s -= 8)
                      ;
                  for (c = c << s | l,
                  f += s; f > 0; h[g++] = 255 & c,
                  c /= 256,
                  f -= 8)
                      ;
                  return h[--g] |= 128 * m,
                  h
              },
              unpack: function(t, e) {
                  var r, i = t.length, o = 8 * i - e - 1, s = (1 << o) - 1, a = s >> 1, c = o - 7, l = i - 1, u = t[l--], h = 127 & u;
                  for (u >>= 7; c > 0; h = 256 * h + t[l],
                  l--,
                  c -= 8)
                      ;
                  for (r = h & (1 << -c) - 1,
                  h >>= -c,
                  c += e; c > 0; r = 256 * r + t[l],
                  l--,
                  c -= 8)
                      ;
                  if (0 === h)
                      h = 1 - a;
                  else {
                      if (h === s)
                          return r ? NaN : u ? -1 / 0 : 1 / 0;
                      r += n(2, e),
                      h -= a
                  }
                  return (u ? -1 : 1) * r * n(2, h - e)
              }
          }
      },
      8361: function(t, e, n) {
          var r = n(7293)
            , i = n(4326)
            , o = "".split;
          t.exports = r((function() {
              return !Object("z").propertyIsEnumerable(0)
          }
          )) ? function(t) {
              return "String" == i(t) ? o.call(t, "") : Object(t)
          }
          : Object
      },
      9587: function(t, e, n) {
          var r = n(614)
            , i = n(111)
            , o = n(7674);
          t.exports = function(t, e, n) {
              var s, a;
              return o && r(s = e.constructor) && s !== n && i(a = s.prototype) && a !== n.prototype && o(t, a),
              t
          }
      },
      2788: function(t, e, n) {
          var r = n(614)
            , i = n(5465)
            , o = Function.toString;
          r(i.inspectSource) || (i.inspectSource = function(t) {
              return o.call(t)
          }
          ),
          t.exports = i.inspectSource
      },
      9909: function(t, e, n) {
          var r, i, o, s = n(8536), a = n(7854), c = n(111), l = n(8880), u = n(2597), h = n(5465), f = n(6200), d = n(3501), p = "Object already initialized", v = a.WeakMap;
          if (s || h.state) {
              var m = h.state || (h.state = new v)
                , g = m.get
                , y = m.has
                , w = m.set;
              r = function(t, e) {
                  if (y.call(m, t))
                      throw new TypeError(p);
                  return e.facade = t,
                  w.call(m, t, e),
                  e
              }
              ,
              i = function(t) {
                  return g.call(m, t) || {}
              }
              ,
              o = function(t) {
                  return y.call(m, t)
              }
          } else {
              var b = f("state");
              d[b] = !0,
              r = function(t, e) {
                  if (u(t, b))
                      throw new TypeError(p);
                  return e.facade = t,
                  l(t, b, e),
                  e
              }
              ,
              i = function(t) {
                  return u(t, b) ? t[b] : {}
              }
              ,
              o = function(t) {
                  return u(t, b)
              }
          }
          t.exports = {
              set: r,
              get: i,
              has: o,
              enforce: function(t) {
                  return o(t) ? i(t) : r(t, {})
              },
              getterFor: function(t) {
                  return function(e) {
                      var n;
                      if (!c(e) || (n = i(e)).type !== t)
                          throw TypeError("Incompatible receiver, " + t + " required");
                      return n
                  }
              }
          }
      },
      7659: function(t, e, n) {
          var r = n(5112)
            , i = n(7497)
            , o = r("iterator")
            , s = Array.prototype;
          t.exports = function(t) {
              return void 0 !== t && (i.Array === t || s[o] === t)
          }
      },
      3157: function(t, e, n) {
          var r = n(4326);
          t.exports = Array.isArray || function(t) {
              return "Array" == r(t)
          }
      },
      614: function(t) {
          t.exports = function(t) {
              return "function" == typeof t
          }
      },
      4411: function(t, e, n) {
          var r = n(7293)
            , i = n(614)
            , o = n(648)
            , s = n(5005)
            , a = n(2788)
            , c = []
            , l = s("Reflect", "construct")
            , u = /^\s*(?:class|function)\b/
            , h = u.exec
            , f = !u.exec((function() {}
          ))
            , d = function(t) {
              if (!i(t))
                  return !1;
              try {
                  return l(Object, c, t),
                  !0
              } catch (t) {
                  return !1
              }
          };
          t.exports = !l || r((function() {
              var t;
              return d(d.call) || !d(Object) || !d((function() {
                  t = !0
              }
              )) || t
          }
          )) ? function(t) {
              if (!i(t))
                  return !1;
              switch (o(t)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                  return !1
              }
              return f || !!h.call(u, a(t))
          }
          : d
      },
      4705: function(t, e, n) {
          var r = n(7293)
            , i = n(614)
            , o = /#|\.prototype\./
            , s = function(t, e) {
              var n = c[a(t)];
              return n == u || n != l && (i(e) ? r(e) : !!e)
          }
            , a = s.normalize = function(t) {
              return String(t).replace(o, ".").toLowerCase()
          }
            , c = s.data = {}
            , l = s.NATIVE = "N"
            , u = s.POLYFILL = "P";
          t.exports = s
      },
      5988: function(t, e, n) {
          var r = n(111)
            , i = Math.floor;
          t.exports = Number.isInteger || function(t) {
              return !r(t) && isFinite(t) && i(t) === t
          }
      },
      111: function(t, e, n) {
          var r = n(614);
          t.exports = function(t) {
              return "object" == typeof t ? null !== t : r(t)
          }
      },
      1913: function(t) {
          t.exports = !1
      },
      2190: function(t, e, n) {
          var r = n(614)
            , i = n(5005)
            , o = n(3307);
          t.exports = o ? function(t) {
              return "symbol" == typeof t
          }
          : function(t) {
              var e = i("Symbol");
              return r(e) && Object(t)instanceof e
          }
      },
      7497: function(t) {
          t.exports = {}
      },
      6244: function(t, e, n) {
          var r = n(7466);
          t.exports = function(t) {
              return r(t.length)
          }
      },
      133: function(t, e, n) {
          var r = n(7392)
            , i = n(7293);
          t.exports = !!Object.getOwnPropertySymbols && !i((function() {
              var t = Symbol();
              return !String(t) || !(Object(t)instanceof Symbol) || !Symbol.sham && r && r < 41
          }
          ))
      },
      8536: function(t, e, n) {
          var r = n(7854)
            , i = n(614)
            , o = n(2788)
            , s = r.WeakMap;
          t.exports = i(s) && /native code/.test(o(s))
      },
      30: function(t, e, n) {
          var r, i = n(9670), o = n(6048), s = n(748), a = n(3501), c = n(490), l = n(317), u = n(6200)("IE_PROTO"), h = function() {}, f = function(t) {
              return "<script>" + t + "<\/script>"
          }, d = function(t) {
              t.write(f("")),
              t.close();
              var e = t.parentWindow.Object;
              return t = null,
              e
          }, p = function() {
              try {
                  r = new ActiveXObject("htmlfile")
              } catch (t) {}
              var t, e;
              p = "undefined" != typeof document ? document.domain && r ? d(r) : ((e = l("iframe")).style.display = "none",
              c.appendChild(e),
              e.src = String("javascript:"),
              (t = e.contentWindow.document).open(),
              t.write(f("document.F=Object")),
              t.close(),
              t.F) : d(r);
              for (var n = s.length; n--; )
                  delete p.prototype[s[n]];
              return p()
          };
          a[u] = !0,
          t.exports = Object.create || function(t, e) {
              var n;
              return null !== t ? (h.prototype = i(t),
              n = new h,
              h.prototype = null,
              n[u] = t) : n = p(),
              void 0 === e ? n : o(n, e)
          }
      },
      6048: function(t, e, n) {
          var r = n(9781)
            , i = n(3070)
            , o = n(9670)
            , s = n(1956);
          t.exports = r ? Object.defineProperties : function(t, e) {
              o(t);
              for (var n, r = s(e), a = r.length, c = 0; a > c; )
                  i.f(t, n = r[c++], e[n]);
              return t
          }
      },
      3070: function(t, e, n) {
          var r = n(9781)
            , i = n(4664)
            , o = n(9670)
            , s = n(4948)
            , a = Object.defineProperty;
          e.f = r ? a : function(t, e, n) {
              if (o(t),
              e = s(e),
              o(n),
              i)
                  try {
                      return a(t, e, n)
                  } catch (t) {}
              if ("get"in n || "set"in n)
                  throw TypeError("Accessors not supported");
              return "value"in n && (t[e] = n.value),
              t
          }
      },
      1236: function(t, e, n) {
          var r = n(9781)
            , i = n(5296)
            , o = n(9114)
            , s = n(5656)
            , a = n(4948)
            , c = n(2597)
            , l = n(4664)
            , u = Object.getOwnPropertyDescriptor;
          e.f = r ? u : function(t, e) {
              if (t = s(t),
              e = a(e),
              l)
                  try {
                      return u(t, e)
                  } catch (t) {}
              if (c(t, e))
                  return o(!i.f.call(t, e), t[e])
          }
      },
      8006: function(t, e, n) {
          var r = n(6324)
            , i = n(748).concat("length", "prototype");
          e.f = Object.getOwnPropertyNames || function(t) {
              return r(t, i)
          }
      },
      5181: function(t, e) {
          e.f = Object.getOwnPropertySymbols
      },
      9518: function(t, e, n) {
          var r = n(2597)
            , i = n(614)
            , o = n(7908)
            , s = n(6200)
            , a = n(8544)
            , c = s("IE_PROTO")
            , l = Object.prototype;
          t.exports = a ? Object.getPrototypeOf : function(t) {
              var e = o(t);
              if (r(e, c))
                  return e[c];
              var n = e.constructor;
              return i(n) && e instanceof n ? n.prototype : e instanceof Object ? l : null
          }
      },
      6324: function(t, e, n) {
          var r = n(2597)
            , i = n(5656)
            , o = n(1318).indexOf
            , s = n(3501);
          t.exports = function(t, e) {
              var n, a = i(t), c = 0, l = [];
              for (n in a)
                  !r(s, n) && r(a, n) && l.push(n);
              for (; e.length > c; )
                  r(a, n = e[c++]) && (~o(l, n) || l.push(n));
              return l
          }
      },
      1956: function(t, e, n) {
          var r = n(6324)
            , i = n(748);
          t.exports = Object.keys || function(t) {
              return r(t, i)
          }
      },
      5296: function(t, e) {
          "use strict";
          var n = {}.propertyIsEnumerable
            , r = Object.getOwnPropertyDescriptor
            , i = r && !n.call({
              1: 2
          }, 1);
          e.f = i ? function(t) {
              var e = r(this, t);
              return !!e && e.enumerable
          }
          : n
      },
      7674: function(t, e, n) {
          var r = n(9670)
            , i = n(6077);
          t.exports = Object.setPrototypeOf || ("__proto__"in {} ? function() {
              var t, e = !1, n = {};
              try {
                  (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []),
                  e = n instanceof Array
              } catch (t) {}
              return function(n, o) {
                  return r(n),
                  i(o),
                  e ? t.call(n, o) : n.__proto__ = o,
                  n
              }
          }() : void 0)
      },
      2140: function(t, e, n) {
          var r = n(614)
            , i = n(111);
          t.exports = function(t, e) {
              var n, o;
              if ("string" === e && r(n = t.toString) && !i(o = n.call(t)))
                  return o;
              if (r(n = t.valueOf) && !i(o = n.call(t)))
                  return o;
              if ("string" !== e && r(n = t.toString) && !i(o = n.call(t)))
                  return o;
              throw TypeError("Can't convert object to primitive value")
          }
      },
      3887: function(t, e, n) {
          var r = n(5005)
            , i = n(8006)
            , o = n(5181)
            , s = n(9670);
          t.exports = r("Reflect", "ownKeys") || function(t) {
              var e = i.f(s(t))
                , n = o.f;
              return n ? e.concat(n(t)) : e
          }
      },
      2248: function(t, e, n) {
          var r = n(1320);
          t.exports = function(t, e, n) {
              for (var i in e)
                  r(t, i, e[i], n);
              return t
          }
      },
      1320: function(t, e, n) {
          var r = n(7854)
            , i = n(614)
            , o = n(2597)
            , s = n(8880)
            , a = n(3505)
            , c = n(2788)
            , l = n(9909)
            , u = n(6530).CONFIGURABLE
            , h = l.get
            , f = l.enforce
            , d = String(String).split("String");
          (t.exports = function(t, e, n, c) {
              var l, h = !!c && !!c.unsafe, p = !!c && !!c.enumerable, v = !!c && !!c.noTargetGet, m = c && void 0 !== c.name ? c.name : e;
              i(n) && ("Symbol(" === String(m).slice(0, 7) && (m = "[" + String(m).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
              (!o(n, "name") || u && n.name !== m) && s(n, "name", m),
              (l = f(n)).source || (l.source = d.join("string" == typeof m ? m : ""))),
              t !== r ? (h ? !v && t[e] && (p = !0) : delete t[e],
              p ? t[e] = n : s(t, e, n)) : p ? t[e] = n : a(e, n)
          }
          )(Function.prototype, "toString", (function() {
              return i(this) && h(this).source || c(this)
          }
          ))
      },
      4488: function(t) {
          t.exports = function(t) {
              if (null == t)
                  throw TypeError("Can't call method on " + t);
              return t
          }
      },
      3505: function(t, e, n) {
          var r = n(7854);
          t.exports = function(t, e) {
              try {
                  Object.defineProperty(r, t, {
                      value: e,
                      configurable: !0,
                      writable: !0
                  })
              } catch (n) {
                  r[t] = e
              }
              return e
          }
      },
      6340: function(t, e, n) {
          "use strict";
          var r = n(5005)
            , i = n(3070)
            , o = n(5112)
            , s = n(9781)
            , a = o("species");
          t.exports = function(t) {
              var e = r(t)
                , n = i.f;
              s && e && !e[a] && n(e, a, {
                  configurable: !0,
                  get: function() {
                      return this
                  }
              })
          }
      },
      8003: function(t, e, n) {
          var r = n(3070).f
            , i = n(2597)
            , o = n(5112)("toStringTag");
          t.exports = function(t, e, n) {
              t && !i(t = n ? t : t.prototype, o) && r(t, o, {
                  configurable: !0,
                  value: e
              })
          }
      },
      6200: function(t, e, n) {
          var r = n(2309)
            , i = n(9711)
            , o = r("keys");
          t.exports = function(t) {
              return o[t] || (o[t] = i(t))
          }
      },
      5465: function(t, e, n) {
          var r = n(7854)
            , i = n(3505)
            , o = "__core-js_shared__"
            , s = r[o] || i(o, {});
          t.exports = s
      },
      2309: function(t, e, n) {
          var r = n(1913)
            , i = n(5465);
          (t.exports = function(t, e) {
              return i[t] || (i[t] = void 0 !== e ? e : {})
          }
          )("versions", []).push({
              version: "3.18.3",
              mode: r ? "pure" : "global",
              copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
          })
      },
      1400: function(t, e, n) {
          var r = n(9303)
            , i = Math.max
            , o = Math.min;
          t.exports = function(t, e) {
              var n = r(t);
              return n < 0 ? i(n + e, 0) : o(n, e)
          }
      },
      7067: function(t, e, n) {
          var r = n(9303)
            , i = n(7466);
          t.exports = function(t) {
              if (void 0 === t)
                  return 0;
              var e = r(t)
                , n = i(e);
              if (e !== n)
                  throw RangeError("Wrong length or index");
              return n
          }
      },
      5656: function(t, e, n) {
          var r = n(8361)
            , i = n(4488);
          t.exports = function(t) {
              return r(i(t))
          }
      },
      9303: function(t) {
          var e = Math.ceil
            , n = Math.floor;
          t.exports = function(t) {
              var r = +t;
              return r != r || 0 === r ? 0 : (r > 0 ? n : e)(r)
          }
      },
      7466: function(t, e, n) {
          var r = n(9303)
            , i = Math.min;
          t.exports = function(t) {
              return t > 0 ? i(r(t), 9007199254740991) : 0
          }
      },
      7908: function(t, e, n) {
          var r = n(4488);
          t.exports = function(t) {
              return Object(r(t))
          }
      },
      4590: function(t, e, n) {
          var r = n(3002);
          t.exports = function(t, e) {
              var n = r(t);
              if (n % e)
                  throw RangeError("Wrong offset");
              return n
          }
      },
      3002: function(t, e, n) {
          var r = n(9303);
          t.exports = function(t) {
              var e = r(t);
              if (e < 0)
                  throw RangeError("The argument can't be less than 0");
              return e
          }
      },
      7593: function(t, e, n) {
          var r = n(111)
            , i = n(2190)
            , o = n(8173)
            , s = n(2140)
            , a = n(5112)("toPrimitive");
          t.exports = function(t, e) {
              if (!r(t) || i(t))
                  return t;
              var n, c = o(t, a);
              if (c) {
                  if (void 0 === e && (e = "default"),
                  n = c.call(t, e),
                  !r(n) || i(n))
                      return n;
                  throw TypeError("Can't convert object to primitive value")
              }
              return void 0 === e && (e = "number"),
              s(t, e)
          }
      },
      4948: function(t, e, n) {
          var r = n(7593)
            , i = n(2190);
          t.exports = function(t) {
              var e = r(t, "string");
              return i(e) ? e : String(e)
          }
      },
      1694: function(t, e, n) {
          var r = {};
          r[n(5112)("toStringTag")] = "z",
          t.exports = "[object z]" === String(r)
      },
      6330: function(t) {
          t.exports = function(t) {
              try {
                  return String(t)
              } catch (t) {
                  return "Object"
              }
          }
      },
      9843: function(t, e, n) {
          "use strict";
          var r = n(2109)
            , i = n(7854)
            , o = n(9781)
            , s = n(3832)
            , a = n(260)
            , c = n(3331)
            , l = n(5787)
            , u = n(9114)
            , h = n(8880)
            , f = n(5988)
            , d = n(7466)
            , p = n(7067)
            , v = n(4590)
            , m = n(4948)
            , g = n(2597)
            , y = n(648)
            , w = n(111)
            , b = n(2190)
            , E = n(30)
            , x = n(7674)
            , _ = n(8006).f
            , k = n(7321)
            , S = n(2092).forEach
            , T = n(6340)
            , A = n(3070)
            , L = n(1236)
            , O = n(9909)
            , j = n(9587)
            , P = O.get
            , M = O.set
            , C = A.f
            , R = L.f
            , I = Math.round
            , q = i.RangeError
            , D = c.ArrayBuffer
            , F = c.DataView
            , B = a.NATIVE_ARRAY_BUFFER_VIEWS
            , H = a.TYPED_ARRAY_CONSTRUCTOR
            , N = a.TYPED_ARRAY_TAG
            , z = a.TypedArray
            , W = a.TypedArrayPrototype
            , Y = a.aTypedArrayConstructor
            , V = a.isTypedArray
            , U = "BYTES_PER_ELEMENT"
            , X = "Wrong length"
            , $ = function(t, e) {
              for (var n = 0, r = e.length, i = new (Y(t))(r); r > n; )
                  i[n] = e[n++];
              return i
          }
            , G = function(t, e) {
              C(t, e, {
                  get: function() {
                      return P(this)[e]
                  }
              })
          }
            , K = function(t) {
              var e;
              return t instanceof D || "ArrayBuffer" == (e = y(t)) || "SharedArrayBuffer" == e
          }
            , Q = function(t, e) {
              return V(t) && !b(e) && e in t && f(+e) && e >= 0
          }
            , J = function(t, e) {
              return e = m(e),
              Q(t, e) ? u(2, t[e]) : R(t, e)
          }
            , Z = function(t, e, n) {
              return e = m(e),
              !(Q(t, e) && w(n) && g(n, "value")) || g(n, "get") || g(n, "set") || n.configurable || g(n, "writable") && !n.writable || g(n, "enumerable") && !n.enumerable ? C(t, e, n) : (t[e] = n.value,
              t)
          };
          o ? (B || (L.f = J,
          A.f = Z,
          G(W, "buffer"),
          G(W, "byteOffset"),
          G(W, "byteLength"),
          G(W, "length")),
          r({
              target: "Object",
              stat: !0,
              forced: !B
          }, {
              getOwnPropertyDescriptor: J,
              defineProperty: Z
          }),
          t.exports = function(t, e, n) {
              var o = t.match(/\d+$/)[0] / 8
                , a = t + (n ? "Clamped" : "") + "Array"
                , c = "get" + t
                , u = "set" + t
                , f = i[a]
                , m = f
                , g = m && m.prototype
                , y = {}
                , b = function(t, e) {
                  C(t, e, {
                      get: function() {
                          return function(t, e) {
                              var n = P(t);
                              return n.view[c](e * o + n.byteOffset, !0)
                          }(this, e)
                      },
                      set: function(t) {
                          return function(t, e, r) {
                              var i = P(t);
                              n && (r = (r = I(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r),
                              i.view[u](e * o + i.byteOffset, r, !0)
                          }(this, e, t)
                      },
                      enumerable: !0
                  })
              };
              B ? s && (m = e((function(t, e, n, r) {
                  return l(t, m, a),
                  j(w(e) ? K(e) ? void 0 !== r ? new f(e,v(n, o),r) : void 0 !== n ? new f(e,v(n, o)) : new f(e) : V(e) ? $(m, e) : k.call(m, e) : new f(p(e)), t, m)
              }
              )),
              x && x(m, z),
              S(_(f), (function(t) {
                  t in m || h(m, t, f[t])
              }
              )),
              m.prototype = g) : (m = e((function(t, e, n, r) {
                  l(t, m, a);
                  var i, s, c, u = 0, h = 0;
                  if (w(e)) {
                      if (!K(e))
                          return V(e) ? $(m, e) : k.call(m, e);
                      i = e,
                      h = v(n, o);
                      var f = e.byteLength;
                      if (void 0 === r) {
                          if (f % o)
                              throw q(X);
                          if ((s = f - h) < 0)
                              throw q(X)
                      } else if ((s = d(r) * o) + h > f)
                          throw q(X);
                      c = s / o
                  } else
                      c = p(e),
                      i = new D(s = c * o);
                  for (M(t, {
                      buffer: i,
                      byteOffset: h,
                      byteLength: s,
                      length: c,
                      view: new F(i)
                  }); u < c; )
                      b(t, u++)
              }
              )),
              x && x(m, z),
              g = m.prototype = E(W)),
              g.constructor !== m && h(g, "constructor", m),
              h(g, H, m),
              N && h(g, N, a),
              y[a] = m,
              r({
                  global: !0,
                  forced: m != f,
                  sham: !B
              }, y),
              U in m || h(m, U, o),
              U in g || h(g, U, o),
              T(a)
          }
          ) : t.exports = function() {}
      },
      3832: function(t, e, n) {
          var r = n(7854)
            , i = n(7293)
            , o = n(7072)
            , s = n(260).NATIVE_ARRAY_BUFFER_VIEWS
            , a = r.ArrayBuffer
            , c = r.Int8Array;
          t.exports = !s || !i((function() {
              c(1)
          }
          )) || !i((function() {
              new c(-1)
          }
          )) || !o((function(t) {
              new c,
              new c(null),
              new c(1.5),
              new c(t)
          }
          ), !0) || i((function() {
              return 1 !== new c(new a(2),1,void 0).length
          }
          ))
      },
      7321: function(t, e, n) {
          var r = n(9483)
            , i = n(7908)
            , o = n(6244)
            , s = n(8554)
            , a = n(1246)
            , c = n(7659)
            , l = n(9974)
            , u = n(260).aTypedArrayConstructor;
          t.exports = function(t) {
              var e, n, h, f, d, p, v = r(this), m = i(t), g = arguments.length, y = g > 1 ? arguments[1] : void 0, w = void 0 !== y, b = a(m);
              if (b && !c(b))
                  for (p = (d = s(m, b)).next,
                  m = []; !(f = p.call(d)).done; )
                      m.push(f.value);
              for (w && g > 2 && (y = l(y, arguments[2], 2)),
              n = o(m),
              h = new (u(v))(n),
              e = 0; n > e; e++)
                  h[e] = w ? y(m[e], e) : m[e];
              return h
          }
      },
      9711: function(t) {
          var e = 0
            , n = Math.random();
          t.exports = function(t) {
              return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++e + n).toString(36)
          }
      },
      3307: function(t, e, n) {
          var r = n(133);
          t.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator
      },
      5112: function(t, e, n) {
          var r = n(7854)
            , i = n(2309)
            , o = n(2597)
            , s = n(9711)
            , a = n(133)
            , c = n(3307)
            , l = i("wks")
            , u = r.Symbol
            , h = c ? u : u && u.withoutSetter || s;
          t.exports = function(t) {
              return o(l, t) && (a || "string" == typeof l[t]) || (a && o(u, t) ? l[t] = u[t] : l[t] = h("Symbol." + t)),
              l[t]
          }
      },
      4197: function(t, e, n) {
          n(9843)("Float32", (function(t) {
              return function(e, n, r) {
                  return t(this, e, n, r)
              }
          }
          ))
      },
      5109: function(t, e, n) {
          n(9843)("Int16", (function(t) {
              return function(e, n, r) {
                  return t(this, e, n, r)
              }
          }
          ))
      },
      3824: function(t, e, n) {
          "use strict";
          var r = n(260)
            , i = n(7854)
            , o = n(7293)
            , s = n(9662)
            , a = n(6244)
            , c = n(4362)
            , l = n(8886)
            , u = n(256)
            , h = n(7392)
            , f = n(8008)
            , d = r.aTypedArray
            , p = r.exportTypedArrayMethod
            , v = i.Uint16Array
            , m = v && v.prototype.sort
            , g = !!m && !o((function() {
              var t = new v(2);
              t.sort(null),
              t.sort({})
          }
          ))
            , y = !!m && !o((function() {
              if (h)
                  return h < 74;
              if (l)
                  return l < 67;
              if (u)
                  return !0;
              if (f)
                  return f < 602;
              var t, e, n = new v(516), r = Array(516);
              for (t = 0; t < 516; t++)
                  e = t % 4,
                  n[t] = 515 - t,
                  r[t] = t - 2 * e + 3;
              for (n.sort((function(t, e) {
                  return (t / 4 | 0) - (e / 4 | 0)
              }
              )),
              t = 0; t < 516; t++)
                  if (n[t] !== r[t])
                      return !0
          }
          ));
          p("sort", (function(t) {
              var e = this;
              if (void 0 !== t && s(t),
              y)
                  return m.call(e, t);
              d(e);
              var n, r = a(e), i = Array(r);
              for (n = 0; n < r; n++)
                  i[n] = e[n];
              for (i = c(e, function(t) {
                  return function(e, n) {
                      return void 0 !== t ? +t(e, n) || 0 : n != n ? -1 : e != e ? 1 : 0 === e && 0 === n ? 1 / e > 0 && 1 / n < 0 ? 1 : -1 : e > n
                  }
              }(t)),
              n = 0; n < r; n++)
                  e[n] = i[n];
              return e
          }
          ), !y || g)
      },
      7158: function(t, e, n) {
          var r, i;
          "undefined" != typeof window && window,
          void 0 === (i = "function" == typeof (r = function() {
              "use strict";
              function t() {}
              var e = t.prototype;
              return e.on = function(t, e) {
                  if (t && e) {
                      var n = this._events = this._events || {}
                        , r = n[t] = n[t] || [];
                      return -1 == r.indexOf(e) && r.push(e),
                      this
                  }
              }
              ,
              e.once = function(t, e) {
                  if (t && e) {
                      this.on(t, e);
                      var n = this._onceEvents = this._onceEvents || {};
                      return (n[t] = n[t] || {})[e] = !0,
                      this
                  }
              }
              ,
              e.off = function(t, e) {
                  var n = this._events && this._events[t];
                  if (n && n.length) {
                      var r = n.indexOf(e);
                      return -1 != r && n.splice(r, 1),
                      this
                  }
              }
              ,
              e.emitEvent = function(t, e) {
                  var n = this._events && this._events[t];
                  if (n && n.length) {
                      n = n.slice(0),
                      e = e || [];
                      for (var r = this._onceEvents && this._onceEvents[t], i = 0; i < n.length; i++) {
                          var o = n[i];
                          r && r[o] && (this.off(t, o),
                          delete r[o]),
                          o.apply(this, e)
                      }
                      return this
                  }
              }
              ,
              e.allOff = function() {
                  delete this._events,
                  delete this._onceEvents
              }
              ,
              t
          }
          ) ? r.call(e, n, e, t) : r) || (t.exports = i)
      },
      7564: function(t, e, n) {
          var r, i;
          !function(o, s) {
              "use strict";
              r = [n(7158)],
              i = function(t) {
                  return function(t, e) {
                      var n = t.jQuery
                        , r = t.console;
                      function i(t, e) {
                          for (var n in e)
                              t[n] = e[n];
                          return t
                      }
                      var o = Array.prototype.slice;
                      function s(t, e, a) {
                          if (!(this instanceof s))
                              return new s(t,e,a);
                          var c, l = t;
                          "string" == typeof t && (l = document.querySelectorAll(t)),
                          l ? (this.elements = (c = l,
                          Array.isArray(c) ? c : "object" == typeof c && "number" == typeof c.length ? o.call(c) : [c]),
                          this.options = i({}, this.options),
                          "function" == typeof e ? a = e : i(this.options, e),
                          a && this.on("always", a),
                          this.getImages(),
                          n && (this.jqDeferred = new n.Deferred),
                          setTimeout(this.check.bind(this))) : r.error("Bad element for imagesLoaded " + (l || t))
                      }
                      s.prototype = Object.create(e.prototype),
                      s.prototype.options = {},
                      s.prototype.getImages = function() {
                          this.images = [],
                          this.elements.forEach(this.addElementImages, this)
                      }
                      ,
                      s.prototype.addElementImages = function(t) {
                          "IMG" == t.nodeName && this.addImage(t),
                          !0 === this.options.background && this.addElementBackgroundImages(t);
                          var e = t.nodeType;
                          if (e && a[e]) {
                              for (var n = t.querySelectorAll("img"), r = 0; r < n.length; r++) {
                                  var i = n[r];
                                  this.addImage(i)
                              }
                              if ("string" == typeof this.options.background) {
                                  var o = t.querySelectorAll(this.options.background);
                                  for (r = 0; r < o.length; r++) {
                                      var s = o[r];
                                      this.addElementBackgroundImages(s)
                                  }
                              }
                          }
                      }
                      ;
                      var a = {
                          1: !0,
                          9: !0,
                          11: !0
                      };
                      function c(t) {
                          this.img = t
                      }
                      function l(t, e) {
                          this.url = t,
                          this.element = e,
                          this.img = new Image
                      }
                      return s.prototype.addElementBackgroundImages = function(t) {
                          var e = getComputedStyle(t);
                          if (e)
                              for (var n = /url\((['"])?(.*?)\1\)/gi, r = n.exec(e.backgroundImage); null !== r; ) {
                                  var i = r && r[2];
                                  i && this.addBackground(i, t),
                                  r = n.exec(e.backgroundImage)
                              }
                      }
                      ,
                      s.prototype.addImage = function(t) {
                          var e = new c(t);
                          this.images.push(e)
                      }
                      ,
                      s.prototype.addBackground = function(t, e) {
                          var n = new l(t,e);
                          this.images.push(n)
                      }
                      ,
                      s.prototype.check = function() {
                          var t = this;
                          function e(e, n, r) {
                              setTimeout((function() {
                                  t.progress(e, n, r)
                              }
                              ))
                          }
                          this.progressedCount = 0,
                          this.hasAnyBroken = !1,
                          this.images.length ? this.images.forEach((function(t) {
                              t.once("progress", e),
                              t.check()
                          }
                          )) : this.complete()
                      }
                      ,
                      s.prototype.progress = function(t, e, n) {
                          this.progressedCount++,
                          this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded,
                          this.emitEvent("progress", [this, t, e]),
                          this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
                          this.progressedCount == this.images.length && this.complete(),
                          this.options.debug && r && r.log("progress: " + n, t, e)
                      }
                      ,
                      s.prototype.complete = function() {
                          var t = this.hasAnyBroken ? "fail" : "done";
                          if (this.isComplete = !0,
                          this.emitEvent(t, [this]),
                          this.emitEvent("always", [this]),
                          this.jqDeferred) {
                              var e = this.hasAnyBroken ? "reject" : "resolve";
                              this.jqDeferred[e](this)
                          }
                      }
                      ,
                      c.prototype = Object.create(e.prototype),
                      c.prototype.check = function() {
                          this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image,
                          this.proxyImage.addEventListener("load", this),
                          this.proxyImage.addEventListener("error", this),
                          this.img.addEventListener("load", this),
                          this.img.addEventListener("error", this),
                          this.proxyImage.src = this.img.src)
                      }
                      ,
                      c.prototype.getIsImageComplete = function() {
                          return this.img.complete && this.img.naturalWidth
                      }
                      ,
                      c.prototype.confirm = function(t, e) {
                          this.isLoaded = t,
                          this.emitEvent("progress", [this, this.img, e])
                      }
                      ,
                      c.prototype.handleEvent = function(t) {
                          var e = "on" + t.type;
                          this[e] && this[e](t)
                      }
                      ,
                      c.prototype.onload = function() {
                          this.confirm(!0, "onload"),
                          this.unbindEvents()
                      }
                      ,
                      c.prototype.onerror = function() {
                          this.confirm(!1, "onerror"),
                          this.unbindEvents()
                      }
                      ,
                      c.prototype.unbindEvents = function() {
                          this.proxyImage.removeEventListener("load", this),
                          this.proxyImage.removeEventListener("error", this),
                          this.img.removeEventListener("load", this),
                          this.img.removeEventListener("error", this)
                      }
                      ,
                      l.prototype = Object.create(c.prototype),
                      l.prototype.check = function() {
                          this.img.addEventListener("load", this),
                          this.img.addEventListener("error", this),
                          this.img.src = this.url,
                          this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
                          this.unbindEvents())
                      }
                      ,
                      l.prototype.unbindEvents = function() {
                          this.img.removeEventListener("load", this),
                          this.img.removeEventListener("error", this)
                      }
                      ,
                      l.prototype.confirm = function(t, e) {
                          this.isLoaded = t,
                          this.emitEvent("progress", [this, this.element, e])
                      }
                      ,
                      s.makeJQueryPlugin = function(e) {
                          (e = e || t.jQuery) && ((n = e).fn.imagesLoaded = function(t, e) {
                              return new s(this,t,e).jqDeferred.promise(n(this))
                          }
                          )
                      }
                      ,
                      s.makeJQueryPlugin(),
                      s
                  }(o, t)
              }
              .apply(e, r),
              void 0 === i || (t.exports = i)
          }("undefined" != typeof window ? window : this)
      },
      1296: function(t, e, n) {
          var r = /^\s+|\s+$/g
            , i = /^[-+]0x[0-9a-f]+$/i
            , o = /^0b[01]+$/i
            , s = /^0o[0-7]+$/i
            , a = parseInt
            , c = "object" == typeof n.g && n.g && n.g.Object === Object && n.g
            , l = "object" == typeof self && self && self.Object === Object && self
            , u = c || l || Function("return this")()
            , h = Object.prototype.toString
            , f = Math.max
            , d = Math.min
            , p = function() {
              return u.Date.now()
          };
          function v(t) {
              var e = typeof t;
              return !!t && ("object" == e || "function" == e)
          }
          function m(t) {
              if ("number" == typeof t)
                  return t;
              if (function(t) {
                  return "symbol" == typeof t || function(t) {
                      return !!t && "object" == typeof t
                  }(t) && "[object Symbol]" == h.call(t)
              }(t))
                  return NaN;
              if (v(t)) {
                  var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                  t = v(e) ? e + "" : e
              }
              if ("string" != typeof t)
                  return 0 === t ? t : +t;
              t = t.replace(r, "");
              var n = o.test(t);
              return n || s.test(t) ? a(t.slice(2), n ? 2 : 8) : i.test(t) ? NaN : +t
          }
          t.exports = function(t, e, n) {
              var r, i, o, s, a, c, l = 0, u = !1, h = !1, g = !0;
              if ("function" != typeof t)
                  throw new TypeError("Expected a function");
              function y(e) {
                  var n = r
                    , o = i;
                  return r = i = void 0,
                  l = e,
                  s = t.apply(o, n)
              }
              function w(t) {
                  return l = t,
                  a = setTimeout(E, e),
                  u ? y(t) : s
              }
              function b(t) {
                  var n = t - c;
                  return void 0 === c || n >= e || n < 0 || h && t - l >= o
              }
              function E() {
                  var t = p();
                  if (b(t))
                      return x(t);
                  a = setTimeout(E, function(t) {
                      var n = e - (t - c);
                      return h ? d(n, o - (t - l)) : n
                  }(t))
              }
              function x(t) {
                  return a = void 0,
                  g && r ? y(t) : (r = i = void 0,
                  s)
              }
              function _() {
                  var t = p()
                    , n = b(t);
                  if (r = arguments,
                  i = this,
                  c = t,
                  n) {
                      if (void 0 === a)
                          return w(c);
                      if (h)
                          return a = setTimeout(E, e),
                          y(c)
                  }
                  return void 0 === a && (a = setTimeout(E, e)),
                  s
              }
              return e = m(e) || 0,
              v(n) && (u = !!n.leading,
              o = (h = "maxWait"in n) ? f(m(n.maxWait) || 0, e) : o,
              g = "trailing"in n ? !!n.trailing : g),
              _.cancel = function() {
                  void 0 !== a && clearTimeout(a),
                  l = 0,
                  r = c = i = a = void 0
              }
              ,
              _.flush = function() {
                  return void 0 === a ? s : x(p())
              }
              ,
              _
          }
      },
      3096: function(t, e, n) {
          var r = "Expected a function"
            , i = /^\s+|\s+$/g
            , o = /^[-+]0x[0-9a-f]+$/i
            , s = /^0b[01]+$/i
            , a = /^0o[0-7]+$/i
            , c = parseInt
            , l = "object" == typeof n.g && n.g && n.g.Object === Object && n.g
            , u = "object" == typeof self && self && self.Object === Object && self
            , h = l || u || Function("return this")()
            , f = Object.prototype.toString
            , d = Math.max
            , p = Math.min
            , v = function() {
              return h.Date.now()
          };
          function m(t) {
              var e = typeof t;
              return !!t && ("object" == e || "function" == e)
          }
          function g(t) {
              if ("number" == typeof t)
                  return t;
              if (function(t) {
                  return "symbol" == typeof t || function(t) {
                      return !!t && "object" == typeof t
                  }(t) && "[object Symbol]" == f.call(t)
              }(t))
                  return NaN;
              if (m(t)) {
                  var e = "function" == typeof t.valueOf ? t.valueOf() : t;
                  t = m(e) ? e + "" : e
              }
              if ("string" != typeof t)
                  return 0 === t ? t : +t;
              t = t.replace(i, "");
              var n = s.test(t);
              return n || a.test(t) ? c(t.slice(2), n ? 2 : 8) : o.test(t) ? NaN : +t
          }
          t.exports = function(t, e, n) {
              var i = !0
                , o = !0;
              if ("function" != typeof t)
                  throw new TypeError(r);
              return m(n) && (i = "leading"in n ? !!n.leading : i,
              o = "trailing"in n ? !!n.trailing : o),
              function(t, e, n) {
                  var i, o, s, a, c, l, u = 0, h = !1, f = !1, y = !0;
                  if ("function" != typeof t)
                      throw new TypeError(r);
                  function w(e) {
                      var n = i
                        , r = o;
                      return i = o = void 0,
                      u = e,
                      a = t.apply(r, n)
                  }
                  function b(t) {
                      return u = t,
                      c = setTimeout(x, e),
                      h ? w(t) : a
                  }
                  function E(t) {
                      var n = t - l;
                      return void 0 === l || n >= e || n < 0 || f && t - u >= s
                  }
                  function x() {
                      var t = v();
                      if (E(t))
                          return _(t);
                      c = setTimeout(x, function(t) {
                          var n = e - (t - l);
                          return f ? p(n, s - (t - u)) : n
                      }(t))
                  }
                  function _(t) {
                      return c = void 0,
                      y && i ? w(t) : (i = o = void 0,
                      a)
                  }
                  function k() {
                      var t = v()
                        , n = E(t);
                      if (i = arguments,
                      o = this,
                      l = t,
                      n) {
                          if (void 0 === c)
                              return b(l);
                          if (f)
                              return c = setTimeout(x, e),
                              w(l)
                      }
                      return void 0 === c && (c = setTimeout(x, e)),
                      a
                  }
                  return e = g(e) || 0,
                  m(n) && (h = !!n.leading,
                  s = (f = "maxWait"in n) ? d(g(n.maxWait) || 0, e) : s,
                  y = "trailing"in n ? !!n.trailing : y),
                  k.cancel = function() {
                      void 0 !== c && clearTimeout(c),
                      u = 0,
                      i = l = o = c = void 0
                  }
                  ,
                  k.flush = function() {
                      return void 0 === c ? a : _(v())
                  }
                  ,
                  k
              }(t, e, {
                  leading: i,
                  maxWait: e,
                  trailing: o
              })
          }
      },
      3746: function() {
          window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(t, e) {
              e = e || window;
              for (var n = 0; n < this.length; n++)
                  t.call(e, this[n], n, this)
          }
          )
      }
  }
    , e = {};
  function n(r) {
      var i = e[r];
      if (void 0 !== i)
          return i.exports;
      var o = e[r] = {
          exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n),
      o.exports
  }
  n.n = function(t) {
      var e = t && t.__esModule ? function() {
          return t.default
      }
      : function() {
          return t
      }
      ;
      return n.d(e, {
          a: e
      }),
      e
  }
  ,
  n.d = function(t, e) {
      for (var r in e)
          n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
              enumerable: !0,
              get: e[r]
          })
  }
  ,
  n.g = function() {
      if ("object" == typeof globalThis)
          return globalThis;
      try {
          return this || new Function("return this")()
      } catch (t) {
          if ("object" == typeof window)
              return window
      }
  }(),
  n.o = function(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e)
  }
  ,
  function() {
      "use strict";
      n(3746);
      var t = n(3096)
        , e = n.n(t)
        , r = n(1296)
        , i = n.n(r);
      function o(t, e) {
          if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function")
      }
      function s(t, e) {
          for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1,
              r.configurable = !0,
              "value"in r && (r.writable = !0),
              Object.defineProperty(t, r.key, r)
          }
      }
      function a(t, e, n) {
          return e && s(t.prototype, e),
          n && s(t, n),
          t
      }
      function c(t, e, n) {
          return e in t ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
          }) : t[e] = n,
          t
      }
      function l(t, e) {
          var n = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(t);
              e && (r = r.filter((function(e) {
                  return Object.getOwnPropertyDescriptor(t, e).enumerable
              }
              ))),
              n.push.apply(n, r)
          }
          return n
      }
      function u(t) {
          for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? l(Object(n), !0).forEach((function(e) {
                  c(t, e, n[e])
              }
              )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach((function(e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e))
              }
              ))
          }
          return t
      }
      function h(t, e) {
          if ("function" != typeof e && null !== e)
              throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
              constructor: {
                  value: t,
                  writable: !0,
                  configurable: !0
              }
          }),
          e && d(t, e)
      }
      function f(t) {
          return f = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
              return t.__proto__ || Object.getPrototypeOf(t)
          }
          ,
          f(t)
      }
      function d(t, e) {
          return d = Object.setPrototypeOf || function(t, e) {
              return t.__proto__ = e,
              t
          }
          ,
          d(t, e)
      }
      function p(t) {
          if (void 0 === t)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t
      }
      function v(t, e) {
          return !e || "object" != typeof e && "function" != typeof e ? p(t) : e
      }
      function m(t) {
          var e = function() {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                  return !1;
              if (Reflect.construct.sham)
                  return !1;
              if ("function" == typeof Proxy)
                  return !0;
              try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
                  ))),
                  !0
              } catch (t) {
                  return !1
              }
          }();
          return function() {
              var n, r = f(t);
              if (e) {
                  var i = f(this).constructor;
                  n = Reflect.construct(r, arguments, i)
              } else
                  n = r.apply(this, arguments);
              return v(this, n)
          }
      }
      function g(t, e, n) {
          return g = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(t, e, n) {
              var r = function(t, e) {
                  for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = f(t)); )
                      ;
                  return t
              }(t, e);
              if (r) {
                  var i = Object.getOwnPropertyDescriptor(r, e);
                  return i.get ? i.get.call(n) : i.value
              }
          }
          ,
          g(t, e, n || t)
      }
      function y(t, e) {
          return function(t) {
              if (Array.isArray(t))
                  return t
          }(t) || function(t, e) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                  var n = []
                    , r = !0
                    , i = !1
                    , o = void 0;
                  try {
                      for (var s, a = t[Symbol.iterator](); !(r = (s = a.next()).done) && (n.push(s.value),
                      !e || n.length !== e); r = !0)
                          ;
                  } catch (t) {
                      i = !0,
                      o = t
                  } finally {
                      try {
                          r || null == a.return || a.return()
                      } finally {
                          if (i)
                              throw o
                      }
                  }
                  return n
              }
          }(t, e) || b(t, e) || function() {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
          }()
      }
      function w(t) {
          return function(t) {
              if (Array.isArray(t))
                  return E(t)
          }(t) || function(t) {
              if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
                  return Array.from(t)
          }(t) || b(t) || function() {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
          }()
      }
      function b(t, e) {
          if (t) {
              if ("string" == typeof t)
                  return E(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name),
              "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? E(t, e) : void 0
          }
      }
      function E(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, r = new Array(e); n < e; n++)
              r[n] = t[n];
          return r
      }
      var x = {
          el: document,
          name: "scroll",
          offset: [0, 0],
          repeat: !1,
          smooth: !1,
          initPosition: {
              x: 0,
              y: 0
          },
          direction: "vertical",
          gestureDirection: "vertical",
          reloadOnContextChange: !1,
          lerp: .1,
          class: "is-inview",
          scrollbarContainer: !1,
          scrollbarClass: "c-scrollbar",
          scrollingClass: "has-scroll-scrolling",
          draggingClass: "has-scroll-dragging",
          smoothClass: "has-scroll-smooth",
          initClass: "has-scroll-init",
          getSpeed: !1,
          getDirection: !1,
          scrollFromAnywhere: !1,
          multiplier: 1,
          firefoxMultiplier: 50,
          touchMultiplier: 2,
          resetNativeScroll: !0,
          tablet: {
              smooth: !1,
              direction: "vertical",
              gestureDirection: "vertical",
              breakpoint: 1024
          },
          smartphone: {
              smooth: !1,
              direction: "vertical",
              gestureDirection: "vertical"
          }
      }
        , _ = function() {
          function t() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              o(this, t),
              Object.assign(this, x, e),
              this.smartphone = x.smartphone,
              e.smartphone && Object.assign(this.smartphone, e.smartphone),
              this.tablet = x.tablet,
              e.tablet && Object.assign(this.tablet, e.tablet),
              this.namespace = "locomotive",
              this.html = document.documentElement,
              this.windowHeight = window.innerHeight,
              this.windowWidth = window.innerWidth,
              this.windowMiddle = {
                  x: this.windowWidth / 2,
                  y: this.windowHeight / 2
              },
              this.els = {},
              this.currentElements = {},
              this.listeners = {},
              this.hasScrollTicking = !1,
              this.hasCallEventSet = !1,
              this.checkScroll = this.checkScroll.bind(this),
              this.checkResize = this.checkResize.bind(this),
              this.checkEvent = this.checkEvent.bind(this),
              this.instance = {
                  scroll: {
                      x: 0,
                      y: 0
                  },
                  limit: {
                      x: this.html.offsetWidth,
                      y: this.html.offsetHeight
                  },
                  currentElements: this.currentElements
              },
              this.isMobile ? this.isTablet ? this.context = "tablet" : this.context = "smartphone" : this.context = "desktop",
              this.isMobile && (this.direction = this[this.context].direction),
              "horizontal" === this.direction ? this.directionAxis = "x" : this.directionAxis = "y",
              this.getDirection && (this.instance.direction = null),
              this.getDirection && (this.instance.speed = 0),
              this.html.classList.add(this.initClass),
              window.addEventListener("resize", this.checkResize, !1)
          }
          return a(t, [{
              key: "init",
              value: function() {
                  this.initEvents()
              }
          }, {
              key: "checkScroll",
              value: function() {
                  this.dispatchScroll()
              }
          }, {
              key: "checkResize",
              value: function() {
                  var t = this;
                  this.resizeTick || (this.resizeTick = !0,
                  requestAnimationFrame((function() {
                      t.resize(),
                      t.resizeTick = !1
                  }
                  )))
              }
          }, {
              key: "resize",
              value: function() {}
          }, {
              key: "checkContext",
              value: function() {
                  if (this.reloadOnContextChange) {
                      this.isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 || this.windowWidth < this.tablet.breakpoint,
                      this.isTablet = this.isMobile && this.windowWidth >= this.tablet.breakpoint;
                      var t = this.context;
                      this.isMobile ? this.isTablet ? this.context = "tablet" : this.context = "smartphone" : this.context = "desktop",
                      t != this.context && ("desktop" == t ? this.smooth : this[t].smooth) != ("desktop" == this.context ? this.smooth : this[this.context].smooth) && window.location.reload()
                  }
              }
          }, {
              key: "initEvents",
              value: function() {
                  var t = this;
                  this.scrollToEls = this.el.querySelectorAll("[data-".concat(this.name, "-to]")),
                  this.setScrollTo = this.setScrollTo.bind(this),
                  this.scrollToEls.forEach((function(e) {
                      e.addEventListener("click", t.setScrollTo, !1)
                  }
                  ))
              }
          }, {
              key: "setScrollTo",
              value: function(t) {
                  t.preventDefault(),
                  this.scrollTo(t.currentTarget.getAttribute("data-".concat(this.name, "-href")) || t.currentTarget.getAttribute("href"), {
                      offset: t.currentTarget.getAttribute("data-".concat(this.name, "-offset"))
                  })
              }
          }, {
              key: "addElements",
              value: function() {}
          }, {
              key: "detectElements",
              value: function(t) {
                  var e = this
                    , n = this.instance.scroll.y
                    , r = n + this.windowHeight
                    , i = this.instance.scroll.x
                    , o = i + this.windowWidth;
                  Object.entries(this.els).forEach((function(s) {
                      var a = y(s, 2)
                        , c = a[0]
                        , l = a[1];
                      if (!l || l.inView && !t || ("horizontal" === e.direction ? o >= l.left && i < l.right && e.setInView(l, c) : r >= l.top && n < l.bottom && e.setInView(l, c)),
                      l && l.inView)
                          if ("horizontal" === e.direction) {
                              var u = l.right - l.left;
                              l.progress = (e.instance.scroll.x - (l.left - e.windowWidth)) / (u + e.windowWidth),
                              (o < l.left || i > l.right) && e.setOutOfView(l, c)
                          } else {
                              var h = l.bottom - l.top;
                              l.progress = (e.instance.scroll.y - (l.top - e.windowHeight)) / (h + e.windowHeight),
                              (r < l.top || n > l.bottom) && e.setOutOfView(l, c)
                          }
                  }
                  )),
                  this.hasScrollTicking = !1
              }
          }, {
              key: "setInView",
              value: function(t, e) {
                  this.els[e].inView = !0,
                  t.el.classList.add(t.class),
                  this.currentElements[e] = t,
                  t.call && this.hasCallEventSet && (this.dispatchCall(t, "enter"),
                  t.repeat || (this.els[e].call = !1))
              }
          }, {
              key: "setOutOfView",
              value: function(t, e) {
                  var n = this;
                  this.els[e].inView = !1,
                  Object.keys(this.currentElements).forEach((function(t) {
                      t === e && delete n.currentElements[t]
                  }
                  )),
                  t.call && this.hasCallEventSet && this.dispatchCall(t, "exit"),
                  t.repeat && t.el.classList.remove(t.class)
              }
          }, {
              key: "dispatchCall",
              value: function(t, e) {
                  this.callWay = e,
                  this.callValue = t.call.split(",").map((function(t) {
                      return t.trim()
                  }
                  )),
                  this.callObj = t,
                  1 == this.callValue.length && (this.callValue = this.callValue[0]);
                  var n = new Event(this.namespace + "call");
                  this.el.dispatchEvent(n)
              }
          }, {
              key: "dispatchScroll",
              value: function() {
                  var t = new Event(this.namespace + "scroll");
                  this.el.dispatchEvent(t)
              }
          }, {
              key: "setEvents",
              value: function(t, e) {
                  this.listeners[t] || (this.listeners[t] = []);
                  var n = this.listeners[t];
                  n.push(e),
                  1 === n.length && this.el.addEventListener(this.namespace + t, this.checkEvent, !1),
                  "call" === t && (this.hasCallEventSet = !0,
                  this.detectElements(!0))
              }
          }, {
              key: "unsetEvents",
              value: function(t, e) {
                  if (this.listeners[t]) {
                      var n = this.listeners[t]
                        , r = n.indexOf(e);
                      r < 0 || (n.splice(r, 1),
                      0 === n.index && this.el.removeEventListener(this.namespace + t, this.checkEvent, !1))
                  }
              }
          }, {
              key: "checkEvent",
              value: function(t) {
                  var e = this
                    , n = t.type.replace(this.namespace, "")
                    , r = this.listeners[n];
                  r && 0 !== r.length && r.forEach((function(t) {
                      switch (n) {
                      case "scroll":
                          return t(e.instance);
                      case "call":
                          return t(e.callValue, e.callWay, e.callObj);
                      default:
                          return t()
                      }
                  }
                  ))
              }
          }, {
              key: "startScroll",
              value: function() {}
          }, {
              key: "stopScroll",
              value: function() {}
          }, {
              key: "setScroll",
              value: function(t, e) {
                  this.instance.scroll = {
                      x: 0,
                      y: 0
                  }
              }
          }, {
              key: "destroy",
              value: function() {
                  var t = this;
                  window.removeEventListener("resize", this.checkResize, !1),
                  Object.keys(this.listeners).forEach((function(e) {
                      t.el.removeEventListener(t.namespace + e, t.checkEvent, !1)
                  }
                  )),
                  this.listeners = {},
                  this.scrollToEls.forEach((function(e) {
                      e.removeEventListener("click", t.setScrollTo, !1)
                  }
                  )),
                  this.html.classList.remove(this.initClass)
              }
          }]),
          t
      }()
        , k = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : "undefined" != typeof self ? self : {};
      function S(t, e) {
          return t(e = {
              exports: {}
          }, e.exports),
          e.exports
      }
      var T = S((function(t, e) {
          t.exports = {
              polyfill: function() {
                  var t = window
                    , e = document;
                  if (!("scrollBehavior"in e.documentElement.style) || !0 === t.__forceSmoothScrollPolyfill__) {
                      var n, r = t.HTMLElement || t.Element, i = {
                          scroll: t.scroll || t.scrollTo,
                          scrollBy: t.scrollBy,
                          elementScroll: r.prototype.scroll || a,
                          scrollIntoView: r.prototype.scrollIntoView
                      }, o = t.performance && t.performance.now ? t.performance.now.bind(t.performance) : Date.now, s = (n = t.navigator.userAgent,
                      new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(n) ? 1 : 0);
                      t.scroll = t.scrollTo = function() {
                          void 0 !== arguments[0] && (!0 !== c(arguments[0]) ? p.call(t, e.body, void 0 !== arguments[0].left ? ~~arguments[0].left : t.scrollX || t.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : t.scrollY || t.pageYOffset) : i.scroll.call(t, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : t.scrollX || t.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : t.scrollY || t.pageYOffset))
                      }
                      ,
                      t.scrollBy = function() {
                          void 0 !== arguments[0] && (c(arguments[0]) ? i.scrollBy.call(t, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : p.call(t, e.body, ~~arguments[0].left + (t.scrollX || t.pageXOffset), ~~arguments[0].top + (t.scrollY || t.pageYOffset)))
                      }
                      ,
                      r.prototype.scroll = r.prototype.scrollTo = function() {
                          if (void 0 !== arguments[0])
                              if (!0 !== c(arguments[0])) {
                                  var t = arguments[0].left
                                    , e = arguments[0].top;
                                  p.call(this, this, void 0 === t ? this.scrollLeft : ~~t, void 0 === e ? this.scrollTop : ~~e)
                              } else {
                                  if ("number" == typeof arguments[0] && void 0 === arguments[1])
                                      throw new SyntaxError("Value could not be converted");
                                  i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
                              }
                      }
                      ,
                      r.prototype.scrollBy = function() {
                          void 0 !== arguments[0] && (!0 !== c(arguments[0]) ? this.scroll({
                              left: ~~arguments[0].left + this.scrollLeft,
                              top: ~~arguments[0].top + this.scrollTop,
                              behavior: arguments[0].behavior
                          }) : i.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
                      }
                      ,
                      r.prototype.scrollIntoView = function() {
                          if (!0 !== c(arguments[0])) {
                              var n = f(this)
                                , r = n.getBoundingClientRect()
                                , o = this.getBoundingClientRect();
                              n !== e.body ? (p.call(this, n, n.scrollLeft + o.left - r.left, n.scrollTop + o.top - r.top),
                              "fixed" !== t.getComputedStyle(n).position && t.scrollBy({
                                  left: r.left,
                                  top: r.top,
                                  behavior: "smooth"
                              })) : t.scrollBy({
                                  left: o.left,
                                  top: o.top,
                                  behavior: "smooth"
                              })
                          } else
                              i.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
                      }
                  }
                  function a(t, e) {
                      this.scrollLeft = t,
                      this.scrollTop = e
                  }
                  function c(t) {
                      if (null === t || "object" != typeof t || void 0 === t.behavior || "auto" === t.behavior || "instant" === t.behavior)
                          return !0;
                      if ("object" == typeof t && "smooth" === t.behavior)
                          return !1;
                      throw new TypeError("behavior member of ScrollOptions " + t.behavior + " is not a valid value for enumeration ScrollBehavior.")
                  }
                  function l(t, e) {
                      return "Y" === e ? t.clientHeight + s < t.scrollHeight : "X" === e ? t.clientWidth + s < t.scrollWidth : void 0
                  }
                  function u(e, n) {
                      var r = t.getComputedStyle(e, null)["overflow" + n];
                      return "auto" === r || "scroll" === r
                  }
                  function h(t) {
                      var e = l(t, "Y") && u(t, "Y")
                        , n = l(t, "X") && u(t, "X");
                      return e || n
                  }
                  function f(t) {
                      for (; t !== e.body && !1 === h(t); )
                          t = t.parentNode || t.host;
                      return t
                  }
                  function d(e) {
                      var n, r, i, s, a = (o() - e.startTime) / 468;
                      s = a = a > 1 ? 1 : a,
                      n = .5 * (1 - Math.cos(Math.PI * s)),
                      r = e.startX + (e.x - e.startX) * n,
                      i = e.startY + (e.y - e.startY) * n,
                      e.method.call(e.scrollable, r, i),
                      r === e.x && i === e.y || t.requestAnimationFrame(d.bind(t, e))
                  }
                  function p(n, r, s) {
                      var c, l, u, h, f = o();
                      n === e.body ? (c = t,
                      l = t.scrollX || t.pageXOffset,
                      u = t.scrollY || t.pageYOffset,
                      h = i.scroll) : (c = n,
                      l = n.scrollLeft,
                      u = n.scrollTop,
                      h = a),
                      d({
                          scrollable: c,
                          method: h,
                          startTime: f,
                          startX: l,
                          startY: u,
                          x: r,
                          y: s
                      })
                  }
              }
          }
      }
      ))
        , A = (T.polyfill,
      function(t) {
          h(n, t);
          var e = m(n);
          function n() {
              var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return o(this, n),
              (t = e.call(this, r)).resetNativeScroll && (history.scrollRestoration && (history.scrollRestoration = "manual"),
              window.scrollTo(0, 0)),
              window.addEventListener("scroll", t.checkScroll, !1),
              void 0 === window.smoothscrollPolyfill && (window.smoothscrollPolyfill = T,
              window.smoothscrollPolyfill.polyfill()),
              t
          }
          return a(n, [{
              key: "init",
              value: function() {
                  this.instance.scroll.y = window.pageYOffset,
                  this.addElements(),
                  this.detectElements(),
                  g(f(n.prototype), "init", this).call(this)
              }
          }, {
              key: "checkScroll",
              value: function() {
                  var t = this;
                  g(f(n.prototype), "checkScroll", this).call(this),
                  this.getDirection && this.addDirection(),
                  this.getSpeed && (this.addSpeed(),
                  this.speedTs = Date.now()),
                  this.instance.scroll.y = window.pageYOffset,
                  Object.entries(this.els).length && (this.hasScrollTicking || (requestAnimationFrame((function() {
                      t.detectElements()
                  }
                  )),
                  this.hasScrollTicking = !0))
              }
          }, {
              key: "addDirection",
              value: function() {
                  window.pageYOffset > this.instance.scroll.y ? "down" !== this.instance.direction && (this.instance.direction = "down") : window.pageYOffset < this.instance.scroll.y && "up" !== this.instance.direction && (this.instance.direction = "up")
              }
          }, {
              key: "addSpeed",
              value: function() {
                  window.pageYOffset != this.instance.scroll.y ? this.instance.speed = (window.pageYOffset - this.instance.scroll.y) / Math.max(1, Date.now() - this.speedTs) : this.instance.speed = 0
              }
          }, {
              key: "resize",
              value: function() {
                  Object.entries(this.els).length && (this.windowHeight = window.innerHeight,
                  this.updateElements())
              }
          }, {
              key: "addElements",
              value: function() {
                  var t = this;
                  this.els = {},
                  this.el.querySelectorAll("[data-" + this.name + "]").forEach((function(e, n) {
                      e.getBoundingClientRect();
                      var r, i, o, s = e.dataset[t.name + "Class"] || t.class, a = "string" == typeof e.dataset[t.name + "Id"] ? e.dataset[t.name + "Id"] : n, c = "string" == typeof e.dataset[t.name + "Offset"] ? e.dataset[t.name + "Offset"].split(",") : t.offset, l = e.dataset[t.name + "Repeat"], u = e.dataset[t.name + "Call"], h = e.dataset[t.name + "Target"], f = (o = void 0 !== h ? document.querySelector("".concat(h)) : e).getBoundingClientRect();
                      r = f.top + t.instance.scroll.y,
                      i = f.left + t.instance.scroll.x;
                      var d = r + o.offsetHeight
                        , p = i + o.offsetWidth;
                      l = "false" != l && (null != l || t.repeat);
                      var v = t.getRelativeOffset(c)
                        , m = {
                          el: e,
                          targetEl: o,
                          id: a,
                          class: s,
                          top: r += v[0],
                          bottom: d -= v[1],
                          left: i,
                          right: p,
                          offset: c,
                          progress: 0,
                          repeat: l,
                          inView: !1,
                          call: u
                      };
                      t.els[a] = m,
                      e.classList.contains(s) && t.setInView(t.els[a], a)
                  }
                  ))
              }
          }, {
              key: "updateElements",
              value: function() {
                  var t = this;
                  Object.entries(this.els).forEach((function(e) {
                      var n = y(e, 2)
                        , r = n[0]
                        , i = n[1]
                        , o = i.targetEl.getBoundingClientRect().top + t.instance.scroll.y
                        , s = o + i.targetEl.offsetHeight
                        , a = t.getRelativeOffset(i.offset);
                      t.els[r].top = o + a[0],
                      t.els[r].bottom = s - a[1]
                  }
                  )),
                  this.hasScrollTicking = !1
              }
          }, {
              key: "getRelativeOffset",
              value: function(t) {
                  var e = [0, 0];
                  if (t)
                      for (var n = 0; n < t.length; n++)
                          "string" == typeof t[n] ? t[n].includes("%") ? e[n] = parseInt(t[n].replace("%", "") * this.windowHeight / 100) : e[n] = parseInt(t[n]) : e[n] = t[n];
                  return e
              }
          }, {
              key: "scrollTo",
              value: function(t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
                    , n = parseInt(e.offset) || 0
                    , r = !!e.callback && e.callback;
                  if ("string" == typeof t) {
                      if ("top" === t)
                          t = this.html;
                      else if ("bottom" === t)
                          t = this.html.offsetHeight - window.innerHeight;
                      else if (!(t = document.querySelector(t)))
                          return
                  } else if ("number" == typeof t)
                      t = parseInt(t);
                  else if (!t || !t.tagName)
                      return void console.warn("`target` parameter is not valid");
                  n = "number" != typeof t ? t.getBoundingClientRect().top + n + this.instance.scroll.y : t + n;
                  var i = function() {
                      return parseInt(window.pageYOffset) === parseInt(n)
                  };
                  if (r) {
                      if (i())
                          return void r();
                      var o = function t() {
                          i() && (window.removeEventListener("scroll", t),
                          r())
                      };
                      window.addEventListener("scroll", o)
                  }
                  window.scrollTo({
                      top: n,
                      behavior: "smooth"
                  })
              }
          }, {
              key: "update",
              value: function() {
                  this.addElements(),
                  this.detectElements()
              }
          }, {
              key: "destroy",
              value: function() {
                  g(f(n.prototype), "destroy", this).call(this),
                  window.removeEventListener("scroll", this.checkScroll, !1)
              }
          }]),
          n
      }(_))
        , L = Object.getOwnPropertySymbols
        , O = Object.prototype.hasOwnProperty
        , j = Object.prototype.propertyIsEnumerable;
      function P(t) {
          if (null == t)
              throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(t)
      }
      var M = function() {
          try {
              if (!Object.assign)
                  return !1;
              var t = new String("abc");
              if (t[5] = "de",
              "5" === Object.getOwnPropertyNames(t)[0])
                  return !1;
              for (var e = {}, n = 0; n < 10; n++)
                  e["_" + String.fromCharCode(n)] = n;
              if ("0123456789" !== Object.getOwnPropertyNames(e).map((function(t) {
                  return e[t]
              }
              )).join(""))
                  return !1;
              var r = {};
              return "abcdefghijklmnopqrst".split("").forEach((function(t) {
                  r[t] = t
              }
              )),
              "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("")
          } catch (t) {
              return !1
          }
      }() ? Object.assign : function(t, e) {
          for (var n, r, i = P(t), o = 1; o < arguments.length; o++) {
              for (var s in n = Object(arguments[o]))
                  O.call(n, s) && (i[s] = n[s]);
              if (L) {
                  r = L(n);
                  for (var a = 0; a < r.length; a++)
                      j.call(n, r[a]) && (i[r[a]] = n[r[a]])
              }
          }
          return i
      }
      ;
      function C() {}
      C.prototype = {
          on: function(t, e, n) {
              var r = this.e || (this.e = {});
              return (r[t] || (r[t] = [])).push({
                  fn: e,
                  ctx: n
              }),
              this
          },
          once: function(t, e, n) {
              var r = this;
              function i() {
                  r.off(t, i),
                  e.apply(n, arguments)
              }
              return i._ = e,
              this.on(t, i, n)
          },
          emit: function(t) {
              for (var e = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[t] || []).slice(), r = 0, i = n.length; r < i; r++)
                  n[r].fn.apply(n[r].ctx, e);
              return this
          },
          off: function(t, e) {
              var n = this.e || (this.e = {})
                , r = n[t]
                , i = [];
              if (r && e)
                  for (var o = 0, s = r.length; o < s; o++)
                      r[o].fn !== e && r[o].fn._ !== e && i.push(r[o]);
              return i.length ? n[t] = i : delete n[t],
              this
          }
      };
      var R = C
        , I = S((function(t, e) {
          (function() {
              (null !== e ? e : this).Lethargy = function() {
                  function t(t, e, n, r) {
                      this.stability = null != t ? Math.abs(t) : 8,
                      this.sensitivity = null != e ? 1 + Math.abs(e) : 100,
                      this.tolerance = null != n ? 1 + Math.abs(n) : 1.1,
                      this.delay = null != r ? r : 150,
                      this.lastUpDeltas = function() {
                          var t, e, n;
                          for (n = [],
                          t = 1,
                          e = 2 * this.stability; 1 <= e ? t <= e : t >= e; 1 <= e ? t++ : t--)
                              n.push(null);
                          return n
                      }
                      .call(this),
                      this.lastDownDeltas = function() {
                          var t, e, n;
                          for (n = [],
                          t = 1,
                          e = 2 * this.stability; 1 <= e ? t <= e : t >= e; 1 <= e ? t++ : t--)
                              n.push(null);
                          return n
                      }
                      .call(this),
                      this.deltasTimestamp = function() {
                          var t, e, n;
                          for (n = [],
                          t = 1,
                          e = 2 * this.stability; 1 <= e ? t <= e : t >= e; 1 <= e ? t++ : t--)
                              n.push(null);
                          return n
                      }
                      .call(this)
                  }
                  return t.prototype.check = function(t) {
                      var e;
                      return null != (t = t.originalEvent || t).wheelDelta ? e = t.wheelDelta : null != t.deltaY ? e = -40 * t.deltaY : null == t.detail && 0 !== t.detail || (e = -40 * t.detail),
                      this.deltasTimestamp.push(Date.now()),
                      this.deltasTimestamp.shift(),
                      e > 0 ? (this.lastUpDeltas.push(e),
                      this.lastUpDeltas.shift(),
                      this.isInertia(1)) : (this.lastDownDeltas.push(e),
                      this.lastDownDeltas.shift(),
                      this.isInertia(-1))
                  }
                  ,
                  t.prototype.isInertia = function(t) {
                      var e, n, r, i, o, s, a;
                      return null === (e = -1 === t ? this.lastDownDeltas : this.lastUpDeltas)[0] ? t : !(this.deltasTimestamp[2 * this.stability - 2] + this.delay > Date.now() && e[0] === e[2 * this.stability - 1]) && (r = e.slice(0, this.stability),
                      n = e.slice(this.stability, 2 * this.stability),
                      a = r.reduce((function(t, e) {
                          return t + e
                      }
                      )),
                      o = n.reduce((function(t, e) {
                          return t + e
                      }
                      )),
                      s = a / r.length,
                      i = o / n.length,
                      Math.abs(s) < Math.abs(i * this.tolerance) && this.sensitivity < Math.abs(i) && t)
                  }
                  ,
                  t.prototype.showLastUpDeltas = function() {
                      return this.lastUpDeltas
                  }
                  ,
                  t.prototype.showLastDownDeltas = function() {
                      return this.lastDownDeltas
                  }
                  ,
                  t
              }()
          }
          ).call(k)
      }
      ))
        , q = "onwheel"in document
        , D = "onmousewheel"in document
        , F = "ontouchstart"in window || window.TouchEvent || window.DocumentTouch && document instanceof DocumentTouch
        , B = navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1
        , H = !!window.navigator.msPointerEnabled
        , N = "onkeydown"in document
        , z = navigator.userAgent.indexOf("Firefox") > -1
        , W = Object.prototype.toString
        , Y = Object.prototype.hasOwnProperty;
      function V(t, e) {
          return function() {
              return t.apply(e, arguments)
          }
      }
      var U = I.Lethargy
        , X = "virtualscroll"
        , $ = G;
      function G(t) {
          !function(t) {
              if (!t)
                  return console.warn("bindAll requires at least one argument.");
              var e = Array.prototype.slice.call(arguments, 1);
              if (0 === e.length)
                  for (var n in t)
                      Y.call(t, n) && "function" == typeof t[n] && "[object Function]" == W.call(t[n]) && e.push(n);
              for (var r = 0; r < e.length; r++) {
                  var i = e[r];
                  t[i] = V(t[i], t)
              }
          }(this, "_onWheel", "_onMouseWheel", "_onTouchStart", "_onTouchMove", "_onKeyDown"),
          this.el = window,
          t && t.el && (this.el = t.el,
          delete t.el),
          this.options = M({
              mouseMultiplier: 1,
              touchMultiplier: 2,
              firefoxMultiplier: 15,
              keyStep: 120,
              preventTouch: !1,
              unpreventTouchClass: "vs-touchmove-allowed",
              limitInertia: !1,
              useKeyboard: !0,
              useTouch: !0
          }, t),
          this.options.limitInertia && (this._lethargy = new U),
          this._emitter = new R,
          this._event = {
              y: 0,
              x: 0,
              deltaX: 0,
              deltaY: 0
          },
          this.touchStartX = null,
          this.touchStartY = null,
          this.bodyTouchAction = null,
          void 0 !== this.options.passive && (this.listenerOptions = {
              passive: this.options.passive
          })
      }
      function K(t, e, n) {
          return (1 - n) * t + n * e
      }
      function Q(t) {
          var e = {};
          if (window.getComputedStyle) {
              var n = getComputedStyle(t)
                , r = n.transform || n.webkitTransform || n.mozTransform
                , i = r.match(/^matrix3d\((.+)\)$/);
              return i ? (e.x = i ? parseFloat(i[1].split(", ")[12]) : 0,
              e.y = i ? parseFloat(i[1].split(", ")[13]) : 0) : (i = r.match(/^matrix\((.+)\)$/),
              e.x = i ? parseFloat(i[1].split(", ")[4]) : 0,
              e.y = i ? parseFloat(i[1].split(", ")[5]) : 0),
              e
          }
      }
      function J(t) {
          for (var e = []; t && t !== document; t = t.parentNode)
              e.push(t);
          return e
      }
      G.prototype._notify = function(t) {
          var e = this._event;
          e.x += e.deltaX,
          e.y += e.deltaY,
          this._emitter.emit(X, {
              x: e.x,
              y: e.y,
              deltaX: e.deltaX,
              deltaY: e.deltaY,
              originalEvent: t
          })
      }
      ,
      G.prototype._onWheel = function(t) {
          var e = this.options;
          if (!this._lethargy || !1 !== this._lethargy.check(t)) {
              var n = this._event;
              n.deltaX = t.wheelDeltaX || -1 * t.deltaX,
              n.deltaY = t.wheelDeltaY || -1 * t.deltaY,
              z && 1 == t.deltaMode && (n.deltaX *= e.firefoxMultiplier,
              n.deltaY *= e.firefoxMultiplier),
              n.deltaX *= e.mouseMultiplier,
              n.deltaY *= e.mouseMultiplier,
              this._notify(t)
          }
      }
      ,
      G.prototype._onMouseWheel = function(t) {
          if (!this.options.limitInertia || !1 !== this._lethargy.check(t)) {
              var e = this._event;
              e.deltaX = t.wheelDeltaX ? t.wheelDeltaX : 0,
              e.deltaY = t.wheelDeltaY ? t.wheelDeltaY : t.wheelDelta,
              this._notify(t)
          }
      }
      ,
      G.prototype._onTouchStart = function(t) {
          var e = t.targetTouches ? t.targetTouches[0] : t;
          this.touchStartX = e.pageX,
          this.touchStartY = e.pageY
      }
      ,
      G.prototype._onTouchMove = function(t) {
          var e = this.options;
          e.preventTouch && !t.target.classList.contains(e.unpreventTouchClass) && t.preventDefault();
          var n = this._event
            , r = t.targetTouches ? t.targetTouches[0] : t;
          n.deltaX = (r.pageX - this.touchStartX) * e.touchMultiplier,
          n.deltaY = (r.pageY - this.touchStartY) * e.touchMultiplier,
          this.touchStartX = r.pageX,
          this.touchStartY = r.pageY,
          this._notify(t)
      }
      ,
      G.prototype._onKeyDown = function(t) {
          var e = this._event;
          e.deltaX = e.deltaY = 0;
          var n = window.innerHeight - 40;
          switch (t.keyCode) {
          case 37:
          case 38:
              e.deltaY = this.options.keyStep;
              break;
          case 39:
          case 40:
              e.deltaY = -this.options.keyStep;
              break;
          case t.shiftKey:
              e.deltaY = n;
              break;
          case 32:
              e.deltaY = -n;
              break;
          default:
              return
          }
          this._notify(t)
      }
      ,
      G.prototype._bind = function() {
          q && this.el.addEventListener("wheel", this._onWheel, this.listenerOptions),
          D && this.el.addEventListener("mousewheel", this._onMouseWheel, this.listenerOptions),
          F && this.options.useTouch && (this.el.addEventListener("touchstart", this._onTouchStart, this.listenerOptions),
          this.el.addEventListener("touchmove", this._onTouchMove, this.listenerOptions)),
          H && B && (this.bodyTouchAction = document.body.style.msTouchAction,
          document.body.style.msTouchAction = "none",
          this.el.addEventListener("MSPointerDown", this._onTouchStart, !0),
          this.el.addEventListener("MSPointerMove", this._onTouchMove, !0)),
          N && this.options.useKeyboard && document.addEventListener("keydown", this._onKeyDown)
      }
      ,
      G.prototype._unbind = function() {
          q && this.el.removeEventListener("wheel", this._onWheel),
          D && this.el.removeEventListener("mousewheel", this._onMouseWheel),
          F && (this.el.removeEventListener("touchstart", this._onTouchStart),
          this.el.removeEventListener("touchmove", this._onTouchMove)),
          H && B && (document.body.style.msTouchAction = this.bodyTouchAction,
          this.el.removeEventListener("MSPointerDown", this._onTouchStart, !0),
          this.el.removeEventListener("MSPointerMove", this._onTouchMove, !0)),
          N && this.options.useKeyboard && document.removeEventListener("keydown", this._onKeyDown)
      }
      ,
      G.prototype.on = function(t, e) {
          this._emitter.on(X, t, e);
          var n = this._emitter.e;
          n && n[X] && 1 === n[X].length && this._bind()
      }
      ,
      G.prototype.off = function(t, e) {
          this._emitter.off(X, t, e);
          var n = this._emitter.e;
          (!n[X] || n[X].length <= 0) && this._unbind()
      }
      ,
      G.prototype.reset = function() {
          var t = this._event;
          t.x = 0,
          t.y = 0
      }
      ,
      G.prototype.destroy = function() {
          this._emitter.off(),
          this._unbind()
      }
      ;
      var Z = .1
        , tt = "function" == typeof Float32Array;
      function et(t, e) {
          return 1 - 3 * e + 3 * t
      }
      function nt(t, e) {
          return 3 * e - 6 * t
      }
      function rt(t) {
          return 3 * t
      }
      function it(t, e, n) {
          return ((et(e, n) * t + nt(e, n)) * t + rt(e)) * t
      }
      function ot(t, e, n) {
          return 3 * et(e, n) * t * t + 2 * nt(e, n) * t + rt(e)
      }
      function st(t) {
          return t
      }
      var at = function(t, e, n, r) {
          if (!(0 <= t && t <= 1 && 0 <= n && n <= 1))
              throw new Error("bezier x values must be in [0, 1] range");
          if (t === e && n === r)
              return st;
          for (var i = tt ? new Float32Array(11) : new Array(11), o = 0; o < 11; ++o)
              i[o] = it(o * Z, t, n);
          return function(o) {
              return 0 === o ? 0 : 1 === o ? 1 : it(function(e) {
                  for (var r = 0, o = 1; 10 !== o && i[o] <= e; ++o)
                      r += Z;
                  --o;
                  var s = r + (e - i[o]) / (i[o + 1] - i[o]) * Z
                    , a = ot(s, t, n);
                  return a >= .001 ? function(t, e, n, r) {
                      for (var i = 0; i < 4; ++i) {
                          var o = ot(e, n, r);
                          if (0 === o)
                              return e;
                          e -= (it(e, n, r) - t) / o
                      }
                      return e
                  }(e, s, t, n) : 0 === a ? s : function(t, e, n, r, i) {
                      var o, s, a = 0;
                      do {
                          (o = it(s = e + (n - e) / 2, r, i) - t) > 0 ? n = s : e = s
                      } while (Math.abs(o) > 1e-7 && ++a < 10);
                      return s
                  }(e, r, r + Z, t, n)
              }(o), e, r)
          }
      }
        , ct = function(t) {
          h(n, t);
          var e = m(n);
          function n() {
              var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return o(this, n),
              history.scrollRestoration && (history.scrollRestoration = "manual"),
              window.scrollTo(0, 0),
              (t = e.call(this, r)).inertia && (t.lerp = .1 * t.inertia),
              t.isScrolling = !1,
              t.isDraggingScrollbar = !1,
              t.isTicking = !1,
              t.hasScrollTicking = !1,
              t.parallaxElements = {},
              t.stop = !1,
              t.scrollbarContainer = r.scrollbarContainer,
              t.checkKey = t.checkKey.bind(p(t)),
              window.addEventListener("keydown", t.checkKey, !1),
              t
          }
          return a(n, [{
              key: "init",
              value: function() {
                  var t = this;
                  this.html.classList.add(this.smoothClass),
                  this.html.setAttribute("data-".concat(this.name, "-direction"), this.direction),
                  this.instance = u({
                      delta: {
                          x: this.initPosition.x,
                          y: this.initPosition.y
                      },
                      scroll: {
                          x: this.initPosition.x,
                          y: this.initPosition.y
                      }
                  }, this.instance),
                  this.vs = new $({
                      el: this.scrollFromAnywhere ? document : this.el,
                      mouseMultiplier: navigator.platform.indexOf("Win") > -1 ? 1 : .4,
                      firefoxMultiplier: this.firefoxMultiplier,
                      touchMultiplier: this.touchMultiplier,
                      useKeyboard: !1,
                      passive: !0
                  }),
                  this.vs.on((function(e) {
                      t.stop || t.isDraggingScrollbar || requestAnimationFrame((function() {
                          t.updateDelta(e),
                          t.isScrolling || t.startScrolling()
                      }
                      ))
                  }
                  )),
                  this.setScrollLimit(),
                  this.initScrollBar(),
                  this.addSections(),
                  this.addElements(),
                  this.checkScroll(!0),
                  this.transformElements(!0, !0),
                  g(f(n.prototype), "init", this).call(this)
              }
          }, {
              key: "setScrollLimit",
              value: function() {
                  if (this.instance.limit.y = this.el.offsetHeight - this.windowHeight,
                  "horizontal" === this.direction) {
                      for (var t = 0, e = this.el.children, n = 0; n < e.length; n++)
                          t += e[n].offsetWidth;
                      this.instance.limit.x = t - this.windowWidth
                  }
              }
          }, {
              key: "startScrolling",
              value: function() {
                  this.startScrollTs = Date.now(),
                  this.isScrolling = !0,
                  this.checkScroll(),
                  this.html.classList.add(this.scrollingClass)
              }
          }, {
              key: "stopScrolling",
              value: function() {
                  cancelAnimationFrame(this.checkScrollRaf),
                  this.scrollToRaf && (cancelAnimationFrame(this.scrollToRaf),
                  this.scrollToRaf = null),
                  this.isScrolling = !1,
                  this.instance.scroll.y = Math.round(this.instance.scroll.y),
                  this.html.classList.remove(this.scrollingClass)
              }
          }, {
              key: "checkKey",
              value: function(t) {
                  var e = this;
                  if (this.stop)
                      9 == t.keyCode && requestAnimationFrame((function() {
                          e.html.scrollTop = 0,
                          document.body.scrollTop = 0,
                          e.html.scrollLeft = 0,
                          document.body.scrollLeft = 0
                      }
                      ));
                  else {
                      switch (t.keyCode) {
                      case 9:
                          requestAnimationFrame((function() {
                              e.html.scrollTop = 0,
                              document.body.scrollTop = 0,
                              e.html.scrollLeft = 0,
                              document.body.scrollLeft = 0,
                              e.scrollTo(document.activeElement, {
                                  offset: -window.innerHeight / 2
                              })
                          }
                          ));
                          break;
                      case 38:
                          this.instance.delta[this.directionAxis] -= 240;
                          break;
                      case 40:
                          this.instance.delta[this.directionAxis] += 240;
                          break;
                      case 33:
                          this.instance.delta[this.directionAxis] -= window.innerHeight;
                          break;
                      case 34:
                          this.instance.delta[this.directionAxis] += window.innerHeight;
                          break;
                      case 36:
                          this.instance.delta[this.directionAxis] -= this.instance.limit[this.directionAxis];
                          break;
                      case 35:
                          this.instance.delta[this.directionAxis] += this.instance.limit[this.directionAxis];
                          break;
                      case 32:
                          document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLTextAreaElement || (t.shiftKey ? this.instance.delta[this.directionAxis] -= window.innerHeight : this.instance.delta[this.directionAxis] += window.innerHeight);
                          break;
                      default:
                          return
                      }
                      this.instance.delta[this.directionAxis] < 0 && (this.instance.delta[this.directionAxis] = 0),
                      this.instance.delta[this.directionAxis] > this.instance.limit[this.directionAxis] && (this.instance.delta[this.directionAxis] = this.instance.limit[this.directionAxis]),
                      this.stopScrolling(),
                      this.isScrolling = !0,
                      this.checkScroll(),
                      this.html.classList.add(this.scrollingClass)
                  }
              }
          }, {
              key: "checkScroll",
              value: function() {
                  var t = this
                    , e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                  if (e || this.isScrolling || this.isDraggingScrollbar) {
                      this.hasScrollTicking || (this.checkScrollRaf = requestAnimationFrame((function() {
                          return t.checkScroll()
                      }
                      )),
                      this.hasScrollTicking = !0),
                      this.updateScroll();
                      var r = Math.abs(this.instance.delta[this.directionAxis] - this.instance.scroll[this.directionAxis])
                        , i = Date.now() - this.startScrollTs;
                      if (!this.animatingScroll && i > 100 && (r < .5 && 0 != this.instance.delta[this.directionAxis] || r < .5 && 0 == this.instance.delta[this.directionAxis]) && this.stopScrolling(),
                      Object.entries(this.sections).forEach((function(n) {
                          var r = y(n, 2)
                            , i = (r[0],
                          r[1]);
                          i.persistent || t.instance.scroll[t.directionAxis] > i.offset[t.directionAxis] && t.instance.scroll[t.directionAxis] < i.limit[t.directionAxis] ? ("horizontal" === t.direction ? t.transform(i.el, -t.instance.scroll[t.directionAxis], 0) : t.transform(i.el, 0, -t.instance.scroll[t.directionAxis]),
                          i.inView || (i.inView = !0,
                          i.el.style.opacity = 1,
                          i.el.style.pointerEvents = "all",
                          i.el.setAttribute("data-".concat(t.name, "-section-inview"), ""))) : ((i.inView || e) && (i.inView = !1,
                          i.el.style.opacity = 0,
                          i.el.style.pointerEvents = "none",
                          i.el.removeAttribute("data-".concat(t.name, "-section-inview"))),
                          t.transform(i.el, 0, 0))
                      }
                      )),
                      this.getDirection && this.addDirection(),
                      this.getSpeed && (this.addSpeed(),
                      this.speedTs = Date.now()),
                      this.detectElements(),
                      this.transformElements(),
                      this.hasScrollbar) {
                          var o = this.instance.scroll[this.directionAxis] / this.instance.limit[this.directionAxis] * this.scrollBarLimit[this.directionAxis];
                          "horizontal" === this.direction ? this.transform(this.scrollbarThumb, o, 0) : this.transform(this.scrollbarThumb, 0, o)
                      }
                      g(f(n.prototype), "checkScroll", this).call(this),
                      this.hasScrollTicking = !1
                  }
              }
          }, {
              key: "resize",
              value: function() {
                  this.windowHeight = window.innerHeight,
                  this.windowWidth = window.innerWidth,
                  this.checkContext(),
                  this.windowMiddle = {
                      x: this.windowWidth / 2,
                      y: this.windowHeight / 2
                  },
                  this.update()
              }
          }, {
              key: "updateDelta",
              value: function(t) {
                  var e, n = this[this.context] && this[this.context].gestureDirection ? this[this.context].gestureDirection : this.gestureDirection;
                  e = "both" === n ? t.deltaX + t.deltaY : "vertical" === n ? t.deltaY : "horizontal" === n ? t.deltaX : t.deltaY,
                  this.instance.delta[this.directionAxis] -= e * this.multiplier,
                  this.instance.delta[this.directionAxis] < 0 && (this.instance.delta[this.directionAxis] = 0),
                  this.instance.delta[this.directionAxis] > this.instance.limit[this.directionAxis] && (this.instance.delta[this.directionAxis] = this.instance.limit[this.directionAxis])
              }
          }, {
              key: "updateScroll",
              value: function(t) {
                  this.isScrolling || this.isDraggingScrollbar ? this.instance.scroll[this.directionAxis] = K(this.instance.scroll[this.directionAxis], this.instance.delta[this.directionAxis], this.lerp) : this.instance.scroll[this.directionAxis] > this.instance.limit[this.directionAxis] ? this.setScroll(this.instance.scroll[this.directionAxis], this.instance.limit[this.directionAxis]) : this.instance.scroll.y < 0 ? this.setScroll(this.instance.scroll[this.directionAxis], 0) : this.setScroll(this.instance.scroll[this.directionAxis], this.instance.delta[this.directionAxis])
              }
          }, {
              key: "addDirection",
              value: function() {
                  this.instance.delta.y > this.instance.scroll.y ? "down" !== this.instance.direction && (this.instance.direction = "down") : this.instance.delta.y < this.instance.scroll.y && "up" !== this.instance.direction && (this.instance.direction = "up"),
                  this.instance.delta.x > this.instance.scroll.x ? "right" !== this.instance.direction && (this.instance.direction = "right") : this.instance.delta.x < this.instance.scroll.x && "left" !== this.instance.direction && (this.instance.direction = "left")
              }
          }, {
              key: "addSpeed",
              value: function() {
                  this.instance.delta[this.directionAxis] != this.instance.scroll[this.directionAxis] ? this.instance.speed = (this.instance.delta[this.directionAxis] - this.instance.scroll[this.directionAxis]) / Math.max(1, Date.now() - this.speedTs) : this.instance.speed = 0
              }
          }, {
              key: "initScrollBar",
              value: function() {
                  if (this.scrollbar = document.createElement("span"),
                  this.scrollbarThumb = document.createElement("span"),
                  this.scrollbar.classList.add("".concat(this.scrollbarClass)),
                  this.scrollbarThumb.classList.add("".concat(this.scrollbarClass, "_thumb")),
                  this.scrollbar.append(this.scrollbarThumb),
                  this.scrollbarContainer ? this.scrollbarContainer.append(this.scrollbar) : document.body.append(this.scrollbar),
                  this.getScrollBar = this.getScrollBar.bind(this),
                  this.releaseScrollBar = this.releaseScrollBar.bind(this),
                  this.moveScrollBar = this.moveScrollBar.bind(this),
                  this.scrollbarThumb.addEventListener("mousedown", this.getScrollBar),
                  window.addEventListener("mouseup", this.releaseScrollBar),
                  window.addEventListener("mousemove", this.moveScrollBar),
                  this.hasScrollbar = !1,
                  "horizontal" == this.direction) {
                      if (this.instance.limit.x + this.windowWidth <= this.windowWidth)
                          return
                  } else if (this.instance.limit.y + this.windowHeight <= this.windowHeight)
                      return;
                  this.hasScrollbar = !0,
                  this.scrollbarBCR = this.scrollbar.getBoundingClientRect(),
                  this.scrollbarHeight = this.scrollbarBCR.height,
                  this.scrollbarWidth = this.scrollbarBCR.width,
                  "horizontal" === this.direction ? this.scrollbarThumb.style.width = "".concat(this.scrollbarWidth * this.scrollbarWidth / (this.instance.limit.x + this.scrollbarWidth), "px") : this.scrollbarThumb.style.height = "".concat(this.scrollbarHeight * this.scrollbarHeight / (this.instance.limit.y + this.scrollbarHeight), "px"),
                  this.scrollbarThumbBCR = this.scrollbarThumb.getBoundingClientRect(),
                  this.scrollBarLimit = {
                      x: this.scrollbarWidth - this.scrollbarThumbBCR.width,
                      y: this.scrollbarHeight - this.scrollbarThumbBCR.height
                  }
              }
          }, {
              key: "reinitScrollBar",
              value: function() {
                  if (this.hasScrollbar = !1,
                  "horizontal" == this.direction) {
                      if (this.instance.limit.x + this.windowWidth <= this.windowWidth)
                          return
                  } else if (this.instance.limit.y + this.windowHeight <= this.windowHeight)
                      return;
                  this.hasScrollbar = !0,
                  this.scrollbarBCR = this.scrollbar.getBoundingClientRect(),
                  this.scrollbarHeight = this.scrollbarBCR.height,
                  this.scrollbarWidth = this.scrollbarBCR.width,
                  "horizontal" === this.direction ? this.scrollbarThumb.style.width = "".concat(this.scrollbarWidth * this.scrollbarWidth / (this.instance.limit.x + this.scrollbarWidth), "px") : this.scrollbarThumb.style.height = "".concat(this.scrollbarHeight * this.scrollbarHeight / (this.instance.limit.y + this.scrollbarHeight), "px"),
                  this.scrollbarThumbBCR = this.scrollbarThumb.getBoundingClientRect(),
                  this.scrollBarLimit = {
                      x: this.scrollbarWidth - this.scrollbarThumbBCR.width,
                      y: this.scrollbarHeight - this.scrollbarThumbBCR.height
                  }
              }
          }, {
              key: "destroyScrollBar",
              value: function() {
                  this.scrollbarThumb.removeEventListener("mousedown", this.getScrollBar),
                  window.removeEventListener("mouseup", this.releaseScrollBar),
                  window.removeEventListener("mousemove", this.moveScrollBar),
                  this.scrollbar.remove()
              }
          }, {
              key: "getScrollBar",
              value: function(t) {
                  this.isDraggingScrollbar = !0,
                  this.checkScroll(),
                  this.html.classList.remove(this.scrollingClass),
                  this.html.classList.add(this.draggingClass)
              }
          }, {
              key: "releaseScrollBar",
              value: function(t) {
                  this.isDraggingScrollbar = !1,
                  this.html.classList.add(this.scrollingClass),
                  this.html.classList.remove(this.draggingClass)
              }
          }, {
              key: "moveScrollBar",
              value: function(t) {
                  var e = this;
                  this.isDraggingScrollbar && requestAnimationFrame((function() {
                      var n = 100 * (t.clientX - e.scrollbarBCR.left) / e.scrollbarWidth * e.instance.limit.x / 100
                        , r = 100 * (t.clientY - e.scrollbarBCR.top) / e.scrollbarHeight * e.instance.limit.y / 100;
                      r > 0 && r < e.instance.limit.y && (e.instance.delta.y = r),
                      n > 0 && n < e.instance.limit.x && (e.instance.delta.x = n)
                  }
                  ))
              }
          }, {
              key: "addElements",
              value: function() {
                  var t = this;
                  this.els = {},
                  this.parallaxElements = {},
                  this.el.querySelectorAll("[data-".concat(this.name, "]")).forEach((function(e, n) {
                      var r, i, o, s = J(e), a = Object.entries(t.sections).map((function(t) {
                          var e = y(t, 2);
                          return e[0],
                          e[1]
                      }
                      )).find((function(t) {
                          return s.includes(t.el)
                      }
                      )), c = e.dataset[t.name + "Class"] || t.class, l = "string" == typeof e.dataset[t.name + "Id"] ? e.dataset[t.name + "Id"] : "el" + n, u = e.dataset[t.name + "Repeat"], h = e.dataset[t.name + "Call"], f = e.dataset[t.name + "Position"], d = e.dataset[t.name + "Delay"], p = e.dataset[t.name + "Direction"], v = "string" == typeof e.dataset[t.name + "Sticky"], m = !!e.dataset[t.name + "Speed"] && parseFloat(e.dataset[t.name + "Speed"]) / 10, g = "string" == typeof e.dataset[t.name + "Offset"] ? e.dataset[t.name + "Offset"].split(",") : t.offset, w = e.dataset[t.name + "Target"], b = (o = void 0 !== w ? document.querySelector("".concat(w)) : e).getBoundingClientRect();
                      null === a || a.inView ? (r = b.top + t.instance.scroll.y - Q(o).y,
                      i = b.left + t.instance.scroll.x - Q(o).x) : (r = b.top - Q(a.el).y - Q(o).y,
                      i = b.left - Q(a.el).x - Q(o).x);
                      var E = r + o.offsetHeight
                        , x = i + o.offsetWidth
                        , _ = {
                          x: (x - i) / 2 + i,
                          y: (E - r) / 2 + r
                      };
                      if (v) {
                          var k = e.getBoundingClientRect()
                            , S = k.top
                            , T = k.left
                            , A = {
                              x: T - i,
                              y: S - r
                          };
                          r += window.innerHeight,
                          i += window.innerWidth,
                          E = S + o.offsetHeight - e.offsetHeight - A[t.directionAxis],
                          _ = {
                              x: ((x = T + o.offsetWidth - e.offsetWidth - A[t.directionAxis]) - i) / 2 + i,
                              y: (E - r) / 2 + r
                          }
                      }
                      u = "false" != u && (null != u || t.repeat);
                      var L = [0, 0];
                      if (g)
                          if ("horizontal" === t.direction) {
                              for (var O = 0; O < g.length; O++)
                                  "string" == typeof g[O] ? g[O].includes("%") ? L[O] = parseInt(g[O].replace("%", "") * t.windowWidth / 100) : L[O] = parseInt(g[O]) : L[O] = g[O];
                              i += L[0],
                              x -= L[1]
                          } else {
                              for (O = 0; O < g.length; O++)
                                  "string" == typeof g[O] ? g[O].includes("%") ? L[O] = parseInt(g[O].replace("%", "") * t.windowHeight / 100) : L[O] = parseInt(g[O]) : L[O] = g[O];
                              r += L[0],
                              E -= L[1]
                          }
                      var j = {
                          el: e,
                          id: l,
                          class: c,
                          section: a,
                          top: r,
                          middle: _,
                          bottom: E,
                          left: i,
                          right: x,
                          offset: g,
                          progress: 0,
                          repeat: u,
                          inView: !1,
                          call: h,
                          speed: m,
                          delay: d,
                          position: f,
                          target: o,
                          direction: p,
                          sticky: v
                      };
                      t.els[l] = j,
                      e.classList.contains(c) && t.setInView(t.els[l], l),
                      (!1 !== m || v) && (t.parallaxElements[l] = j)
                  }
                  ))
              }
          }, {
              key: "addSections",
              value: function() {
                  var t = this;
                  this.sections = {};
                  var e = this.el.querySelectorAll("[data-".concat(this.name, "-section]"));
                  0 === e.length && (e = [this.el]),
                  e.forEach((function(e, n) {
                      var r = "string" == typeof e.dataset[t.name + "Id"] ? e.dataset[t.name + "Id"] : "section" + n
                        , i = e.getBoundingClientRect()
                        , o = {
                          x: i.left - 1.5 * window.innerWidth - Q(e).x,
                          y: i.top - 1.5 * window.innerHeight - Q(e).y
                      }
                        , s = {
                          x: o.x + i.width + 2 * window.innerWidth,
                          y: o.y + i.height + 2 * window.innerHeight
                      }
                        , a = "string" == typeof e.dataset[t.name + "Persistent"];
                      e.setAttribute("data-scroll-section-id", r);
                      var c = {
                          el: e,
                          offset: o,
                          limit: s,
                          inView: !1,
                          persistent: a,
                          id: r
                      };
                      t.sections[r] = c
                  }
                  ))
              }
          }, {
              key: "transform",
              value: function(t, e, n, r) {
                  var i;
                  if (r) {
                      var o = Q(t)
                        , s = K(o.x, e, r)
                        , a = K(o.y, n, r);
                      i = "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,".concat(s, ",").concat(a, ",0,1)")
                  } else
                      i = "matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,".concat(e, ",").concat(n, ",0,1)");
                  t.style.webkitTransform = i,
                  t.style.msTransform = i,
                  t.style.transform = i
              }
          }, {
              key: "transformElements",
              value: function(t) {
                  var e = this
                    , n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                    , r = this.instance.scroll.x + this.windowWidth
                    , i = this.instance.scroll.y + this.windowHeight
                    , o = {
                      x: this.instance.scroll.x + this.windowMiddle.x,
                      y: this.instance.scroll.y + this.windowMiddle.y
                  };
                  Object.entries(this.parallaxElements).forEach((function(s) {
                      var a = y(s, 2)
                        , c = (a[0],
                      a[1])
                        , l = !1;
                      if (t && (l = 0),
                      c.inView || n)
                          switch (c.position) {
                          case "top":
                          case "left":
                              l = e.instance.scroll[e.directionAxis] * -c.speed;
                              break;
                          case "elementTop":
                              l = (i - c.top) * -c.speed;
                              break;
                          case "bottom":
                              l = (e.instance.limit[e.directionAxis] - i + e.windowHeight) * c.speed;
                              break;
                          case "elementLeft":
                              l = (r - c.left) * -c.speed;
                              break;
                          case "right":
                              l = (e.instance.limit[e.directionAxis] - r + e.windowHeight) * c.speed;
                              break;
                          default:
                              l = (o[e.directionAxis] - c.middle[e.directionAxis]) * -c.speed
                          }
                      c.sticky && (l = c.inView ? "horizontal" === e.direction ? e.instance.scroll.x - c.left + window.innerWidth : e.instance.scroll.y - c.top + window.innerHeight : "horizontal" === e.direction ? e.instance.scroll.x < c.left - window.innerWidth && e.instance.scroll.x < c.left - window.innerWidth / 2 ? 0 : e.instance.scroll.x > c.right && e.instance.scroll.x > c.right + 100 && c.right - c.left + window.innerWidth : e.instance.scroll.y < c.top - window.innerHeight && e.instance.scroll.y < c.top - window.innerHeight / 2 ? 0 : e.instance.scroll.y > c.bottom && e.instance.scroll.y > c.bottom + 100 && c.bottom - c.top + window.innerHeight),
                      !1 !== l && ("horizontal" === c.direction || "horizontal" === e.direction && "vertical" !== c.direction ? e.transform(c.el, l, 0, !t && c.delay) : e.transform(c.el, 0, l, !t && c.delay))
                  }
                  ))
              }
          }, {
              key: "scrollTo",
              value: function(t) {
                  var e = this
                    , n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
                    , r = parseInt(n.offset) || 0
                    , i = isNaN(parseInt(n.duration)) ? 1e3 : parseInt(n.duration)
                    , o = n.easing || [.25, 0, .35, 1]
                    , s = !!n.disableLerp
                    , a = !!n.callback && n.callback;
                  if (o = at.apply(void 0, w(o)),
                  "string" == typeof t) {
                      if ("top" === t)
                          t = 0;
                      else if ("bottom" === t)
                          t = this.instance.limit.y;
                      else if ("left" === t)
                          t = 0;
                      else if ("right" === t)
                          t = this.instance.limit.x;
                      else if (!(t = document.querySelector(t)))
                          return
                  } else if ("number" == typeof t)
                      t = parseInt(t);
                  else if (!t || !t.tagName)
                      return void console.warn("`target` parameter is not valid");
                  if ("number" != typeof t) {
                      var c = J(t).includes(this.el);
                      if (!c)
                          return;
                      var l = t.getBoundingClientRect()
                        , u = l.top
                        , h = l.left
                        , f = J(t)
                        , d = f.find((function(t) {
                          return Object.entries(e.sections).map((function(t) {
                              var e = y(t, 2);
                              return e[0],
                              e[1]
                          }
                          )).find((function(e) {
                              return e.el == t
                          }
                          ))
                      }
                      ))
                        , p = 0;
                      p = d ? Q(d)[this.directionAxis] : -this.instance.scroll[this.directionAxis],
                      r = "horizontal" === this.direction ? h + r - p : u + r - p
                  } else
                      r = t + r;
                  var v = parseFloat(this.instance.delta[this.directionAxis])
                    , m = Math.max(0, Math.min(r, this.instance.limit[this.directionAxis]))
                    , g = m - v
                    , b = function(t) {
                      s ? "horizontal" === e.direction ? e.setScroll(v + g * t, e.instance.delta.y) : e.setScroll(e.instance.delta.x, v + g * t) : e.instance.delta[e.directionAxis] = v + g * t
                  };
                  this.animatingScroll = !0,
                  this.stopScrolling(),
                  this.startScrolling();
                  var E = Date.now()
                    , x = function t() {
                      var n = (Date.now() - E) / i;
                      n > 1 ? (b(1),
                      e.animatingScroll = !1,
                      0 == i && e.update(),
                      a && a()) : (e.scrollToRaf = requestAnimationFrame(t),
                      b(o(n)))
                  };
                  x()
              }
          }, {
              key: "update",
              value: function() {
                  this.setScrollLimit(),
                  this.addSections(),
                  this.addElements(),
                  this.detectElements(),
                  this.updateScroll(),
                  this.transformElements(!0),
                  this.reinitScrollBar(),
                  this.checkScroll(!0)
              }
          }, {
              key: "startScroll",
              value: function() {
                  this.stop = !1
              }
          }, {
              key: "stopScroll",
              value: function() {
                  this.stop = !0
              }
          }, {
              key: "setScroll",
              value: function(t, e) {
                  this.instance = u(u({}, this.instance), {}, {
                      scroll: {
                          x: t,
                          y: e
                      },
                      delta: {
                          x: t,
                          y: e
                      },
                      speed: 0
                  })
              }
          }, {
              key: "destroy",
              value: function() {
                  g(f(n.prototype), "destroy", this).call(this),
                  this.stopScrolling(),
                  this.html.classList.remove(this.smoothClass),
                  this.vs.destroy(),
                  this.destroyScrollBar(),
                  window.removeEventListener("keydown", this.checkKey, !1)
              }
          }]),
          n
      }(_)
        , lt = function() {
          function t() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              o(this, t),
              this.options = e,
              Object.assign(this, x, e),
              this.smartphone = x.smartphone,
              e.smartphone && Object.assign(this.smartphone, e.smartphone),
              this.tablet = x.tablet,
              e.tablet && Object.assign(this.tablet, e.tablet),
              this.smooth || "horizontal" != this.direction || console.warn("🚨 `smooth:false` & `horizontal` direction are not yet compatible"),
              this.tablet.smooth || "horizontal" != this.tablet.direction || console.warn("🚨 `smooth:false` & `horizontal` direction are not yet compatible (tablet)"),
              this.smartphone.smooth || "horizontal" != this.smartphone.direction || console.warn("🚨 `smooth:false` & `horizontal` direction are not yet compatible (smartphone)"),
              this.init()
          }
          return a(t, [{
              key: "init",
              value: function() {
                  if (this.options.isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 || window.innerWidth < this.tablet.breakpoint,
                  this.options.isTablet = this.options.isMobile && window.innerWidth >= this.tablet.breakpoint,
                  this.smooth && !this.options.isMobile || this.tablet.smooth && this.options.isTablet || this.smartphone.smooth && this.options.isMobile && !this.options.isTablet ? this.scroll = new ct(this.options) : this.scroll = new A(this.options),
                  this.scroll.init(),
                  window.location.hash) {
                      var t = window.location.hash.slice(1, window.location.hash.length)
                        , e = document.getElementById(t);
                      e && this.scroll.scrollTo(e)
                  }
              }
          }, {
              key: "update",
              value: function() {
                  this.scroll.update()
              }
          }, {
              key: "start",
              value: function() {
                  this.scroll.startScroll()
              }
          }, {
              key: "stop",
              value: function() {
                  this.scroll.stopScroll()
              }
          }, {
              key: "scrollTo",
              value: function(t, e) {
                  this.scroll.scrollTo(t, e)
              }
          }, {
              key: "setScroll",
              value: function(t, e) {
                  this.scroll.setScroll(t, e)
              }
          }, {
              key: "on",
              value: function(t, e) {
                  this.scroll.setEvents(t, e)
              }
          }, {
              key: "off",
              value: function(t, e) {
                  this.scroll.unsetEvents(t, e)
              }
          }, {
              key: "destroy",
              value: function() {
                  this.scroll.destroy()
              }
          }]),
          t
      }()
        , ut = lt;
      class ht {
          constructor() {
              window.addEventListener("afterTransition", (()=>{
                  this.bindInternalScroll(),
                  this.header.classList.remove("hide"),
                  this.isHeaderVisible = !0
              }
              ), !1),
              this.header = document.querySelector("header.header"),
              this.isHeaderVisible = !0,
              this.initialize()
          }
          initialize() {
              this.locomotion = new ut({
                  el: document.querySelector("[data-scroll-container]"),
                  smooth: !0,
                  repeat: !1,
                  getDirection: !0,
                  resetNativeScroll: !0
              }),
              this.initHeaderToggle(),
              this.locomotion.scrollTo(0, {
                  duration: 1,
                  disableLerp: !0
              });
              const t = document.querySelector("script[src*='use.typekit.net']");
              if (t) {
                  const e = ()=>{
                      if (location.hash && 0 == location.hash.indexOf("#")) {
                          let t = 0
                            , e = 0;
                          try {
                              if (t = document.querySelector(location.hash),
                              !t)
                                  throw !0;
                              window.innerWidth < 1024 && t.classList.contains("services__brands__block") && (e = -25)
                          } catch (e) {
                              t = 0
                          }
                          document.body.scrollTop = 0,
                          document.documentElement.scrollTop = 0,
                          this.locomotion.scrollTo(t, {
                              duration: 0,
                              offset: e,
                              disableLerp: !0
                          })
                      }
                      this.locomotion.update()
                  }
                    , n = ()=>{
                      Typekit.load({
                          active: e,
                          inactive: e
                      })
                  }
                  ;
                  try {
                      n()
                  } catch (e) {
                      t.addEventListener("load", n, {
                          once: !0
                      })
                  }
              }
              window.addEventListener("resize", debounce((()=>{
                  this.locomotion.update()
              }
              ), 200), !1);
              const e = document.querySelectorAll("a.footer__backtop");
              this.initAnchorScroll(e),
              this.bindInternalScroll()
          }
          initHeaderToggle() {
              const t = window.innerWidth > 1024 ? 67 : 44;
              let e = "dark"
                , n = 0;
              document.body.classList.contains("works-index") ? this.header.classList.add("invert") : this.header.classList.remove("invert"),
              this.locomotion.on("scroll", (r=>{
                  let i = e;
                  if (Object.keys(r.currentElements).length > 0) {
                      const e = Object.values(r.currentElements).filter((t=>{
                          const e = t.el.hasAttribute("data-basecolor")
                            , n = !(document.body.classList.contains("contact-index") && t.el.classList.contains("footer"));
                          return e && n
                      }
                      ));
                      e.sort(((t,e)=>t.top > e.top ? 1 : -1)),
                      e.forEach((e=>{
                          r.scroll.y >= e.top - t && (i = e.el.getAttribute("data-basecolor"))
                      }
                      ))
                  }
                  e != i && (e = i,
                  "dark" == e ? this.header.classList.remove("invert") : this.header.classList.add("invert")),
                  document.body.classList.contains("ready") && r.scroll.y + window.innerHeight < document.body.scrollHeight && ("down" == r.direction ? this.isHeaderVisible && r.scroll.y > n + 50 && (this.header.classList.add("hide"),
                  this.isHeaderVisible = !1) : "up" == r.direction && (n = Math.max(0, r.scroll.y),
                  this.isHeaderVisible || (this.header.classList.remove("hide"),
                  this.isHeaderVisible = !0)))
              }
              ))
          }
          bindInternalScroll() {
              const t = document.querySelectorAll("#root a[href^='#']");
              this.initAnchorScroll(t)
          }
          initAnchorScroll(t) {
              t.forEach((t=>{
                  let e = 0
                    , n = 0;
                  try {
                      if (e = document.querySelector(t.getAttribute("href")),
                      !e)
                          throw !0;
                      e.hasAttribute("data-anchoroffset") && (window.innerWidth >= 1024 ? n = 1 * e.dataset.anchoroffset : (t.classList.contains("article__toc__link") || e.classList.contains("services__brands__block")) && (n = -25))
                  } catch (t) {
                      e = 0
                  }
                  t.addEventListener("click", (t=>(this.locomotion.scrollTo(e, {
                      duration: 750,
                      offset: n
                  }),
                  t.stopPropagation(),
                  t.preventDefault(),
                  !1)))
              }
              ))
          }
          gotoAnchor(t) {
              let e = 0
                , n = 0;
              try {
                  if (e = document.querySelector(t),
                  !e)
                      throw !0;
                  e.hasAttribute("data-anchoroffset") && window.innerWidth >= 1024 && (n = 1 * e.dataset.anchoroffset),
                  window.innerWidth < 1024 && e.classList.contains("services__brands__block") && (n = -25),
                  this.header.classList.add("hide")
              } catch (t) {
                  e = 0
              }
              this.locomotion.scrollTo(e, {
                  duration: 0,
                  offset: n,
                  disableLerp: !0
              })
          }
          reset() {
              this.locomotion.destroy(),
              this.locomotion.init(),
              this.locomotion.update(),
              this.locomotion.scrollTo(0, {
                  duration: 0,
                  disableLerp: !0
              }),
              this.initHeaderToggle()
          }
      }
      var ft = n(9069)
        , dt = n.n(ft);
      n(7564);
      class pt {
          constructor() {
              document.documentMode ? (this.beforeTransitionEvent = document.createEvent("Event"),
              this.afterTransitionEvent = document.createEvent("Event"),
              this.transitionCompleteEvent = document.createEvent("Event"),
              this.staticReloadEvent = document.createEvent("Event"),
              this.beforeTransitionEvent.initEvent("beforeTransition", !0, !0),
              this.afterTransitionEvent.initEvent("afterTransition", !0, !0),
              this.transitionCompleteEvent.initEvent("transitionComplete", !0, !0),
              this.staticReloadEvent.initEvent("staticReload", !0, !0)) : (this.beforeTransitionEvent = new Event("beforeTransition"),
              this.afterTransitionEvent = new Event("afterTransition"),
              this.transitionCompleteEvent = new Event("transitionComplete"),
              this.staticReloadEvent = new Event("staticReload")),
              this.initialize(),
              this.barba = dt()
          }
          initialize() {
              const t = document.querySelector(".transitionmask");
              dt().init({
                  timeout: 9999999,
                  cacheIgnore: [],
                  prevent: ({el: t, event: e, href: n})=>{
                      if ("click" == e.type) {
                          let t = e.target;
                          for (; t && !t.href; )
                              t = t.parentNode;
                          if (t.getAttribute("href").match(/^#/))
                              return !0;
                          if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(t.href.toLowerCase()))
                              return !0;
                          if (t.pathname === window.location.pathname)
                              return e.preventDefault(),
                              e.stopPropagation(),
                              !0
                      }
                  }
                  ,
                  transitions: [{
                      before: async()=>{
                          window.dispatchEvent(this.beforeTransitionEvent),
                          await new Promise((t=>setTimeout(t, 50)))
                      }
                      ,
                      leave: async()=>{
                          document.body.classList.add("transition"),
                          t.classList.add("transition"),
                          await new Promise((t=>setTimeout(t, 1e3)))
                      }
                      ,
                      beforeEnter: t=>{
                          document.body.removeAttribute("class"),
                          document.body.classList.add(t.next.namespace),
                          window.isTouch && document.body.classList.add("touch")
                      }
                      ,
                      enter: t=>{}
                      ,
                      afterEnter: t=>{}
                      ,
                      after: ()=>{
                          e((()=>{
                              t.classList.remove("transition"),
                              document.body.classList.add("active"),
                              setTimeout((()=>{
                                  document.body.classList.add("ready")
                              }
                              ), 450),
                              window.biFundamentals.locomotion.reset(),
                              window.dispatchEvent(this.afterTransitionEvent),
                              window.dispatchEvent(this.transitionCompleteEvent),
                              location.hash && window.biFundamentals.locomotion.gotoAnchor(location.hash)
                          }
                          ))
                      }
                  }]
              });
              const e = (t,e)=>{
                  document.querySelectorAll("[data-loadwait], [data-loadwait] *");
                  const n = document.querySelector("script[src*='use.typekit.net']")
                    , r = document.body.classList.contains("index-index") ? document.querySelector("[data-loadwait] video") : null;
                  let i = 0;
                  const o = ()=>{
                      i++,
                      4 == i && s()
                  }
                    , s = ()=>{
                      r && r.play(),
                      t && t(),
                      e && e()
                  }
                  ;
                  if (o(),
                  n) {
                      const t = setTimeout((()=>{
                          o()
                      }
                      ), 5e3)
                        , e = ()=>{
                          clearTimeout(t),
                          o()
                      }
                        , r = ()=>{
                          Typekit.load({
                              active: e,
                              inactive: e
                          })
                      }
                      ;
                      try {
                          r()
                      } catch (t) {
                          n.addEventListener("load", r, {
                              once: !0
                          })
                      }
                  } else
                      o();
                  r ? (r.setAttribute("src", r.getAttribute("data-src")),
                  r.addEventListener("canplaythrough", (()=>{
                      o()
                  }
                  )),
                  r.load()) : o(),
                  setTimeout(o, 100)
              }
              ;
              e((()=>{
                  t.classList.add("reveal"),
                  document.body.classList.add("active"),
                  setTimeout((()=>{
                      document.body.classList.add("ready")
                  }
                  ), 450),
                  window.dispatchEvent(this.transitionCompleteEvent),
                  location.hash && window.biFundamentals.locomotion.gotoAnchor(location.hash)
              }
              ))
          }
      }
      var vt = {
          update: null,
          begin: null,
          loopBegin: null,
          changeBegin: null,
          change: null,
          changeComplete: null,
          loopComplete: null,
          complete: null,
          loop: 1,
          direction: "normal",
          autoplay: !0,
          timelineOffset: 0
      }
        , mt = {
          duration: 1e3,
          delay: 0,
          endDelay: 0,
          easing: "easeOutElastic(1, .5)",
          round: 0
      }
        , gt = ["translateX", "translateY", "translateZ", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "skew", "skewX", "skewY", "perspective", "matrix", "matrix3d"]
        , yt = {
          CSS: {},
          springs: {}
      };
      function wt(t, e, n) {
          return Math.min(Math.max(t, e), n)
      }
      function bt(t, e) {
          return t.indexOf(e) > -1
      }
      function Et(t, e) {
          return t.apply(null, e)
      }
      var xt = {
          arr: function(t) {
              return Array.isArray(t)
          },
          obj: function(t) {
              return bt(Object.prototype.toString.call(t), "Object")
          },
          pth: function(t) {
              return xt.obj(t) && t.hasOwnProperty("totalLength")
          },
          svg: function(t) {
              return t instanceof SVGElement
          },
          inp: function(t) {
              return t instanceof HTMLInputElement
          },
          dom: function(t) {
              return t.nodeType || xt.svg(t)
          },
          str: function(t) {
              return "string" == typeof t
          },
          fnc: function(t) {
              return "function" == typeof t
          },
          und: function(t) {
              return void 0 === t
          },
          nil: function(t) {
              return xt.und(t) || null === t
          },
          hex: function(t) {
              return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
          },
          rgb: function(t) {
              return /^rgb/.test(t)
          },
          hsl: function(t) {
              return /^hsl/.test(t)
          },
          col: function(t) {
              return xt.hex(t) || xt.rgb(t) || xt.hsl(t)
          },
          key: function(t) {
              return !vt.hasOwnProperty(t) && !mt.hasOwnProperty(t) && "targets" !== t && "keyframes" !== t
          }
      };
      function _t(t) {
          var e = /\(([^)]+)\)/.exec(t);
          return e ? e[1].split(",").map((function(t) {
              return parseFloat(t)
          }
          )) : []
      }
      function kt(t, e) {
          var n = _t(t)
            , r = wt(xt.und(n[0]) ? 1 : n[0], .1, 100)
            , i = wt(xt.und(n[1]) ? 100 : n[1], .1, 100)
            , o = wt(xt.und(n[2]) ? 10 : n[2], .1, 100)
            , s = wt(xt.und(n[3]) ? 0 : n[3], .1, 100)
            , a = Math.sqrt(i / r)
            , c = o / (2 * Math.sqrt(i * r))
            , l = c < 1 ? a * Math.sqrt(1 - c * c) : 0
            , u = c < 1 ? (c * a - s) / l : -s + a;
          function h(t) {
              var n = e ? e * t / 1e3 : t;
              return n = c < 1 ? Math.exp(-n * c * a) * (1 * Math.cos(l * n) + u * Math.sin(l * n)) : (1 + u * n) * Math.exp(-n * a),
              0 === t || 1 === t ? t : 1 - n
          }
          return e ? h : function() {
              var e = yt.springs[t];
              if (e)
                  return e;
              for (var n = 1 / 6, r = 0, i = 0; ; )
                  if (1 === h(r += n)) {
                      if (++i >= 16)
                          break
                  } else
                      i = 0;
              var o = r * n * 1e3;
              return yt.springs[t] = o,
              o
          }
      }
      function St(t) {
          return void 0 === t && (t = 10),
          function(e) {
              return Math.ceil(wt(e, 1e-6, 1) * t) * (1 / t)
          }
      }
      var Tt, At, Lt = function() {
          var t = .1;
          function e(t, e) {
              return 1 - 3 * e + 3 * t
          }
          function n(t, e) {
              return 3 * e - 6 * t
          }
          function r(t) {
              return 3 * t
          }
          function i(t, i, o) {
              return ((e(i, o) * t + n(i, o)) * t + r(i)) * t
          }
          function o(t, i, o) {
              return 3 * e(i, o) * t * t + 2 * n(i, o) * t + r(i)
          }
          return function(e, n, r, s) {
              if (0 <= e && e <= 1 && 0 <= r && r <= 1) {
                  var a = new Float32Array(11);
                  if (e !== n || r !== s)
                      for (var c = 0; c < 11; ++c)
                          a[c] = i(c * t, e, r);
                  return function(c) {
                      return e === n && r === s || 0 === c || 1 === c ? c : i(function(n) {
                          for (var s = 0, c = 1; 10 !== c && a[c] <= n; ++c)
                              s += t;
                          --c;
                          var l = s + (n - a[c]) / (a[c + 1] - a[c]) * t
                            , u = o(l, e, r);
                          return u >= .001 ? function(t, e, n, r) {
                              for (var s = 0; s < 4; ++s) {
                                  var a = o(e, n, r);
                                  if (0 === a)
                                      return e;
                                  e -= (i(e, n, r) - t) / a
                              }
                              return e
                          }(n, l, e, r) : 0 === u ? l : function(t, e, n, r, o) {
                              var s, a, c = 0;
                              do {
                                  (s = i(a = e + (n - e) / 2, r, o) - t) > 0 ? n = a : e = a
                              } while (Math.abs(s) > 1e-7 && ++c < 10);
                              return a
                          }(n, s, s + t, e, r)
                      }(c), n, s)
                  }
              }
          }
      }(), Ot = (Tt = {
          linear: function() {
              return function(t) {
                  return t
              }
          }
      },
      At = {
          Sine: function() {
              return function(t) {
                  return 1 - Math.cos(t * Math.PI / 2)
              }
          },
          Circ: function() {
              return function(t) {
                  return 1 - Math.sqrt(1 - t * t)
              }
          },
          Back: function() {
              return function(t) {
                  return t * t * (3 * t - 2)
              }
          },
          Bounce: function() {
              return function(t) {
                  for (var e, n = 4; t < ((e = Math.pow(2, --n)) - 1) / 11; )
                      ;
                  return 1 / Math.pow(4, 3 - n) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
              }
          },
          Elastic: function(t, e) {
              void 0 === t && (t = 1),
              void 0 === e && (e = .5);
              var n = wt(t, 1, 10)
                , r = wt(e, .1, 2);
              return function(t) {
                  return 0 === t || 1 === t ? t : -n * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - r / (2 * Math.PI) * Math.asin(1 / n)) * (2 * Math.PI) / r)
              }
          }
      },
      ["Quad", "Cubic", "Quart", "Quint", "Expo"].forEach((function(t, e) {
          At[t] = function() {
              return function(t) {
                  return Math.pow(t, e + 2)
              }
          }
      }
      )),
      Object.keys(At).forEach((function(t) {
          var e = At[t];
          Tt["easeIn" + t] = e,
          Tt["easeOut" + t] = function(t, n) {
              return function(r) {
                  return 1 - e(t, n)(1 - r)
              }
          }
          ,
          Tt["easeInOut" + t] = function(t, n) {
              return function(r) {
                  return r < .5 ? e(t, n)(2 * r) / 2 : 1 - e(t, n)(-2 * r + 2) / 2
              }
          }
          ,
          Tt["easeOutIn" + t] = function(t, n) {
              return function(r) {
                  return r < .5 ? (1 - e(t, n)(1 - 2 * r)) / 2 : (e(t, n)(2 * r - 1) + 1) / 2
              }
          }
      }
      )),
      Tt);
      function jt(t, e) {
          if (xt.fnc(t))
              return t;
          var n = t.split("(")[0]
            , r = Ot[n]
            , i = _t(t);
          switch (n) {
          case "spring":
              return kt(t, e);
          case "cubicBezier":
              return Et(Lt, i);
          case "steps":
              return Et(St, i);
          default:
              return Et(r, i)
          }
      }
      function Pt(t) {
          try {
              return document.querySelectorAll(t)
          } catch (t) {
              return
          }
      }
      function Mt(t, e) {
          for (var n = t.length, r = arguments.length >= 2 ? arguments[1] : void 0, i = [], o = 0; o < n; o++)
              if (o in t) {
                  var s = t[o];
                  e.call(r, s, o, t) && i.push(s)
              }
          return i
      }
      function Ct(t) {
          return t.reduce((function(t, e) {
              return t.concat(xt.arr(e) ? Ct(e) : e)
          }
          ), [])
      }
      function Rt(t) {
          return xt.arr(t) ? t : (xt.str(t) && (t = Pt(t) || t),
          t instanceof NodeList || t instanceof HTMLCollection ? [].slice.call(t) : [t])
      }
      function It(t, e) {
          return t.some((function(t) {
              return t === e
          }
          ))
      }
      function qt(t) {
          var e = {};
          for (var n in t)
              e[n] = t[n];
          return e
      }
      function Dt(t, e) {
          var n = qt(t);
          for (var r in t)
              n[r] = e.hasOwnProperty(r) ? e[r] : t[r];
          return n
      }
      function Ft(t, e) {
          var n = qt(t);
          for (var r in e)
              n[r] = xt.und(t[r]) ? e[r] : t[r];
          return n
      }
      function Bt(t) {
          var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t);
          if (e)
              return e[1]
      }
      function Ht(t, e) {
          return xt.fnc(t) ? t(e.target, e.id, e.total) : t
      }
      function Nt(t, e) {
          return t.getAttribute(e)
      }
      function zt(t, e, n) {
          if (It([n, "deg", "rad", "turn"], Bt(e)))
              return e;
          var r = yt.CSS[e + n];
          if (!xt.und(r))
              return r;
          var i = document.createElement(t.tagName)
            , o = t.parentNode && t.parentNode !== document ? t.parentNode : document.body;
          o.appendChild(i),
          i.style.position = "absolute",
          i.style.width = 100 + n;
          var s = 100 / i.offsetWidth;
          o.removeChild(i);
          var a = s * parseFloat(e);
          return yt.CSS[e + n] = a,
          a
      }
      function Wt(t, e, n) {
          if (e in t.style) {
              var r = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()
                , i = t.style[e] || getComputedStyle(t).getPropertyValue(r) || "0";
              return n ? zt(t, i, n) : i
          }
      }
      function Yt(t, e) {
          return xt.dom(t) && !xt.inp(t) && (!xt.nil(Nt(t, e)) || xt.svg(t) && t[e]) ? "attribute" : xt.dom(t) && It(gt, e) ? "transform" : xt.dom(t) && "transform" !== e && Wt(t, e) ? "css" : null != t[e] ? "object" : void 0
      }
      function Vt(t) {
          if (xt.dom(t)) {
              for (var e, n = t.style.transform || "", r = /(\w+)\(([^)]*)\)/g, i = new Map; e = r.exec(n); )
                  i.set(e[1], e[2]);
              return i
          }
      }
      function Ut(t, e, n, r) {
          switch (Yt(t, e)) {
          case "transform":
              return function(t, e, n, r) {
                  var i = bt(e, "scale") ? 1 : 0 + function(t) {
                      return bt(t, "translate") || "perspective" === t ? "px" : bt(t, "rotate") || bt(t, "skew") ? "deg" : void 0
                  }(e)
                    , o = Vt(t).get(e) || i;
                  return n && (n.transforms.list.set(e, o),
                  n.transforms.last = e),
                  r ? zt(t, o, r) : o
              }(t, e, r, n);
          case "css":
              return Wt(t, e, n);
          case "attribute":
              return Nt(t, e);
          default:
              return t[e] || 0
          }
      }
      function Xt(t, e) {
          var n = /^(\*=|\+=|-=)/.exec(t);
          if (!n)
              return t;
          var r = Bt(t) || 0
            , i = parseFloat(e)
            , o = parseFloat(t.replace(n[0], ""));
          switch (n[0][0]) {
          case "+":
              return i + o + r;
          case "-":
              return i - o + r;
          case "*":
              return i * o + r
          }
      }
      function $t(t, e) {
          if (xt.col(t))
              return function(t) {
                  return xt.rgb(t) ? (n = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(e = t)) ? "rgba(" + n[1] + ",1)" : e : xt.hex(t) ? function(t) {
                      var e = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (function(t, e, n, r) {
                          return e + e + n + n + r + r
                      }
                      ))
                        , n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
                      return "rgba(" + parseInt(n[1], 16) + "," + parseInt(n[2], 16) + "," + parseInt(n[3], 16) + ",1)"
                  }(t) : xt.hsl(t) ? function(t) {
                      var e, n, r, i = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t), o = parseInt(i[1], 10) / 360, s = parseInt(i[2], 10) / 100, a = parseInt(i[3], 10) / 100, c = i[4] || 1;
                      function l(t, e, n) {
                          return n < 0 && (n += 1),
                          n > 1 && (n -= 1),
                          n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t
                      }
                      if (0 == s)
                          e = n = r = a;
                      else {
                          var u = a < .5 ? a * (1 + s) : a + s - a * s
                            , h = 2 * a - u;
                          e = l(h, u, o + 1 / 3),
                          n = l(h, u, o),
                          r = l(h, u, o - 1 / 3)
                      }
                      return "rgba(" + 255 * e + "," + 255 * n + "," + 255 * r + "," + c + ")"
                  }(t) : void 0;
                  var e, n
              }(t);
          if (/\s/g.test(t))
              return t;
          var n = Bt(t)
            , r = n ? t.substr(0, t.length - n.length) : t;
          return e ? r + e : r
      }
      function Gt(t, e) {
          return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2))
      }
      function Kt(t) {
          for (var e, n = t.points, r = 0, i = 0; i < n.numberOfItems; i++) {
              var o = n.getItem(i);
              i > 0 && (r += Gt(e, o)),
              e = o
          }
          return r
      }
      function Qt(t) {
          if (t.getTotalLength)
              return t.getTotalLength();
          switch (t.tagName.toLowerCase()) {
          case "circle":
              return function(t) {
                  return 2 * Math.PI * Nt(t, "r")
              }(t);
          case "rect":
              return function(t) {
                  return 2 * Nt(t, "width") + 2 * Nt(t, "height")
              }(t);
          case "line":
              return function(t) {
                  return Gt({
                      x: Nt(t, "x1"),
                      y: Nt(t, "y1")
                  }, {
                      x: Nt(t, "x2"),
                      y: Nt(t, "y2")
                  })
              }(t);
          case "polyline":
              return Kt(t);
          case "polygon":
              return function(t) {
                  var e = t.points;
                  return Kt(t) + Gt(e.getItem(e.numberOfItems - 1), e.getItem(0))
              }(t)
          }
      }
      function Jt(t, e) {
          var n = e || {}
            , r = n.el || function(t) {
              for (var e = t.parentNode; xt.svg(e) && xt.svg(e.parentNode); )
                  e = e.parentNode;
              return e
          }(t)
            , i = r.getBoundingClientRect()
            , o = Nt(r, "viewBox")
            , s = i.width
            , a = i.height
            , c = n.viewBox || (o ? o.split(" ") : [0, 0, s, a]);
          return {
              el: r,
              viewBox: c,
              x: c[0] / 1,
              y: c[1] / 1,
              w: s,
              h: a,
              vW: c[2],
              vH: c[3]
          }
      }
      function Zt(t, e, n) {
          function r(n) {
              void 0 === n && (n = 0);
              var r = e + n >= 1 ? e + n : 0;
              return t.el.getPointAtLength(r)
          }
          var i = Jt(t.el, t.svg)
            , o = r()
            , s = r(-1)
            , a = r(1)
            , c = n ? 1 : i.w / i.vW
            , l = n ? 1 : i.h / i.vH;
          switch (t.property) {
          case "x":
              return (o.x - i.x) * c;
          case "y":
              return (o.y - i.y) * l;
          case "angle":
              return 180 * Math.atan2(a.y - s.y, a.x - s.x) / Math.PI
          }
      }
      function te(t, e) {
          var n = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g
            , r = $t(xt.pth(t) ? t.totalLength : t, e) + "";
          return {
              original: r,
              numbers: r.match(n) ? r.match(n).map(Number) : [0],
              strings: xt.str(t) || e ? r.split(n) : []
          }
      }
      function ee(t) {
          return Mt(t ? Ct(xt.arr(t) ? t.map(Rt) : Rt(t)) : [], (function(t, e, n) {
              return n.indexOf(t) === e
          }
          ))
      }
      function ne(t) {
          var e = ee(t);
          return e.map((function(t, n) {
              return {
                  target: t,
                  id: n,
                  total: e.length,
                  transforms: {
                      list: Vt(t)
                  }
              }
          }
          ))
      }
      function re(t, e) {
          var n = qt(e);
          if (/^spring/.test(n.easing) && (n.duration = kt(n.easing)),
          xt.arr(t)) {
              var r = t.length;
              2 !== r || xt.obj(t[0]) ? xt.fnc(e.duration) || (n.duration = e.duration / r) : t = {
                  value: t
              }
          }
          var i = xt.arr(t) ? t : [t];
          return i.map((function(t, n) {
              var r = xt.obj(t) && !xt.pth(t) ? t : {
                  value: t
              };
              return xt.und(r.delay) && (r.delay = n ? 0 : e.delay),
              xt.und(r.endDelay) && (r.endDelay = n === i.length - 1 ? e.endDelay : 0),
              r
          }
          )).map((function(t) {
              return Ft(t, n)
          }
          ))
      }
      var ie = {
          css: function(t, e, n) {
              return t.style[e] = n
          },
          attribute: function(t, e, n) {
              return t.setAttribute(e, n)
          },
          object: function(t, e, n) {
              return t[e] = n
          },
          transform: function(t, e, n, r, i) {
              if (r.list.set(e, n),
              e === r.last || i) {
                  var o = "";
                  r.list.forEach((function(t, e) {
                      o += e + "(" + t + ") "
                  }
                  )),
                  t.style.transform = o
              }
          }
      };
      function oe(t, e) {
          ne(t).forEach((function(t) {
              for (var n in e) {
                  var r = Ht(e[n], t)
                    , i = t.target
                    , o = Bt(r)
                    , s = Ut(i, n, o, t)
                    , a = Xt($t(r, o || Bt(s)), s)
                    , c = Yt(i, n);
                  ie[c](i, n, a, t.transforms, !0)
              }
          }
          ))
      }
      function se(t, e) {
          return Mt(Ct(t.map((function(t) {
              return e.map((function(e) {
                  return function(t, e) {
                      var n = Yt(t.target, e.name);
                      if (n) {
                          var r = function(t, e) {
                              var n;
                              return t.tweens.map((function(r) {
                                  var i = function(t, e) {
                                      var n = {};
                                      for (var r in t) {
                                          var i = Ht(t[r], e);
                                          xt.arr(i) && 1 === (i = i.map((function(t) {
                                              return Ht(t, e)
                                          }
                                          ))).length && (i = i[0]),
                                          n[r] = i
                                      }
                                      return n.duration = parseFloat(n.duration),
                                      n.delay = parseFloat(n.delay),
                                      n
                                  }(r, e)
                                    , o = i.value
                                    , s = xt.arr(o) ? o[1] : o
                                    , a = Bt(s)
                                    , c = Ut(e.target, t.name, a, e)
                                    , l = n ? n.to.original : c
                                    , u = xt.arr(o) ? o[0] : l
                                    , h = Bt(u) || Bt(c)
                                    , f = a || h;
                                  return xt.und(s) && (s = l),
                                  i.from = te(u, f),
                                  i.to = te(Xt(s, u), f),
                                  i.start = n ? n.end : 0,
                                  i.end = i.start + i.delay + i.duration + i.endDelay,
                                  i.easing = jt(i.easing, i.duration),
                                  i.isPath = xt.pth(o),
                                  i.isPathTargetInsideSVG = i.isPath && xt.svg(e.target),
                                  i.isColor = xt.col(i.from.original),
                                  i.isColor && (i.round = 1),
                                  n = i,
                                  i
                              }
                              ))
                          }(e, t)
                            , i = r[r.length - 1];
                          return {
                              type: n,
                              property: e.name,
                              animatable: t,
                              tweens: r,
                              duration: i.end,
                              delay: r[0].delay,
                              endDelay: i.endDelay
                          }
                      }
                  }(t, e)
              }
              ))
          }
          ))), (function(t) {
              return !xt.und(t)
          }
          ))
      }
      function ae(t, e) {
          var n = t.length
            , r = function(t) {
              return t.timelineOffset ? t.timelineOffset : 0
          }
            , i = {};
          return i.duration = n ? Math.max.apply(Math, t.map((function(t) {
              return r(t) + t.duration
          }
          ))) : e.duration,
          i.delay = n ? Math.min.apply(Math, t.map((function(t) {
              return r(t) + t.delay
          }
          ))) : e.delay,
          i.endDelay = n ? i.duration - Math.max.apply(Math, t.map((function(t) {
              return r(t) + t.duration - t.endDelay
          }
          ))) : e.endDelay,
          i
      }
      var ce = 0
        , le = []
        , ue = function() {
          var t;
          function e(n) {
              for (var r = le.length, i = 0; i < r; ) {
                  var o = le[i];
                  o.paused ? (le.splice(i, 1),
                  r--) : (o.tick(n),
                  i++)
              }
              t = i > 0 ? requestAnimationFrame(e) : void 0
          }
          return "undefined" != typeof document && document.addEventListener("visibilitychange", (function() {
              fe.suspendWhenDocumentHidden && (he() ? t = cancelAnimationFrame(t) : (le.forEach((function(t) {
                  return t._onDocumentVisibility()
              }
              )),
              ue()))
          }
          )),
          function() {
              t || he() && fe.suspendWhenDocumentHidden || !(le.length > 0) || (t = requestAnimationFrame(e))
          }
      }();
      function he() {
          return !!document && document.hidden
      }
      function fe(t) {
          void 0 === t && (t = {});
          var e, n = 0, r = 0, i = 0, o = 0, s = null;
          function a(t) {
              var e = window.Promise && new Promise((function(t) {
                  return s = t
              }
              ));
              return t.finished = e,
              e
          }
          var c = function(t) {
              var e = Dt(vt, t)
                , n = Dt(mt, t)
                , r = function(t, e) {
                  var n = []
                    , r = e.keyframes;
                  for (var i in r && (e = Ft(function(t) {
                      for (var e = Mt(Ct(t.map((function(t) {
                          return Object.keys(t)
                      }
                      ))), (function(t) {
                          return xt.key(t)
                      }
                      )).reduce((function(t, e) {
                          return t.indexOf(e) < 0 && t.push(e),
                          t
                      }
                      ), []), n = {}, r = function(r) {
                          var i = e[r];
                          n[i] = t.map((function(t) {
                              var e = {};
                              for (var n in t)
                                  xt.key(n) ? n == i && (e.value = t[n]) : e[n] = t[n];
                              return e
                          }
                          ))
                      }, i = 0; i < e.length; i++)
                          r(i);
                      return n
                  }(r), e)),
                  e)
                      xt.key(i) && n.push({
                          name: i,
                          tweens: re(e[i], t)
                      });
                  return n
              }(n, t)
                , i = ne(t.targets)
                , o = se(i, r)
                , s = ae(o, n)
                , a = ce;
              return ce++,
              Ft(e, {
                  id: a,
                  children: [],
                  animatables: i,
                  animations: o,
                  duration: s.duration,
                  delay: s.delay,
                  endDelay: s.endDelay
              })
          }(t);
          function l() {
              var t = c.direction;
              "alternate" !== t && (c.direction = "normal" !== t ? "normal" : "reverse"),
              c.reversed = !c.reversed,
              e.forEach((function(t) {
                  return t.reversed = c.reversed
              }
              ))
          }
          function u(t) {
              return c.reversed ? c.duration - t : t
          }
          function h() {
              n = 0,
              r = u(c.currentTime) * (1 / fe.speed)
          }
          function f(t, e) {
              e && e.seek(t - e.timelineOffset)
          }
          function d(t) {
              for (var e = 0, n = c.animations, r = n.length; e < r; ) {
                  var i = n[e]
                    , o = i.animatable
                    , s = i.tweens
                    , a = s.length - 1
                    , l = s[a];
                  a && (l = Mt(s, (function(e) {
                      return t < e.end
                  }
                  ))[0] || l);
                  for (var u = wt(t - l.start - l.delay, 0, l.duration) / l.duration, h = isNaN(u) ? 1 : l.easing(u), f = l.to.strings, d = l.round, p = [], v = l.to.numbers.length, m = void 0, g = 0; g < v; g++) {
                      var y = void 0
                        , w = l.to.numbers[g]
                        , b = l.from.numbers[g] || 0;
                      y = l.isPath ? Zt(l.value, h * w, l.isPathTargetInsideSVG) : b + h * (w - b),
                      d && (l.isColor && g > 2 || (y = Math.round(y * d) / d)),
                      p.push(y)
                  }
                  var E = f.length;
                  if (E) {
                      m = f[0];
                      for (var x = 0; x < E; x++) {
                          f[x];
                          var _ = f[x + 1]
                            , k = p[x];
                          isNaN(k) || (m += _ ? k + _ : k + " ")
                      }
                  } else
                      m = p[0];
                  ie[i.type](o.target, i.property, m, o.transforms),
                  i.currentValue = m,
                  e++
              }
          }
          function p(t) {
              c[t] && !c.passThrough && c[t](c)
          }
          function v(t) {
              var h = c.duration
                , v = c.delay
                , m = h - c.endDelay
                , g = u(t);
              c.progress = wt(g / h * 100, 0, 100),
              c.reversePlayback = g < c.currentTime,
              e && function(t) {
                  if (c.reversePlayback)
                      for (var n = o; n--; )
                          f(t, e[n]);
                  else
                      for (var r = 0; r < o; r++)
                          f(t, e[r])
              }(g),
              !c.began && c.currentTime > 0 && (c.began = !0,
              p("begin")),
              !c.loopBegan && c.currentTime > 0 && (c.loopBegan = !0,
              p("loopBegin")),
              g <= v && 0 !== c.currentTime && d(0),
              (g >= m && c.currentTime !== h || !h) && d(h),
              g > v && g < m ? (c.changeBegan || (c.changeBegan = !0,
              c.changeCompleted = !1,
              p("changeBegin")),
              p("change"),
              d(g)) : c.changeBegan && (c.changeCompleted = !0,
              c.changeBegan = !1,
              p("changeComplete")),
              c.currentTime = wt(g, 0, h),
              c.began && p("update"),
              t >= h && (r = 0,
              c.remaining && !0 !== c.remaining && c.remaining--,
              c.remaining ? (n = i,
              p("loopComplete"),
              c.loopBegan = !1,
              "alternate" === c.direction && l()) : (c.paused = !0,
              c.completed || (c.completed = !0,
              p("loopComplete"),
              p("complete"),
              !c.passThrough && "Promise"in window && (s(),
              a(c)))))
          }
          return a(c),
          c.reset = function() {
              var t = c.direction;
              c.passThrough = !1,
              c.currentTime = 0,
              c.progress = 0,
              c.paused = !0,
              c.began = !1,
              c.loopBegan = !1,
              c.changeBegan = !1,
              c.completed = !1,
              c.changeCompleted = !1,
              c.reversePlayback = !1,
              c.reversed = "reverse" === t,
              c.remaining = c.loop,
              e = c.children;
              for (var n = o = e.length; n--; )
                  c.children[n].reset();
              (c.reversed && !0 !== c.loop || "alternate" === t && 1 === c.loop) && c.remaining++,
              d(c.reversed ? c.duration : 0)
          }
          ,
          c._onDocumentVisibility = h,
          c.set = function(t, e) {
              return oe(t, e),
              c
          }
          ,
          c.tick = function(t) {
              i = t,
              n || (n = i),
              v((i + (r - n)) * fe.speed)
          }
          ,
          c.seek = function(t) {
              v(u(t))
          }
          ,
          c.pause = function() {
              c.paused = !0,
              h()
          }
          ,
          c.play = function() {
              c.paused && (c.completed && c.reset(),
              c.paused = !1,
              le.push(c),
              h(),
              ue())
          }
          ,
          c.reverse = function() {
              l(),
              c.completed = !c.reversed,
              h()
          }
          ,
          c.restart = function() {
              c.reset(),
              c.play()
          }
          ,
          c.remove = function(t) {
              pe(ee(t), c)
          }
          ,
          c.reset(),
          c.autoplay && c.play(),
          c
      }
      function de(t, e) {
          for (var n = e.length; n--; )
              It(t, e[n].animatable.target) && e.splice(n, 1)
      }
      function pe(t, e) {
          var n = e.animations
            , r = e.children;
          de(t, n);
          for (var i = r.length; i--; ) {
              var o = r[i]
                , s = o.animations;
              de(t, s),
              s.length || o.children.length || r.splice(i, 1)
          }
          n.length || r.length || e.pause()
      }
      fe.version = "3.2.1",
      fe.speed = 1,
      fe.suspendWhenDocumentHidden = !0,
      fe.running = le,
      fe.remove = function(t) {
          for (var e = ee(t), n = le.length; n--; )
              pe(e, le[n])
      }
      ,
      fe.get = Ut,
      fe.set = oe,
      fe.convertPx = zt,
      fe.path = function(t, e) {
          var n = xt.str(t) ? Pt(t)[0] : t
            , r = e || 100;
          return function(t) {
              return {
                  property: t,
                  el: n,
                  svg: Jt(n),
                  totalLength: Qt(n) * (r / 100)
              }
          }
      }
      ,
      fe.setDashoffset = function(t) {
          var e = Qt(t);
          return t.setAttribute("stroke-dasharray", e),
          e
      }
      ,
      fe.stagger = function(t, e) {
          void 0 === e && (e = {});
          var n = e.direction || "normal"
            , r = e.easing ? jt(e.easing) : null
            , i = e.grid
            , o = e.axis
            , s = e.from || 0
            , a = "first" === s
            , c = "center" === s
            , l = "last" === s
            , u = xt.arr(t)
            , h = u ? parseFloat(t[0]) : parseFloat(t)
            , f = u ? parseFloat(t[1]) : 0
            , d = Bt(u ? t[1] : t) || 0
            , p = e.start || 0 + (u ? h : 0)
            , v = []
            , m = 0;
          return function(t, e, g) {
              if (a && (s = 0),
              c && (s = (g - 1) / 2),
              l && (s = g - 1),
              !v.length) {
                  for (var y = 0; y < g; y++) {
                      if (i) {
                          var w = c ? (i[0] - 1) / 2 : s % i[0]
                            , b = c ? (i[1] - 1) / 2 : Math.floor(s / i[0])
                            , E = w - y % i[0]
                            , x = b - Math.floor(y / i[0])
                            , _ = Math.sqrt(E * E + x * x);
                          "x" === o && (_ = -E),
                          "y" === o && (_ = -x),
                          v.push(_)
                      } else
                          v.push(Math.abs(s - y));
                      m = Math.max.apply(Math, v)
                  }
                  r && (v = v.map((function(t) {
                      return r(t / m) * m
                  }
                  ))),
                  "reverse" === n && (v = v.map((function(t) {
                      return o ? t < 0 ? -1 * t : -t : Math.abs(m - t)
                  }
                  )))
              }
              return p + (u ? (f - h) / m : h) * (Math.round(100 * v[e]) / 100) + d
          }
      }
      ,
      fe.timeline = function(t) {
          void 0 === t && (t = {});
          var e = fe(t);
          return e.duration = 0,
          e.add = function(n, r) {
              var i = le.indexOf(e)
                , o = e.children;
              function s(t) {
                  t.passThrough = !0
              }
              i > -1 && le.splice(i, 1);
              for (var a = 0; a < o.length; a++)
                  s(o[a]);
              var c = Ft(n, Dt(mt, t));
              c.targets = c.targets || t.targets;
              var l = e.duration;
              c.autoplay = !1,
              c.direction = e.direction,
              c.timelineOffset = xt.und(r) ? l : Xt(r, l),
              s(e),
              e.seek(c.timelineOffset);
              var u = fe(c);
              s(u),
              o.push(u);
              var h = ae(o, t);
              return e.delay = h.delay,
              e.endDelay = h.endDelay,
              e.duration = h.duration,
              e.seek(0),
              e.reset(),
              e.autoplay && e.play(),
              e
          }
          ,
          e
      }
      ,
      fe.easing = jt,
      fe.penner = Ot,
      fe.random = function(t, e) {
          return Math.floor(Math.random() * (e - t + 1)) + t
      }
      ;
      var ve = fe;
      class me {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              this.blocks = document.querySelectorAll(".about__member__block"),
              this.blocks && this.initMemberToggle()
          }
          initMemberToggle() {
              this.blocks.forEach((t=>{
                  const e = t.querySelector(".about__member__block__toggle")
                    , n = t.querySelector(".about__member__block__body")
                    , r = t.querySelector(".about__member__block__body__contents");
                  let i = !1
                    , o = null;
                  function s() {
                      n.style.height = "auto",
                      window.biFundamentals.locomotion.locomotion.update()
                  }
                  function a() {
                      n.style.height = "0px",
                      window.biFundamentals.locomotion.locomotion.update()
                  }
                  e.addEventListener("click", (()=>function() {
                      o && o.pause();
                      const e = i ? 0 : r.offsetHeight;
                      n.style.height = (i ? r.offsetHeight : 0) + "px",
                      o = ve({
                          targets: n,
                          height: e,
                          duration: 500,
                          easing: "easeOutExpo",
                          complete: i ? a : s
                      }),
                      i ? (t.classList.remove("open"),
                      i = !1) : (t.classList.add("open"),
                      i = !0)
                  }()), !1)
              }
              ))
          }
          destroy() {
              this.blocks = null
          }
      }
      class ge {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              this.forms = document.querySelectorAll(".inputform"),
              this.forms.forEach((t=>this.initContactForm(t)))
          }
          initContactForm(t) {
              t.querySelectorAll(".inputform__selection").forEach((t=>{
                  const e = t.querySelector(".select")
                    , n = t.querySelector(".label");
                  e.addEventListener("change", (()=>{
                      t.classList.add("selected"),
                      n.innerText = e.value
                  }
                  ), !1)
              }
              ))
          }
          destroy() {}
      }
      n(4197),
      n(3824),
      n(5109);
      class ye {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              document.querySelector("#glow_canvas") && this.initGlowCanvas()
          }
          initGlowCanvas() {
              const t = document.querySelector("#glow_canvas");
              t.width = window.innerWidth,
              t.height = window.innerHeight;
              const e = t.getContext("webgl")
                , n = function(t, n) {
                  const r = e.createProgram();
                  return e.attachShader(r, t),
                  e.attachShader(r, n),
                  e.linkProgram(r),
                  e.useProgram(r),
                  r
              }(h(e.VERTEX_SHADER, "attribute vec3 position;\nvoid main(void){\n\tgl_Position = vec4(position,1.0);\n}"), h(e.FRAGMENT_SHADER, "precision highp float;\n\nuniform vec2 resolution;\nuniform float time;\nuniform vec4 param1;\nuniform vec4 param2;\nuniform vec4 param3;\n#define iResolution resolution\n#define iTime time\n\nvoid mainImage(out vec4 fragColor, in vec2 fragCoord);\nvoid main(void) {\n\tvec4 col;\n\tmainImage(col, gl_FragCoord.xy);\n\tgl_FragColor = col;\n}\n\n// --- //\n\nfloat Circle(vec2 point, float radius, float slope, vec2 uv){\n\treturn smoothstep(radius + slope, radius - slope, length(uv - point));\n}\n\nvec3 DrawZero(vec2 point, vec2 uv){\n\tvec3 result = vec3(0.0);\n\tfloat radius = 0.8;\n\tfloat slope = 0.85;\n\n\tfloat start = 0.0;\n\tfloat t = iTime*1.5;\n\tfloat x = cos(t * param1.x + start) * param1.z;\n\tfloat y = sin(t * param1.y + start) * param1.w;\n\t//紫\n\t//vec3 color = vec3(0.1686, 0.149, 0.251) * 1.0000;\n\t//vec3 color = vec3(0.0745, 0.0588, 0.1569) * 0.5000;\n\tvec3 color = vec3(0.1373, 0.102, 0.298) * 0.7500;\n\t//vec3 color = vec3(0.0392, 0.0078, 0.2039) * 0.7500;\n\tresult += max(color * Circle(vec2(0.5, 0.5) * 2.0 - 1.0 + vec2(x, y), radius, slope, uv), 0.0);\n\n\tstart = 0.5;\n\tt = iTime*1.5;\n\tx = cos(t * param2.x + start) * param2.z;\n\ty = sin(t * param2.y + start) * param2.w;\n\t//ピンク\n\t//color = vec3(0.3529, 0.2314, 0.2902) * 2.0000;\n\t//color = vec3(0.2863, 0.1373, 0.2039) * 1.2000;\n\tcolor = vec3(0.4078, 0.1725, 0.2863) * 1.5000;\n\t//color = vec3(0.3608, 0.0784, 0.2) * 18.5000;\n\tresult += max(color * Circle(vec2(0.5, 0.5) * 2.0 - 1.0 + vec2(x, y), radius, slope, uv), 0.0);\n\n\tstart = 2.0;\n\tt = iTime*1.5;\n\tx = cos(t * param3.x + start) * param3.z;\n\ty = sin(t * param3.y + start) * param3.w;\n\t//水色\n\t//color = vec3(0.2118, 5.3059, 20.3686) * 50.0000;\n\t//color = vec3(4.1216, 0.2235, 0.3098) * 6.5000;\n\tcolor = vec3(4.1686, 20.3333, 7.4549) * 0.5000;\n\t//color = vec3(4.0902, 60.2431, 20.3922) * 4.5000;\n\tresult += max(color * Circle(vec2(7.5, 2.5) * 2.0 - 1.0 + vec2(x, y), radius, slope, uv), 0.0);\n\n\treturn max(result, 0.0);\n}\n\nvoid mainImage( out vec4 fragColor, in vec2 fragCoord ){\n\tvec2 uv = fragCoord/iResolution.xy;\n\tuv -= vec2(0.5);\n\tuv.x *= iResolution.x / iResolution.y;\n\tvec3 col = DrawZero(vec2(0.0, 0.0), uv);\n\tfragColor = vec4(col,25.0);\n}"))
                , r = performance.now()
                , i = [];
              i[0] = e.getUniformLocation(n, "time"),
              i[1] = e.getUniformLocation(n, "resolution"),
              i[2] = e.getUniformLocation(n, "param1"),
              i[3] = e.getUniformLocation(n, "param2"),
              i[4] = e.getUniformLocation(n, "param3");
              const o = [[[.4, .3, .6, .3], [.3, .4, .5, .6], [.7, .6, .3, .4]], [[.2, .4, .7, .1], [.6, .5, .4, .3], [.6, .5, .3, .8]], [[.5, .2, .6, .5], [.4, .6, .4, .6], [.3, .6, .5, .8]], [[.5, .3, .6, .2], [.4, .3, .7, .6], [.8, .6, .4, .6]]]
                , s = Math.floor(4 * Math.random())
                , a = [0, 1, 2].sort((()=>.5 - Math.random()))
                , c = function(t) {
                  const n = e.createBuffer();
                  return e.bindBuffer(e.ARRAY_BUFFER, n),
                  e.bufferData(e.ARRAY_BUFFER, new Float32Array([-1, 1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0]), e.STATIC_DRAW),
                  e.bindBuffer(e.ARRAY_BUFFER, null),
                  n
              }()
                , l = function(t) {
                  const n = e.createBuffer();
                  return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, n),
                  e.bufferData(e.ELEMENT_ARRAY_BUFFER, new Int16Array([0, 2, 1, 1, 2, 3]), e.STATIC_DRAW),
                  e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, null),
                  n
              }()
                , u = e.getAttribLocation(n, "position");
              function h(t, n) {
                  const r = e.createShader(t);
                  return e.shaderSource(r, n),
                  e.compileShader(r),
                  r
              }
              e.bindBuffer(e.ARRAY_BUFFER, c),
              e.enableVertexAttribArray(u),
              e.vertexAttribPointer(u, 3, e.FLOAT, !1, 0, 0),
              e.bindBuffer(e.ELEMENT_ARRAY_BUFFER, l),
              e.clearColor(0, 0, 0, 1),
              function n() {
                  t.width = window.innerWidth,
                  t.height = window.innerHeight,
                  e.viewport(0, 0, t.width, t.height),
                  e.clear(e.COLOR_BUFFER_BIT),
                  e.uniform1f(i[0], .001 * (performance.now() - r)),
                  e.uniform2fv(i[1], [t.width, t.height]),
                  e.uniform4fv(i[2], o[s][a[0]]),
                  e.uniform4fv(i[3], o[s][a[1]]),
                  e.uniform4fv(i[4], o[s][a[2]]),
                  e.drawElements(e.TRIANGLES, 6, e.UNSIGNED_SHORT, 0),
                  e.flush(),
                  requestAnimationFrame(n)
              }()
          }
          destroy() {}
      }
      class we {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              document.querySelectorAll(".casestudyList").forEach((t=>{
                  this.initCaseStudyList(t)
              }
              ))
          }
          initCaseStudyList(t) {
              const e = t.querySelector(".casestudyList__body")
                , n = t.querySelector(".casestudyList__container")
                , r = t.querySelectorAll(".casestudyList__article")
                , i = t.querySelector(".casestudyList__prev")
                , o = t.querySelector(".casestudyList__next");
              let s = 0;
              function a(t) {
                  t.classList.add("set"),
                  setTimeout((()=>{
                      t.classList.remove("set")
                  }
                  ), 10),
                  t.classList.add("hover")
              }
              function c(t) {
                  t.classList.remove("hover")
              }
              if (i.classList.add("disable"),
              r.length <= 0 && o.classList.add("disable"),
              r.forEach((t=>{
                  t.addEventListener("touchstart", (()=>a(t))),
                  t.addEventListener("mouseenter", (()=>a(t))),
                  t.addEventListener("touchend", (()=>c(t))),
                  t.addEventListener("touchcancel", (()=>c(t))),
                  t.addEventListener("mouseleave", (()=>c(t)))
              }
              )),
              i.addEventListener("click", (()=>{
                  l(!1)
              }
              ), !1),
              o.addEventListener("click", (()=>{
                  l(!0)
              }
              ), !1),
              isTouch) {
                  let t = 0
                    , r = 0
                    , i = 0
                    , o = 0
                    , a = null
                    , c = window.innerWidth >= 1024 ? -40 : -15;
                  function u(l, u, h) {
                      t = l,
                      r = u,
                      i = l,
                      o = u,
                      a = null,
                      c = window.innerWidth >= 1024 ? -40 : -15,
                      n.style.transform = "translateX(calc(" + -100 * s + "% + " + s * c + "px)",
                      e.classList.add("dragging")
                  }
                  function h(e, l, u) {
                      if (null === a && (a = Math.abs(t - e) > Math.abs(r - l)),
                      !0 !== a)
                          return !1;
                      const h = -100 * s + "%"
                        , f = s * c + (e - t) / 2 + "px";
                      n.style.transform = "translateX(calc(" + h + " + " + f + "))",
                      i = e,
                      o = l,
                      u.preventDefault()
                  }
                  function f() {
                      n.style.transform = null,
                      e.classList.remove("dragging"),
                      Math.abs(t - i) > 30 && l(t > i)
                  }
                  e.addEventListener("touchstart", (t=>{
                      t.changedTouches ? u(t.changedTouches[0].pageX, t.changedTouches[0].pageY) : u(t.pageX, t.pageY)
                  }
                  ), !1),
                  e.addEventListener("touchmove", (t=>{
                      if (t.changedTouches ? h(t.changedTouches[0].pageX, t.changedTouches[0].pageY, t) : h(t.pageX, t.pageY),
                      a)
                          return !1
                  }
                  ), !1),
                  e.addEventListener("touchleave", (()=>{
                      n.style.transform = null,
                      e.classList.remove("dragging"),
                      l(s)
                  }
                  ), !1),
                  e.addEventListener("touchend", (t=>{
                      f()
                  }
                  ), !1),
                  e.addEventListener("touchcancel", (t=>{
                      f()
                  }
                  ), !1)
              }
              const l = t=>{
                  !0 === t ? (s = Math.min(s + 1, r.length - 1),
                  i.classList.remove("disable")) : !1 === t ? (s = Math.max(s - 1, 0),
                  o.classList.remove("disable")) : (rev.classList.remove("disable"),
                  o.classList.remove("disable")),
                  s >= r.length - 1 && o.classList.add("disable"),
                  s <= 0 && i.classList.add("disable"),
                  n.setAttribute("data-position", s)
              }
          }
          destroy() {}
      }
      class be {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              const t = document.querySelector(".journallist");
              t && this.initList(t);
              const e = document.querySelectorAll(".journal__recent__article");
              e && e.forEach((t=>this.initRecent(t)))
          }
          initList(t) {
              const e = document.querySelector(".journallist__bg")
                , n = e.querySelector(".journallist__bg__image")
                , r = e.closest("*[data-scroll-section]");
              t.querySelectorAll(".journallist__article");
              let i = 0
                , o = 0
                , s = 0
                , a = 0;
              this.animID = null;
              const c = t;
              this.observer = new MutationObserver((t=>{
                  t.forEach((t=>{
                      Array.from(t.addedNodes).filter((t=>t.classList.contains("journallist__article"))).forEach((t=>u(t)))
                  }
                  ))
              }
              )),
              this.observer.observe(c, {
                  childList: !0
              });
              const l = document.body.classList.contains("journal-index");
              window.biFundamentals.locomotion.locomotion.on("scroll", (t=>{
                  l ? e.style.transform = "translateY(" + t.scroll.y + "px)" : Object.keys(t.currentElements).length > 0 && Object.values(t.currentElements).filter((t=>t.id == r.getAttribute("data-scroll-section-id"))).forEach((n=>{
                      e.style.transform = "translateY(" + -1 * (n.top - t.scroll.y) + "px)"
                  }
                  ))
              }
              ));
              const u = t=>{
                  t.addEventListener("mouseenter", (()=>{
                      n.querySelectorAll(".journallist__bg__image__img.appear").forEach((t=>{
                          t.classList.remove("appear")
                      }
                      )),
                      n.querySelector(".journallist__bg__image__img[data-num='" + t.dataset.num + "']").classList.add("appear"),
                      n.classList.add("appear"),
                      n.classList.add("set"),
                      setTimeout((()=>{
                          n.classList.remove("set")
                      }
                      ), 10)
                  }
                  ), !1),
                  t.addEventListener("mouseleave", (()=>{
                      n.classList.remove("appear")
                  }
                  ), !1),
                  t.addEventListener("touchstart", (()=>{
                      t.classList.add("hover")
                  }
                  )),
                  t.addEventListener("touchend", (()=>{
                      t.classList.remove("hover")
                  }
                  )),
                  t.addEventListener("touchcancel", (()=>{
                      t.classList.remove("hover")
                  }
                  ))
              }
                , h = ()=>{
                  const t = (s - i) / 20
                    , e = (a - o) / 20;
                  i += t,
                  o += e,
                  (Math.abs(t) > .1 || Math.abs(e) > .1) && (this.animID = requestAnimationFrame(h)),
                  n.style.transform = "translate(" + i + "px, calc(-50% + " + o + "px))"
              }
              ;
              r.addEventListener("mousemove", (t=>{
                  s = t.pageX + 100,
                  a = t.pageY,
                  this.animID && cancelAnimationFrame(this.animID),
                  this.animID = requestAnimationFrame(h)
              }
              ), !1),
              t.querySelectorAll(".journallist__article").forEach((t=>u(t)))
          }
          initRecent(t) {
              const e = t.querySelector(".journal__recent__article__image");
              t.addEventListener("mouseenter", (()=>{
                  e.classList.add("set"),
                  setTimeout((()=>{
                      e.classList.remove("set")
                  }
                  ), 10)
              }
              )),
              t.addEventListener("touchstart", (()=>{
                  t.classList.add("hover")
              }
              )),
              t.addEventListener("touchend", (()=>{
                  t.classList.remove("hover")
              }
              )),
              t.addEventListener("touchcancel", (()=>{
                  t.classList.remove("hover")
              }
              ))
          }
          destroy() {
              this.animID && cancelAnimationFrame(this.animID),
              this.observer && (this.observer.disconnect(),
              this.observer = null)
          }
      }
      class Ee {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              document.querySelectorAll(".indexHeader__search__block").forEach((t=>{
                  this.initFilter(t)
              }
              ))
          }
          initFilter(t) {
              const e = t.querySelector(".indexHeader__search__block__label")
                , n = t.querySelector(".indexHeader__search__block__selection");
              n.addEventListener("change", (()=>{
                  const t = n.querySelector("option[value='" + n.value + "']").innerText;
                  e.innerText = t,
                  window.biFundamentals.pjax.barba.go(n.value)
              }
              ))
          }
          destroy() {}
      }
      class xe {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.intervals = [],
              this.initialize()
          }
          initialize() {
              document.querySelectorAll(".slideshow").forEach((t=>{
                  const e = document.createElement("div")
                    , n = t.querySelectorAll(".slideshow__image").length;
                  e.classList.add("slideshow__pager");
                  for (let t = 0; t < n; t++) {
                      const n = document.createElement("div");
                      n.classList.add("slideshow__pager__page"),
                      n.setAttribute("data-num", t),
                      e.appendChild(n)
                  }
                  t.appendChild(e)
              }
              )),
              window.biFundamentals.locomotion.locomotion.on("scroll", (t=>{
                  Object.keys(t.currentElements).length > 0 && Object.values(t.currentElements).filter((t=>{
                      const e = t.el.classList.contains("slideshow")
                        , n = t.el.hasAttribute("data-slideshowready");
                      return e && !n
                  }
                  )).forEach((t=>{
                      this.intervals.push(this.initSlideshow(t.el))
                  }
                  ))
              }
              ))
          }
          initSlideshow(t) {
              const e = t
                , n = e.querySelectorAll(".slideshow__image")
                , r = e.querySelector(".slideshow__viewport");
              let i = 0;
              const o = {
                  id: null
              };
              r.addEventListener("click", (()=>{
                  o.id && clearInterval(o.id),
                  i++,
                  i >= n.length && (i = 0),
                  e.setAttribute("data-position", i),
                  s()
              }
              ));
              const s = ()=>{
                  o.id = setInterval((()=>{
                      i++,
                      i >= n.length && (i = 0),
                      e.setAttribute("data-position", i)
                  }
                  ), 5e3)
              }
              ;
              return setTimeout((()=>{
                  e.setAttribute("data-position", i)
              }
              ), 50),
              e.setAttribute("data-slideshowready", "1"),
              s(),
              o
          }
          destroy() {
              for (; this.intervals.length > 0; ) {
                  const t = this.intervals.pop();
                  clearInterval(t.id)
              }
          }
      }
      class _e {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              document.querySelectorAll(".postsloader").forEach((t=>{
                  this.initPostsLoader(t)
              }
              ))
          }
          initPostsLoader(t) {
              const e = t.querySelector(".postsloader__container")
                , n = t.querySelector(".postsloader__button");
              n && n.addEventListener("click", (r=>{
                  const i = new XMLHttpRequest;
                  return i.addEventListener("load", (r=>{
                      const i = r.target.response.querySelectorAll(".postsloader__posts")
                        , o = r.target.response.querySelector(".postsloader__button");
                      if (n.remove(),
                      i.forEach((t=>{
                          e.append(t)
                      }
                      )),
                      o && (t.append(o),
                      this.initialize()),
                      e.classList.contains("journallist")) {
                          const t = document.querySelector(".journallist__bg__image");
                          r.target.response.querySelectorAll(".journallist__bg__image__img").forEach((e=>{
                              t.append(e)
                          }
                          ))
                      }
                      window.biFundamentals.locomotion.locomotion.update(),
                      setTimeout((()=>t.classList.remove("loading")), 100)
                  }
                  ), !1),
                  i.addEventListener("error", (t=>{
                      console.log("posts load error"),
                      console.log(t)
                  }
                  ), !1),
                  i.open("GET", n.getAttribute("href"), !0),
                  i.responseType = "document",
                  i.send(null),
                  t.classList.add("loading"),
                  r.stopPropagation(),
                  r.preventDefault(),
                  !1
              }
              ), !1)
          }
          destroy() {}
      }
      class ke {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              const t = document.querySelectorAll("a[data-sharesns='tw']")
                , e = document.querySelectorAll("a[data-sharesns='fb']")
                , n = t=>{
                  var e = (screen.width - 600) / 2
                    , n = (screen.height - 600) / 2;
                  window.open(t, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600,left=" + e + ",top=" + n)
              }
              ;
              t.forEach((t=>{
                  t.addEventListener("click", (e=>{
                      var r = "https://twitter.com/intent/tweet?text=";
                      return r += encodeURIComponent(t.dataset.sharetext),
                      r += "&url=" + encodeURIComponent(t.dataset.shareurl),
                      n(r),
                      e.stopPropagation(),
                      e.preventDefault(),
                      !1
                  }
                  ), !1)
              }
              )),
              e.forEach((t=>{
                  t.addEventListener("click", (e=>{
                      var r = "https://www.facebook.com/sharer/sharer.php?u=";
                      return r += encodeURIComponent(t.dataset.shareurl),
                      n(r),
                      e.stopPropagation(),
                      e.preventDefault(),
                      !1
                  }
                  ), !1)
              }
              ))
          }
          destroy() {}
      }
      class Se {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize();
              const t = document.querySelector(".inputform.downloadform__form");
              t && this.initForm(t)
          }
          initialize() {
              document.querySelectorAll(".inputform:not(.downloadform__form)").forEach((t=>this.initForm(t)))
          }
          initForm(t) {
              const e = t.dataset.sendpath
                , n = t.querySelector(".inputform__send")
                , r = t.querySelectorAll(".inputform__error")
                , i = t.querySelectorAll(".inputform__error__msg");
              function o() {
                  const e = t.querySelector(".inputform__error.failed");
                  e && (e.style.display = "block"),
                  n.classList.remove("processing"),
                  window.biFundamentals.locomotion.locomotion.update()
              }
              n.addEventListener("click", (s=>{
                  s.preventDefault();
                  const a = new XMLHttpRequest
                    , c = new FormData(t);
                  r.forEach((t=>t.style.display = "none")),
                  i.forEach((t=>t.style.display = "none")),
                  n.classList.add("processing"),
                  t.classList.remove("invalid"),
                  a.addEventListener("load", (e=>{
                      if (4 == e.target.readyState && 200 == e.target.status) {
                          let r = e.target.response;
                          r && ("string" == typeof r && (r = JSON.parse(r)),
                          r.status ? (console.log("STATUS EXISTS"),
                          "invalid" == r.status ? (console.log("INVALID"),
                          function(e) {
                              const r = t.querySelector(".inputform__error.invalid");
                              r && (r.style.display = "block");
                              for (var i = 0; i < e.length; i++)
                                  t.querySelector(".inputform__error__msg#" + e[i]).style.display = "block";
                              n.classList.remove("processing"),
                              window.biFundamentals.locomotion.locomotion.update()
                          }(r.error)) : "ok" == r.status ? (console.log("OK"),
                          function() {
                              const e = t.querySelector(".inputform__done");
                              e && (e.style.display = "block"),
                              n.classList.remove("processing"),
                              n.classList.add("done"),
                              t.classList.add("done"),
                              window.biFundamentals.locomotion.locomotion.update()
                          }()) : (console.log("UNKNOWN STATUS"),
                          o())) : (console.log("NO STATUS"),
                          o()))
                      } else
                          console.log("NO RECIEVED"),
                          o()
                  }
                  )),
                  a.addEventListener("error", (t=>{
                      console.log("OTHER ERROR"),
                      o()
                  }
                  )),
                  a.open("POST", e, !0),
                  a.responseType = "json",
                  a.send(c)
              }
              ), !1)
          }
          initDownloadForm() {}
          destroy() {}
      }
      class Te {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initBtn()), !1),
              this.initialize(),
              this.initBtn()
          }
          initialize() {
              const t = document.querySelector(".footer__download")
                , e = document.querySelector(".downloadform__close")
                , n = document.querySelector(".downloadform")
                , r = document.querySelector(".downloadform__body");
              function i(t) {
                  return document.body.classList.toggle("openDownloadForm"),
                  t.stopPropagation(),
                  t.preventDefault(),
                  !1
              }
              function o() {
                  n.style.maxHeight = document.documentElement.clientHeight + "px",
                  r.style.maxHeight = document.documentElement.clientHeight + "px"
              }
              t.addEventListener("click", i, !1),
              e.addEventListener("click", i, !1),
              window.addEventListener("resize", o, !1),
              o()
          }
          initBtn() {
              document.querySelectorAll(".opendownloadform").forEach((t=>{
                  t.addEventListener("click", (t=>(document.body.classList.toggle("openDownloadForm"),
                  t.stopPropagation(),
                  t.preventDefault(),
                  !1)), !1)
              }
              ))
          }
      }
      class Ae {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.afterTransition()), !1),
              this.initialize()
          }
          initialize() {
              const t = document.querySelector(".header")
                , e = document.querySelector(".header__nav")
                , n = document.querySelector(".header__nav__container")
                , r = document.querySelectorAll(".header__toggle");
              this.isNavOpen = !1;
              const i = ()=>{
                  n.style.height = window.innerHeight + "px",
                  e.style.height = this.isNavOpen ? window.innerHeight + "px" : "0px"
              }
              ;
              r.forEach((e=>{
                  e.addEventListener("click", (()=>{
                      this.isNavOpen ? (t.classList.remove("open"),
                      this.isNavOpen = !1) : (t.classList.add("open"),
                      this.isNavOpen = !0),
                      i()
                  }
                  ), !1)
              }
              )),
              window.addEventListener("resize", i, !1),
              i()
          }
          afterTransition() {
              const t = document.querySelector(".header")
                , e = document.querySelector(".header__nav");
              t.classList.add("noDuration"),
              t.classList.remove("open"),
              e.style.height = "0px",
              this.isNavOpen = !1,
              requestAnimationFrame((()=>{
                  t.classList.remove("noDuration")
              }
              ))
          }
      }
      class Le {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize(),
              window.addEventListener("resize", (()=>this.resizeHandler()), !1)
          }
          initialize() {
              this.index = document.querySelector(".index__hero"),
              this.article = document.querySelector(".article__header"),
              this.hero = document.querySelector(".singlepageHero"),
              this.content = document.querySelector(".singlepageHero__contents"),
              this.resizeHandler()
          }
          resizeHandler() {
              window.innerWidth < 1024 ? (this.index && (this.index.style.height = document.documentElement.clientHeight + "px"),
              this.article && (this.article.style.height = document.documentElement.clientHeight + "px"),
              this.hero && (this.hero.style.minHeight = document.documentElement.clientHeight + "px"),
              this.content && (this.content.style.minHeight = document.documentElement.clientHeight - 30 + "px")) : (this.index && (this.index.style.height = null),
              this.article && (this.article.style.height = null),
              this.hero && (this.hero.style.minHeight = null),
              this.content && (this.content.style.minHeight = null))
          }
          destroy() {
              this.index = null,
              this.article = null,
              this.hero = null,
              this.content = null
          }
      }
      class Oe {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              this.initialize()
          }
          initialize() {
              document.querySelectorAll([".gradientBanner", ".article__nextwork", ".circleButton", ".circleButton--wh", ".circleButton--prev", ".footer__download", ".article__link", ".article__worksintro__services__list li a", ".article__colophone__member__link", ".works__index__more", ".journal__list__more", ".works__categories__services__link", ".works__categories__members__link", ".about__member__block__link", ".article__toc__link"].join(",")).forEach((t=>{
                  t.addEventListener("touchstart", (()=>{
                      t.classList.add("hover")
                  }
                  )),
                  t.addEventListener("touchend", (()=>{
                      t.classList.remove("hover")
                  }
                  )),
                  t.addEventListener("touchcancel", (()=>{
                      t.classList.remove("hover")
                  }
                  ))
              }
              ))
          }
      }
      function je(t, e) {
          if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function")
      }
      function Pe(t, e) {
          for (var n = 0; n < e.length; n++) {
              var r = e[n];
              r.enumerable = r.enumerable || !1,
              r.configurable = !0,
              "value"in r && (r.writable = !0),
              Object.defineProperty(t, r.key, r)
          }
      }
      var Me = void 0 !== n.g && "[object global]" === {}.toString.call(n.g);
      function Ce(t, e) {
          return 0 === t.indexOf(e.toLowerCase()) ? t : "".concat(e.toLowerCase()).concat(t.substr(0, 1).toUpperCase()).concat(t.substr(1))
      }
      function Re(t) {
          return Boolean(t && 1 === t.nodeType && "nodeName"in t && t.ownerDocument && t.ownerDocument.defaultView)
      }
      function Ie(t) {
          return !isNaN(parseFloat(t)) && isFinite(t) && Math.floor(t) == t
      }
      function qe(t) {
          return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(t)
      }
      function De() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}
            , e = t.id
            , n = t.url
            , r = e || n;
          if (!r)
              throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
          if (Ie(r))
              return "https://vimeo.com/".concat(r);
          if (qe(r))
              return r.replace("http:", "https:");
          if (e)
              throw new TypeError("“".concat(e, "” is not a valid video id."));
          throw new TypeError("“".concat(r, "” is not a vimeo.com url."))
      }
      var Fe = void 0 !== Array.prototype.indexOf
        , Be = "undefined" != typeof window && void 0 !== window.postMessage;
      if (!(Me || Fe && Be))
          throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
      var He = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : "undefined" != typeof self ? self : {};
      !function(t) {
          if (!t.WeakMap) {
              var e = Object.prototype.hasOwnProperty
                , n = Object.defineProperty && function() {
                  try {
                      return 1 === Object.defineProperty({}, "x", {
                          value: 1
                      }).x
                  } catch (t) {}
              }()
                , r = function(t, e, r) {
                  n ? Object.defineProperty(t, e, {
                      configurable: !0,
                      writable: !0,
                      value: r
                  }) : t[e] = r
              };
              t.WeakMap = function() {
                  function t() {
                      if (void 0 === this)
                          throw new TypeError("Constructor WeakMap requires 'new'");
                      if (r(this, "_id", o("_WeakMap")),
                      arguments.length > 0)
                          throw new TypeError("WeakMap iterable is not supported")
                  }
                  function n(t, n) {
                      if (!i(t) || !e.call(t, "_id"))
                          throw new TypeError(n + " method called on incompatible receiver " + typeof t)
                  }
                  function o(t) {
                      return t + "_" + s() + "." + s()
                  }
                  function s() {
                      return Math.random().toString().substring(2)
                  }
                  return r(t.prototype, "delete", (function(t) {
                      if (n(this, "delete"),
                      !i(t))
                          return !1;
                      var e = t[this._id];
                      return !(!e || e[0] !== t || (delete t[this._id],
                      0))
                  }
                  )),
                  r(t.prototype, "get", (function(t) {
                      if (n(this, "get"),
                      i(t)) {
                          var e = t[this._id];
                          return e && e[0] === t ? e[1] : void 0
                      }
                  }
                  )),
                  r(t.prototype, "has", (function(t) {
                      if (n(this, "has"),
                      !i(t))
                          return !1;
                      var e = t[this._id];
                      return !(!e || e[0] !== t)
                  }
                  )),
                  r(t.prototype, "set", (function(t, e) {
                      if (n(this, "set"),
                      !i(t))
                          throw new TypeError("Invalid value used as weak map key");
                      var o = t[this._id];
                      return o && o[0] === t ? (o[1] = e,
                      this) : (r(t, this._id, [t, e]),
                      this)
                  }
                  )),
                  r(t, "_polyfill", !0),
                  t
              }()
          }
          function i(t) {
              return Object(t) === t
          }
      }("undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : He);
      var Ne, ze, We = (Ne = function(t) {
          var e, n, r;
          r = function() {
              var t, e, n, r = Object.prototype.toString, i = "undefined" != typeof setImmediate ? function(t) {
                  return setImmediate(t)
              }
              : setTimeout;
              try {
                  Object.defineProperty({}, "x", {}),
                  t = function(t, e, n, r) {
                      return Object.defineProperty(t, e, {
                          value: n,
                          writable: !0,
                          configurable: !1 !== r
                      })
                  }
              } catch (e) {
                  t = function(t, e, n) {
                      return t[e] = n,
                      t
                  }
              }
              function o(t, r) {
                  n.add(t, r),
                  e || (e = i(n.drain))
              }
              function s(t) {
                  var e, n = typeof t;
                  return null == t || "object" != n && "function" != n || (e = t.then),
                  "function" == typeof e && e
              }
              function a() {
                  for (var t = 0; t < this.chain.length; t++)
                      c(this, 1 === this.state ? this.chain[t].success : this.chain[t].failure, this.chain[t]);
                  this.chain.length = 0
              }
              function c(t, e, n) {
                  var r, i;
                  try {
                      !1 === e ? n.reject(t.msg) : (r = !0 === e ? t.msg : e.call(void 0, t.msg)) === n.promise ? n.reject(TypeError("Promise-chain cycle")) : (i = s(r)) ? i.call(r, n.resolve, n.reject) : n.resolve(r)
                  } catch (t) {
                      n.reject(t)
                  }
              }
              function l(t) {
                  var e, n = this;
                  if (!n.triggered) {
                      n.triggered = !0,
                      n.def && (n = n.def);
                      try {
                          (e = s(t)) ? o((function() {
                              var r = new f(n);
                              try {
                                  e.call(t, (function() {
                                      l.apply(r, arguments)
                                  }
                                  ), (function() {
                                      u.apply(r, arguments)
                                  }
                                  ))
                              } catch (t) {
                                  u.call(r, t)
                              }
                          }
                          )) : (n.msg = t,
                          n.state = 1,
                          n.chain.length > 0 && o(a, n))
                      } catch (t) {
                          u.call(new f(n), t)
                      }
                  }
              }
              function u(t) {
                  var e = this;
                  e.triggered || (e.triggered = !0,
                  e.def && (e = e.def),
                  e.msg = t,
                  e.state = 2,
                  e.chain.length > 0 && o(a, e))
              }
              function h(t, e, n, r) {
                  for (var i = 0; i < e.length; i++)
                      !function(i) {
                          t.resolve(e[i]).then((function(t) {
                              n(i, t)
                          }
                          ), r)
                      }(i)
              }
              function f(t) {
                  this.def = t,
                  this.triggered = !1
              }
              function d(t) {
                  this.promise = t,
                  this.state = 0,
                  this.triggered = !1,
                  this.chain = [],
                  this.msg = void 0
              }
              function p(t) {
                  if ("function" != typeof t)
                      throw TypeError("Not a function");
                  if (0 !== this.__NPO__)
                      throw TypeError("Not a promise");
                  this.__NPO__ = 1;
                  var e = new d(this);
                  this.then = function(t, n) {
                      var r = {
                          success: "function" != typeof t || t,
                          failure: "function" == typeof n && n
                      };
                      return r.promise = new this.constructor((function(t, e) {
                          if ("function" != typeof t || "function" != typeof e)
                              throw TypeError("Not a function");
                          r.resolve = t,
                          r.reject = e
                      }
                      )),
                      e.chain.push(r),
                      0 !== e.state && o(a, e),
                      r.promise
                  }
                  ,
                  this.catch = function(t) {
                      return this.then(void 0, t)
                  }
                  ;
                  try {
                      t.call(void 0, (function(t) {
                          l.call(e, t)
                      }
                      ), (function(t) {
                          u.call(e, t)
                      }
                      ))
                  } catch (t) {
                      u.call(e, t)
                  }
              }
              n = function() {
                  var t, n, r;
                  function i(t, e) {
                      this.fn = t,
                      this.self = e,
                      this.next = void 0
                  }
                  return {
                      add: function(e, o) {
                          r = new i(e,o),
                          n ? n.next = r : t = r,
                          n = r,
                          r = void 0
                      },
                      drain: function() {
                          var r = t;
                          for (t = n = e = void 0; r; )
                              r.fn.call(r.self),
                              r = r.next
                      }
                  }
              }();
              var v = t({}, "constructor", p, !1);
              return p.prototype = v,
              t(v, "__NPO__", 0, !1),
              t(p, "resolve", (function(t) {
                  return t && "object" == typeof t && 1 === t.__NPO__ ? t : new this((function(e, n) {
                      if ("function" != typeof e || "function" != typeof n)
                          throw TypeError("Not a function");
                      e(t)
                  }
                  ))
              }
              )),
              t(p, "reject", (function(t) {
                  return new this((function(e, n) {
                      if ("function" != typeof e || "function" != typeof n)
                          throw TypeError("Not a function");
                      n(t)
                  }
                  ))
              }
              )),
              t(p, "all", (function(t) {
                  var e = this;
                  return "[object Array]" != r.call(t) ? e.reject(TypeError("Not an array")) : 0 === t.length ? e.resolve([]) : new e((function(n, r) {
                      if ("function" != typeof n || "function" != typeof r)
                          throw TypeError("Not a function");
                      var i = t.length
                        , o = Array(i)
                        , s = 0;
                      h(e, t, (function(t, e) {
                          o[t] = e,
                          ++s === i && n(o)
                      }
                      ), r)
                  }
                  ))
              }
              )),
              t(p, "race", (function(t) {
                  var e = this;
                  return "[object Array]" != r.call(t) ? e.reject(TypeError("Not an array")) : new e((function(n, r) {
                      if ("function" != typeof n || "function" != typeof r)
                          throw TypeError("Not a function");
                      h(e, t, (function(t, e) {
                          n(e)
                      }
                      ), r)
                  }
                  ))
              }
              )),
              p
          }
          ,
          (n = He)[e = "Promise"] = n[e] || r(),
          t.exports && (t.exports = n[e])
      }
      ,
      Ne(ze = {
          exports: {}
      }),
      ze.exports), Ye = new WeakMap;
      function Ve(t, e, n) {
          var r = Ye.get(t.element) || {};
          e in r || (r[e] = []),
          r[e].push(n),
          Ye.set(t.element, r)
      }
      function Ue(t, e) {
          return (Ye.get(t.element) || {})[e] || []
      }
      function Xe(t, e, n) {
          var r = Ye.get(t.element) || {};
          if (!r[e])
              return !0;
          if (!n)
              return r[e] = [],
              Ye.set(t.element, r),
              !0;
          var i = r[e].indexOf(n);
          return -1 !== i && r[e].splice(i, 1),
          Ye.set(t.element, r),
          r[e] && 0 === r[e].length
      }
      function $e(t, e) {
          var n = Ye.get(t);
          Ye.set(e, n),
          Ye.delete(t)
      }
      var Ge = ["autopause", "autoplay", "background", "byline", "color", "controls", "dnt", "height", "id", "keyboard", "loop", "maxheight", "maxwidth", "muted", "playsinline", "portrait", "responsive", "speed", "texttrack", "title", "transparent", "url", "width"];
      function Ke(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Ge.reduce((function(e, n) {
              var r = t.getAttribute("data-vimeo-".concat(n));
              return (r || "" === r) && (e[n] = "" === r ? 1 : r),
              e
          }
          ), e)
      }
      function Qe(t, e) {
          var n = t.html;
          if (!e)
              throw new TypeError("An element must be provided");
          if (null !== e.getAttribute("data-vimeo-initialized"))
              return e.querySelector("iframe");
          var r = document.createElement("div");
          return r.innerHTML = n,
          e.appendChild(r.firstChild),
          e.setAttribute("data-vimeo-initialized", "true"),
          e.querySelector("iframe")
      }
      function Je(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
            , n = arguments.length > 2 ? arguments[2] : void 0;
          return new Promise((function(r, i) {
              if (!qe(t))
                  throw new TypeError("“".concat(t, "” is not a vimeo.com url."));
              var o = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(t));
              for (var s in e)
                  e.hasOwnProperty(s) && (o += "&".concat(s, "=").concat(encodeURIComponent(e[s])));
              var a = "XDomainRequest"in window ? new XDomainRequest : new XMLHttpRequest;
              a.open("GET", o, !0),
              a.onload = function() {
                  if (404 !== a.status)
                      if (403 !== a.status)
                          try {
                              var e = JSON.parse(a.responseText);
                              if (403 === e.domain_status_code)
                                  return Qe(e, n),
                                  void i(new Error("“".concat(t, "” is not embeddable.")));
                              r(e)
                          } catch (t) {
                              i(t)
                          }
                      else
                          i(new Error("“".concat(t, "” is not embeddable.")));
                  else
                      i(new Error("“".concat(t, "” was not found.")))
              }
              ,
              a.onerror = function() {
                  var t = a.status ? " (".concat(a.status, ")") : "";
                  i(new Error("There was an error fetching the embed code from Vimeo".concat(t, ".")))
              }
              ,
              a.send()
          }
          ))
      }
      function Ze(t) {
          if ("string" == typeof t)
              try {
                  t = JSON.parse(t)
              } catch (t) {
                  return console.warn(t),
                  {}
              }
          return t
      }
      function tn(t, e, n) {
          if (t.element.contentWindow && t.element.contentWindow.postMessage) {
              var r = {
                  method: e
              };
              void 0 !== n && (r.value = n);
              var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
              i >= 8 && i < 10 && (r = JSON.stringify(r)),
              t.element.contentWindow.postMessage(r, t.origin)
          }
      }
      function en(t, e) {
          var n, r = [];
          if ((e = Ze(e)).event)
              "error" === e.event && Ue(t, e.data.method).forEach((function(n) {
                  var r = new Error(e.data.message);
                  r.name = e.data.name,
                  n.reject(r),
                  Xe(t, e.data.method, n)
              }
              )),
              r = Ue(t, "event:".concat(e.event)),
              n = e.data;
          else if (e.method) {
              var i = function(t, e) {
                  var n = Ue(t, e);
                  if (n.length < 1)
                      return !1;
                  var r = n.shift();
                  return Xe(t, e, r),
                  r
              }(t, e.method);
              i && (r.push(i),
              n = e.value)
          }
          r.forEach((function(e) {
              try {
                  if ("function" == typeof e)
                      return void e.call(t, n);
                  e.resolve(n)
              } catch (t) {}
          }
          ))
      }
      var nn = new WeakMap
        , rn = new WeakMap
        , on = {}
        , sn = function() {
          function t(e) {
              var n = this
                , r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (je(this, t),
              window.jQuery && e instanceof jQuery && (e.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."),
              e = e[0]),
              "undefined" != typeof document && "string" == typeof e && (e = document.getElementById(e)),
              !Re(e))
                  throw new TypeError("You must pass either a valid element or a valid id.");
              if ("IFRAME" !== e.nodeName) {
                  var i = e.querySelector("iframe");
                  i && (e = i)
              }
              if ("IFRAME" === e.nodeName && !qe(e.getAttribute("src") || ""))
                  throw new Error("The player element passed isn’t a Vimeo embed.");
              if (nn.has(e))
                  return nn.get(e);
              this._window = e.ownerDocument.defaultView,
              this.element = e,
              this.origin = "*";
              var o = new We((function(t, i) {
                  if (n._onMessage = function(e) {
                      if (qe(e.origin) && n.element.contentWindow === e.source) {
                          "*" === n.origin && (n.origin = e.origin);
                          var r = Ze(e.data);
                          if (r && "error" === r.event && r.data && "ready" === r.data.method) {
                              var o = new Error(r.data.message);
                              return o.name = r.data.name,
                              void i(o)
                          }
                          var s = r && "ready" === r.event
                            , a = r && "ping" === r.method;
                          if (s || a)
                              return n.element.setAttribute("data-ready", "true"),
                              void t();
                          en(n, r)
                      }
                  }
                  ,
                  n._window.addEventListener("message", n._onMessage),
                  "IFRAME" !== n.element.nodeName) {
                      var o = Ke(e, r);
                      Je(De(o), o, e).then((function(t) {
                          var r = Qe(t, e);
                          return n.element = r,
                          n._originalElement = e,
                          $e(e, r),
                          nn.set(n.element, n),
                          t
                      }
                      )).catch(i)
                  }
              }
              ));
              if (rn.set(this, o),
              nn.set(this.element, this),
              "IFRAME" === this.element.nodeName && tn(this, "ping"),
              on.isEnabled) {
                  var s = function() {
                      return on.exit()
                  };
                  this.fullscreenchangeHandler = function() {
                      on.isFullscreen ? Ve(n, "event:exitFullscreen", s) : Xe(n, "event:exitFullscreen", s),
                      n.ready().then((function() {
                          tn(n, "fullscreenchange", on.isFullscreen)
                      }
                      ))
                  }
                  ,
                  on.on("fullscreenchange", this.fullscreenchangeHandler)
              }
              return this
          }
          var e, n;
          return e = t,
          n = [{
              key: "callMethod",
              value: function(t) {
                  var e = this
                    , n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return new We((function(r, i) {
                      return e.ready().then((function() {
                          Ve(e, t, {
                              resolve: r,
                              reject: i
                          }),
                          tn(e, t, n)
                      }
                      )).catch(i)
                  }
                  ))
              }
          }, {
              key: "get",
              value: function(t) {
                  var e = this;
                  return new We((function(n, r) {
                      return t = Ce(t, "get"),
                      e.ready().then((function() {
                          Ve(e, t, {
                              resolve: n,
                              reject: r
                          }),
                          tn(e, t)
                      }
                      )).catch(r)
                  }
                  ))
              }
          }, {
              key: "set",
              value: function(t, e) {
                  var n = this;
                  return new We((function(r, i) {
                      if (t = Ce(t, "set"),
                      null == e)
                          throw new TypeError("There must be a value to set.");
                      return n.ready().then((function() {
                          Ve(n, t, {
                              resolve: r,
                              reject: i
                          }),
                          tn(n, t, e)
                      }
                      )).catch(i)
                  }
                  ))
              }
          }, {
              key: "on",
              value: function(t, e) {
                  if (!t)
                      throw new TypeError("You must pass an event name.");
                  if (!e)
                      throw new TypeError("You must pass a callback function.");
                  if ("function" != typeof e)
                      throw new TypeError("The callback must be a function.");
                  0 === Ue(this, "event:".concat(t)).length && this.callMethod("addEventListener", t).catch((function() {}
                  )),
                  Ve(this, "event:".concat(t), e)
              }
          }, {
              key: "off",
              value: function(t, e) {
                  if (!t)
                      throw new TypeError("You must pass an event name.");
                  if (e && "function" != typeof e)
                      throw new TypeError("The callback must be a function.");
                  Xe(this, "event:".concat(t), e) && this.callMethod("removeEventListener", t).catch((function(t) {}
                  ))
              }
          }, {
              key: "loadVideo",
              value: function(t) {
                  return this.callMethod("loadVideo", t)
              }
          }, {
              key: "ready",
              value: function() {
                  var t = rn.get(this) || new We((function(t, e) {
                      e(new Error("Unknown player. Probably unloaded."))
                  }
                  ));
                  return We.resolve(t)
              }
          }, {
              key: "addCuePoint",
              value: function(t) {
                  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                  return this.callMethod("addCuePoint", {
                      time: t,
                      data: e
                  })
              }
          }, {
              key: "removeCuePoint",
              value: function(t) {
                  return this.callMethod("removeCuePoint", t)
              }
          }, {
              key: "enableTextTrack",
              value: function(t, e) {
                  if (!t)
                      throw new TypeError("You must pass a language.");
                  return this.callMethod("enableTextTrack", {
                      language: t,
                      kind: e
                  })
              }
          }, {
              key: "disableTextTrack",
              value: function() {
                  return this.callMethod("disableTextTrack")
              }
          }, {
              key: "pause",
              value: function() {
                  return this.callMethod("pause")
              }
          }, {
              key: "play",
              value: function() {
                  return this.callMethod("play")
              }
          }, {
              key: "requestFullscreen",
              value: function() {
                  return on.isEnabled ? on.request(this.element) : this.callMethod("requestFullscreen")
              }
          }, {
              key: "exitFullscreen",
              value: function() {
                  return on.isEnabled ? on.exit() : this.callMethod("exitFullscreen")
              }
          }, {
              key: "getFullscreen",
              value: function() {
                  return on.isEnabled ? We.resolve(on.isFullscreen) : this.get("fullscreen")
              }
          }, {
              key: "requestPictureInPicture",
              value: function() {
                  return this.callMethod("requestPictureInPicture")
              }
          }, {
              key: "exitPictureInPicture",
              value: function() {
                  return this.callMethod("exitPictureInPicture")
              }
          }, {
              key: "getPictureInPicture",
              value: function() {
                  return this.get("pictureInPicture")
              }
          }, {
              key: "unload",
              value: function() {
                  return this.callMethod("unload")
              }
          }, {
              key: "destroy",
              value: function() {
                  var t = this;
                  return new We((function(e) {
                      if (rn.delete(t),
                      nn.delete(t.element),
                      t._originalElement && (nn.delete(t._originalElement),
                      t._originalElement.removeAttribute("data-vimeo-initialized")),
                      t.element && "IFRAME" === t.element.nodeName && t.element.parentNode && (t.element.parentNode.parentNode && t._originalElement && t._originalElement !== t.element.parentNode ? t.element.parentNode.parentNode.removeChild(t.element.parentNode) : t.element.parentNode.removeChild(t.element)),
                      t.element && "DIV" === t.element.nodeName && t.element.parentNode) {
                          t.element.removeAttribute("data-vimeo-initialized");
                          var n = t.element.querySelector("iframe");
                          n && n.parentNode && (n.parentNode.parentNode && t._originalElement && t._originalElement !== n.parentNode ? n.parentNode.parentNode.removeChild(n.parentNode) : n.parentNode.removeChild(n))
                      }
                      t._window.removeEventListener("message", t._onMessage),
                      on.isEnabled && on.off("fullscreenchange", t.fullscreenchangeHandler),
                      e()
                  }
                  ))
              }
          }, {
              key: "getAutopause",
              value: function() {
                  return this.get("autopause")
              }
          }, {
              key: "setAutopause",
              value: function(t) {
                  return this.set("autopause", t)
              }
          }, {
              key: "getBuffered",
              value: function() {
                  return this.get("buffered")
              }
          }, {
              key: "getCameraProps",
              value: function() {
                  return this.get("cameraProps")
              }
          }, {
              key: "setCameraProps",
              value: function(t) {
                  return this.set("cameraProps", t)
              }
          }, {
              key: "getChapters",
              value: function() {
                  return this.get("chapters")
              }
          }, {
              key: "getCurrentChapter",
              value: function() {
                  return this.get("currentChapter")
              }
          }, {
              key: "getColor",
              value: function() {
                  return this.get("color")
              }
          }, {
              key: "setColor",
              value: function(t) {
                  return this.set("color", t)
              }
          }, {
              key: "getCuePoints",
              value: function() {
                  return this.get("cuePoints")
              }
          }, {
              key: "getCurrentTime",
              value: function() {
                  return this.get("currentTime")
              }
          }, {
              key: "setCurrentTime",
              value: function(t) {
                  return this.set("currentTime", t)
              }
          }, {
              key: "getDuration",
              value: function() {
                  return this.get("duration")
              }
          }, {
              key: "getEnded",
              value: function() {
                  return this.get("ended")
              }
          }, {
              key: "getLoop",
              value: function() {
                  return this.get("loop")
              }
          }, {
              key: "setLoop",
              value: function(t) {
                  return this.set("loop", t)
              }
          }, {
              key: "setMuted",
              value: function(t) {
                  return this.set("muted", t)
              }
          }, {
              key: "getMuted",
              value: function() {
                  return this.get("muted")
              }
          }, {
              key: "getPaused",
              value: function() {
                  return this.get("paused")
              }
          }, {
              key: "getPlaybackRate",
              value: function() {
                  return this.get("playbackRate")
              }
          }, {
              key: "setPlaybackRate",
              value: function(t) {
                  return this.set("playbackRate", t)
              }
          }, {
              key: "getPlayed",
              value: function() {
                  return this.get("played")
              }
          }, {
              key: "getQualities",
              value: function() {
                  return this.get("qualities")
              }
          }, {
              key: "getQuality",
              value: function() {
                  return this.get("quality")
              }
          }, {
              key: "setQuality",
              value: function(t) {
                  return this.set("quality", t)
              }
          }, {
              key: "getSeekable",
              value: function() {
                  return this.get("seekable")
              }
          }, {
              key: "getSeeking",
              value: function() {
                  return this.get("seeking")
              }
          }, {
              key: "getTextTracks",
              value: function() {
                  return this.get("textTracks")
              }
          }, {
              key: "getVideoEmbedCode",
              value: function() {
                  return this.get("videoEmbedCode")
              }
          }, {
              key: "getVideoId",
              value: function() {
                  return this.get("videoId")
              }
          }, {
              key: "getVideoTitle",
              value: function() {
                  return this.get("videoTitle")
              }
          }, {
              key: "getVideoWidth",
              value: function() {
                  return this.get("videoWidth")
              }
          }, {
              key: "getVideoHeight",
              value: function() {
                  return this.get("videoHeight")
              }
          }, {
              key: "getVideoUrl",
              value: function() {
                  return this.get("videoUrl")
              }
          }, {
              key: "getVolume",
              value: function() {
                  return this.get("volume")
              }
          }, {
              key: "setVolume",
              value: function(t) {
                  return this.set("volume", t)
              }
          }],
          n && Pe(e.prototype, n),
          t
      }();
      Me || (on = function() {
          var t = function() {
              for (var t, e = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]], n = 0, r = e.length, i = {}; n < r; n++)
                  if ((t = e[n]) && t[1]in document) {
                      for (n = 0; n < t.length; n++)
                          i[e[0][n]] = t[n];
                      return i
                  }
              return !1
          }()
            , e = {
              fullscreenchange: t.fullscreenchange,
              fullscreenerror: t.fullscreenerror
          }
            , n = {
              request: function(e) {
                  return new Promise((function(r, i) {
                      var o = function t() {
                          n.off("fullscreenchange", t),
                          r()
                      };
                      n.on("fullscreenchange", o);
                      var s = (e = e || document.documentElement)[t.requestFullscreen]();
                      s instanceof Promise && s.then(o).catch(i)
                  }
                  ))
              },
              exit: function() {
                  return new Promise((function(e, r) {
                      if (n.isFullscreen) {
                          var i = function t() {
                              n.off("fullscreenchange", t),
                              e()
                          };
                          n.on("fullscreenchange", i);
                          var o = document[t.exitFullscreen]();
                          o instanceof Promise && o.then(i).catch(r)
                      } else
                          e()
                  }
                  ))
              },
              on: function(t, n) {
                  var r = e[t];
                  r && document.addEventListener(r, n)
              },
              off: function(t, n) {
                  var r = e[t];
                  r && document.removeEventListener(r, n)
              }
          };
          return Object.defineProperties(n, {
              isFullscreen: {
                  get: function() {
                      return Boolean(document[t.fullscreenElement])
                  }
              },
              element: {
                  enumerable: !0,
                  get: function() {
                      return document[t.fullscreenElement]
                  }
              },
              isEnabled: {
                  enumerable: !0,
                  get: function() {
                      return Boolean(document[t.fullscreenEnabled])
                  }
              }
          }),
          n
      }(),
      function() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document
            , e = [].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"))
            , n = function(t) {
              "console"in window && console.error && console.error("There was an error creating an embed: ".concat(t))
          };
          e.forEach((function(t) {
              try {
                  if (null !== t.getAttribute("data-vimeo-defer"))
                      return;
                  var e = Ke(t);
                  Je(De(e), e, t).then((function(e) {
                      return Qe(e, t)
                  }
                  )).catch(n)
              } catch (t) {
                  n(t)
              }
          }
          ))
      }(),
      function() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document;
          if (!window.VimeoPlayerResizeEmbeds_) {
              window.VimeoPlayerResizeEmbeds_ = !0;
              var e = function(e) {
                  if (qe(e.origin) && e.data && "spacechange" === e.data.event)
                      for (var n = t.querySelectorAll("iframe"), r = 0; r < n.length; r++)
                          if (n[r].contentWindow === e.source) {
                              n[r].parentElement.style.paddingBottom = "".concat(e.data.data[0].bottom, "px");
                              break
                          }
              };
              window.addEventListener("message", e)
          }
      }());
      var an = sn;
      class cn {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("transitionComplete", (()=>this.initHeroVideo()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              this.initWhatWeDo(),
              this.initBrandingBG(),
              this.initPopupVideo()
          }
          initWhatWeDo() {
              const t = document.querySelector(".index__whatwedo");
              if (t) {
                  const e = document.querySelector(".index__main__bg__wwd");
                  function n(t) {
                      e.setAttribute("data-current", t.dataset.num),
                      e.classList.add("set"),
                      setTimeout((()=>{
                          e.classList.remove("set")
                      }
                      ), 10),
                      e.classList.add("show"),
                      t.classList.add("hover");
                      const n = e.querySelector(".index__main__bg__wwd__image[data-num='" + t.dataset.num + "']")
                        , r = Math.min(t.parentNode.offsetTop + t.parentNode.offsetHeight / 2, e.offsetHeight - window.innerWidth / 2);
                      n.style.top = r + "px"
                  }
                  function r(t) {
                      e.setAttribute("data-current", 0),
                      e.classList.remove("show"),
                      t.classList.remove("hover")
                  }
                  t.querySelectorAll(".index__whatwedo__link").forEach((t=>{
                      t.addEventListener("touchstart", (()=>n(t))),
                      t.addEventListener("mouseenter", (()=>n(t))),
                      t.addEventListener("touchend", (()=>r(t))),
                      t.addEventListener("touchcancel", (()=>r(t))),
                      t.addEventListener("mouseleave", (()=>r(t)))
                  }
                  ))
              }
          }
          initBrandingBG() {
              if (document.querySelector(".index__branding__bg")) {
                  const t = .6;
                  window.biFundamentals.locomotion.locomotion.on("scroll", (e=>{
                      Object.keys(e.currentElements).length > 0 && Object.values(e.currentElements).filter((t=>t.el.classList.contains("index__branding__bg__img"))).forEach((n=>{
                          const r = (1 + -2 * Math.abs(Math.max(0, n.top - e.scroll.y + n.el.offsetHeight / 2) / window.innerHeight - .5)) * t;
                          n.el.style.opacity = r
                      }
                      ))
                  }
                  ))
              }
          }
          initPopupVideo() {
              const t = document.querySelector(".index__popupmovie");
              if (t) {
                  const e = document.querySelector(".index__popupmovie__body")
                    , n = document.querySelectorAll(".index__popupmovie__close, .index__hero__banner")
                    , r = new an("popupvideo");
                  let i = !1;
                  const o = ()=>{
                      t.style.height = window.innerHeight + "px",
                      e.style.height = window.innerHeight + "px"
                  }
                    , s = ()=>{
                      i = !i,
                      i ? (t.classList.add("open"),
                      setTimeout((()=>{
                          r.play()
                      }
                      ), 500),
                      this.video && (this.video.paused || this.video.pause())) : (t.classList.remove("open"),
                      r.setCurrentTime(0),
                      r.pause(),
                      this.video && this.video.paused && this.video.play())
                  }
                  ;
                  this.popupResize = o.bind(this),
                  window.addEventListener("resize", this.popupResize, !1),
                  n.forEach((t=>t.addEventListener("click", s, !1)))
              }
          }
          initHeroVideo() {
              const t = document.querySelector(".index__hero");
              if (t) {
                  this.video = t.querySelector(".videoblock__media");
                  const e = t.querySelector(".videoblock__bar");
                  let n = !1;
                  const r = ()=>{
                      this.video && (requestAnimationFrame(r),
                      !this.video.paused && e && (this.video.duration - this.video.currentTime < .5 ? n || (n = !0,
                      e.classList.add("finish")) : (n && (n = !1,
                      e.classList.remove("finish")),
                      e.style.transform = "scaleX(" + this.video.currentTime / (this.video.duration - .5) + ")")))
                  }
                  ;
                  e && r(),
                  window.biFundamentals.locomotion.locomotion.on("scroll", (t=>{
                      Object.keys(t.currentElements).length > 0 && this.video && (Object.values(t.currentElements).some((t=>t.el.classList.contains("index__hero__main__container"))) ? this.video.paused && this.video.play() : this.video.paused || this.video.pause())
                  }
                  ))
              }
          }
          destroy() {
              this.popupResize && (window.removeEventListener("resize", this.popupResize, !1),
              this.popupResize = null),
              this.video && (this.video = null)
          }
      }
      class ln {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {
              this.initFlow()
          }
          initFlow() {
              const t = document.querySelector(".branding__flow");
              if (!t)
                  return;
              const e = t.querySelector(".branding__flow__main");
              window.biFundamentals.locomotion.locomotion.on("scroll", (t=>{
                  if (Object.keys(t.currentElements).length > 0) {
                      const n = Object.values(t.currentElements).filter((e=>{
                          const n = e.el.classList.contains("branding__flow__section")
                            , r = e.top - t.scroll.y <= window.innerHeight / 2;
                          return n && r
                      }
                      ));
                      n.sort(((t,e)=>t.top > e.top ? 1 : -1)),
                      n.forEach((t=>{
                          const n = 1 * t.id.substr(-1, 1);
                          e.setAttribute("data-position", n - 1)
                      }
                      ))
                  }
              }
              ));
              const n = t.querySelector(".branding__flow__nav__lang__btn[data-lang='ja']")
                , r = t.querySelector(".branding__flow__nav__lang__btn[data-lang='en']");
              n.addEventListener("click", (()=>{
                  e.setAttribute("data-lang", "ja")
              }
              ), !1),
              r.addEventListener("click", (()=>{
                  e.setAttribute("data-lang", "en")
              }
              ), !1)
          }
          destroy() {}
      }
      class un {
          constructor() {
              window.addEventListener("afterTransition", (()=>this.initialize()), !1),
              window.addEventListener("beforeTransition", (()=>this.destroy()), !1),
              this.initialize()
          }
          initialize() {}
          destroy() {}
      }
      class hn {
          constructor() {
              window.throttle = e(),
              window.debounce = i(),
              window.biFundamentals = {},
              window.biFundamentals.locomotion = new ht,
              window.biFundamentals.pjax = new pt,
              new me,
              new ge,
              new ye,
              new we,
              new be,
              new Ee,
              new xe,
              new _e,
              new ke,
              new Se,
              new Te,
              new Ae,
              new Le,
              new Oe,
              new cn,
              new ln,
              new un
          }
      }
      document.addEventListener("DOMContentLoaded", (()=>{
          window.isTouch = !1,
          (navigator.userAgent.indexOf("iPhone") > 0 || navigator.userAgent.indexOf("iPod") > 0 || navigator.userAgent.indexOf("iPad") > 0 || navigator.userAgent.indexOf("Windows Phone") > 0 || navigator.userAgent.indexOf("Android") > 0) && (window.isTouch = !0,
          document.body.classList.add("touch")),
          new hn
      }
      ), !1)
  }()
}();

var renderer, scene, camera, composer, circle, skelet, particle;

window.onload = function() {
  init();
  animate();
}

function init() {
  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio((window.devicePixelRatio) ? window.devicePixelRatio : 1);
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.autoClear = false;
  renderer.setClearColor(0x000000, 0.0);
  document.getElementById('canvas').appendChild(renderer.domElement);

  scene = new THREE.Scene();

  camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1000);
  camera.position.z = 400;
  scene.add(camera);

  circle = new THREE.Object3D();
  skelet = new THREE.Object3D();
  particle = new THREE.Object3D();

  // scene.add(circle);
  // scene.add(skelet);
  scene.add(particle);

  var geometry = new THREE.TetrahedronGeometry(2, 0);
  var geom = new THREE.IcosahedronGeometry(7, 1);
  var geom2 = new THREE.IcosahedronGeometry(10, 2);

  var material = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shading: THREE.FlatShading
  });

  for (var i = 0; i < 1000; i++) {
    var mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize();
    mesh.position.multiplyScalar(90 + (Math.random() * 700));
    mesh.rotation.set(Math.random() * 2, Math.random() * 2, Math.random() * 2);
    particle.add(mesh);
  }

  var mat = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    shading: THREE.FlatShading
  });

  var mat2 = new THREE.MeshPhongMaterial({
    color: 0xffffff,
    wireframe: true,
    side: THREE.DoubleSide,
  });

  var planet = new THREE.Mesh(geom, mat);
  planet.scale.x = planet.scale.y = planet.scale.z = 16;
  circle.add(planet);

  var planet2 = new THREE.Mesh(geom2, mat2);
  planet2.scale.x = planet2.scale.y = planet2.scale.z = 10;
  skelet.add(planet2);

  var ambientLight = new THREE.AmbientLight(0x8200C9 );
  scene.add(ambientLight);
  
  var lights = [];
lights[0] = new THREE.DirectionalLight( 0x8200C9, 1 );
lights[0].position.set( 1, 0, 0 );
lights[1] = new THREE.DirectionalLight( 0x11E8BB, 1 );
lights[1].position.set( 0.75, 1, 0.5 );
lights[2] = new THREE.DirectionalLight( 0x8200C9, 1 );
lights[2].position.set( -0.75, -1, 0.5 );
scene.add( lights[0] );
scene.add( lights[1] );
scene.add( lights[2] );
  

  window.addEventListener('resize', onWindowResize, false);

};

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

function animate() {
  requestAnimationFrame(animate);

  particle.rotation.x += 0.0000;
  particle.rotation.y -= 0.0040;
  circle.rotation.x -= 0.0020;
  circle.rotation.y -= 0.0030;
  skelet.rotation.x -= 0.0010;
  skelet.rotation.y += 0.0020;
  renderer.clear();

  renderer.render( scene, camera )
};

